// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T22:58:02.738Z
// Property: Sky on Main (ID: 6767906449167610)
// Collections: 75 amenities, 14 floorplans (live), 106 photos, 78 POIs, 4 reviews, 11 virtual tours, 6 office hours, 16 faqs
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162465",
  "multihub_property_id": "6767906449167610",
  "property_external_id": "1563664",
  "property_zillow_url": "https://www.zillow.com/b/sky-on-main-kansas-city-mo-5YCRCR/",
  "property_apartments_url": "https://www.apartments.com/sky-on-main-kansas-city-mo/v9ygsvg/",
  "property_google_business_url": "https://www.google.com/maps/place/Sky+On+Main+Apartment+Homes/@39.1026238,-94.5835039,1776m/data=!3m2!1e3!4b1!4m6!3m5!1s0x87c0f05e24203c99:0x2ca1605bc6c9ed05!8m2!3d39.1026238!4d-94.5835039!16s%2Fg%2F11bzrhq7v0?entry=ttu&g_ep=EgoyMDI2MDkxNi4wIKXMDSoASAFQAw%3D%3D",
  "property_linkedin_url": null,
  "property_hubspot_id": "39366991189",
  "property_crm_software": "RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": "1563664 p1532313",
  "property_status": null,
  "property_slug": "sky-on-main",
  "property_name": "Sky on Main",
  "property_website_url": "https://www.skyonmain.com/",
  "property_domain": "https://www.skyonmain.com/",
  "property_address": "920 Main St",
  "property_full_address": "920 Main St, Kansas City, MO 64105",
  "property_address_1": "920 Main St",
  "property_address_2": null,
  "property_address_city": "Kansas City",
  "property_address_state": "MO",
  "property_address_zip_full": null,
  "property_address_zip": "64105",
  "property_address_country": "US",
  "property_address_county": "Jackson County",
  "property_neighborhood_address": "Library District",
  "property_address_latitude": "39.1026296",
  "property_address_longitude": "-94.58342940000001",
  "property_email": "RentCafe.SM@PriceKC.com",
  "property_phone": "(816) 677-6335",
  "property_call_tracking_phone": "816-677-6335",
  "property_company_name": "Price Brothers",
  "property_company_url": "https://www.pricebrotherskc.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "<p><strong>Elevated downtown living in the Library District.</strong> Sky on Main pairs a reimagined historic high-rise with open one- and two-bedroom apartments, floor-to-ceiling windows, quartz islands, in-home laundry, and select skyline, river, and Power &amp; Light views.</p>",
  "property_long_description": "<p><strong>Elevated downtown living in the Library District.</strong> At Sky on Main, you get the energy of Main Street with the polish of a reimagined historic high-rise. One- and two-bedroom apartments, including den layouts, pair open interiors with floor-to-ceiling windows, soaring ceilings, quartz islands, stainless appliances, in-home laundry, Google Fiber, and select skyline, river, and Power &amp; Light views.</p><p>Outside your door, the Library streetcar stop connects you to River Market, City Market, Crossroads, Union Station, Crown Center, the Plaza, and UMKC, while Power &amp; Light, T-Mobile Center, the Kansas City Public Library, and downtown dining are close at hand. Back at home, <a href=\"/amenities\">Sky Vue Terrace</a>, the Sky Lounge Club Room, fitness center, indoor basketball court, co-working space, game room, yoga room, 24-hour lobby attendant, Bloom Bakery market, controlled access, gated garage parking, EV charging, package service, and <a href=\"/pet-policy\">pet-friendly living</a> bring convenience to every day. Explore <a href=\"/floor-plans\">spacious floor plans</a> built for life above the city.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b65f-de4a-761b-b860-f9edeb8fad0c.webp",
  "property_featured_image_media": {
    "alt_text": "Modern apartment kitchen with island and bar stools.",
    "public_id": "01a0b65f-de4a-761b-b860-f9edeb8fad0c",
    "storage_key": "property/6767906449167610/01a0b65f-de4a-761b-b860-f9edeb8fad0c.webp",
    "width": 1200,
    "height": 800
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "281",
  "property_year_built": "2016",
  "property_year_renovated": null,
  "property_walk_score": "94",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "90.0355871886121",
  "property_admin_fee": "300",
  "property_application_fee": "50",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Restrictions: Aggressive dog breeds including, but not limited to, Pit Bull, American Staffordshire Terrier, Rottweiler, German Shepherd, Malamute, Doberman Pinscher, Chow, Great Dane, Saint Bernard, Akita, Wolf Hybrid, and any mixed breed that includes the aforementioned, are specifically prohibited and Landlord has discretion to limit other breeds. Inherently dangerous or exotic, feral or wild animals are prohibited.",
  "property_pet_policy_description": "The non-refundable fee is $300 for 1 pet, and $500 for 2 pets.",
  "property_petpolicy_info": "https://www.pricebrotherskc.com/petroyaltyclub/",
  "property_online_leasing_url": "https://skyonmain.securecafeapplicant.com/onlineleasing/content3/access/sky-on-main/floorplans",
  "property_resident_portal_url": "https://skyonmain.securecafe.com/residentservices/sky-on-main/userlogin.aspx",
  "property_apply_now_url": "https://skyonmain.securecafeapplicant.com/onlineleasing/content3/access/sky-on-main/login",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc987-49ad-729e-9220-9c7af884b0c9.webp",
  "property_primary_logo_media": {
    "alt_text": "Sky on Main luxury apartments logo",
    "public_id": "019fc987-49ad-729e-9220-9c7af884b0c9",
    "storage_key": "property/6767906449167610/019fc987-49ad-729e-9220-9c7af884b0c9.webp",
    "width": 975,
    "height": 975
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc987-49ad-729e-9220-9c7af884b0c9.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Sky on Main luxury apartments logo",
    "public_id": "019fc987-49ad-729e-9220-9c7af884b0c9",
    "storage_key": "property/6767906449167610/019fc987-49ad-729e-9220-9c7af884b0c9.webp",
    "width": 975,
    "height": 975
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc98a-4f15-73d7-99c2-ea0f1ac343ef.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019fc98a-4f15-73d7-99c2-ea0f1ac343ef",
    "storage_key": "property/6767906449167610/019fc98a-4f15-73d7-99c2-ea0f1ac343ef.webp",
    "width": 975,
    "height": 975
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/01a0d9b7-62d2-753a-a137-bd690ff6733b.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/019ff682-589f-76db-bc7c-d7916fa7e182.webp",
  "property_company_logo_media": null,
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/019ff68a-de80-741a-9687-3e84c8c517e3.webp",
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/019ff682-589f-76db-bc7c-d7916fa7e182.webp",
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#000000",
  "property_secondary_color": "#FFFFFF",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "646 - 1148",
  "property_sqft_min": "646",
  "property_sqft_max": "1148",
  "property_price_range": "1375 - 2435",
  "property_price_min": "1375",
  "property_price_max": "2435",
  "property_available_units": 28,
  "property_facebook_url": "https://www.facebook.com/SkyOnMainKC",
  "property_instagram_url": "https://www.instagram.com/skyonmainkc/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJmTwgJF7wwIcRBe3JxltgoSw",
  "property_youtube_url": "https://www.youtube.com/user/Pricebrothersmgt",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Sky on Main",
  "property_home_romance_title": "Create Cherished Memories in Your Dream Apartment Home",
  "property_home_amenities_blurb": "<p>Some people move downtown for convenience. Others move for energy. At Sky on Main, you get both, plus a place that feels like it’s rooting for you. </p><p>Sky on Main brings modern living to one of downtown Kansas City's most recognizable historic buildings. You’re steps from the KC Streetcar, the Power &amp; Light District, and the city's best dining, entertainment, and cultural destinations. Our luxury one- and two-bedroom apartments feature vaulted ceilings, quartz countertops, premium stainless steel appliances, and skyline views that keep you connected to the city and pointed toward what’s next.</p>",
  "property_home_floorplans_blurb": "<p><strong>Floor plans with a downtown point of view.</strong> Choose from streamlined one-bedroom apartments, spacious two-bedroom, two-bath layouts, and select dens that add flexible square footage. Each residence pairs open quartz kitchens, premium stainless appliances, custom cabinetry, wide-plank flooring, and floor-to-ceiling windows with practical details like front-loading laundry, generous closets, roller shades, and select corner or view exposures.</p>",
  "property_home_gallery_blurb": "<p><strong>Preview Sky on Main in vivid detail.</strong> Get a glimpse of the historic high-rise exterior, sunlit apartments with floor-to-ceiling windows, quartz kitchens, wide-plank flooring, and skyline-framing views. Then picture the spaces beyond your door, from Sky Vue Terrace with fire-pit seating and grills to the Sky Lounge Club Room, co-working areas, fitness and yoga studios, game room, and indoor basketball court.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Downtown starts on Main Street.</strong> Step into the Library District with the Central Library’s Community Bookshelf, historic marble-and-brick blocks, and pocket parks moments from Sky on Main. Coffee, brunch, and dinner are close by at Banksia, Made in KC Café + Bar, and The Town Company—then the KC Streetcar connects the Riverfront, Crossroads, Plaza, UMKC, and more.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents love the smooth everyday experience.</strong> Reviews for Sky on Main highlight friendly, responsive service, prompt maintenance, and a clean, well-kept building in the heart of Main Street. The team—often mentioned by name—earns praise for helpful communication, while the modern apartments, impressive city views, great gym, and onsite security presence add to the appeal. See why one resident says, “I truly love living at Sky on Main!”</p>",
  "property_neighborhood_blurb": "<p><strong>Map your day from Main Street.</strong> From Sky on Main, the Library District puts Kansas City’s downtown texture within easy reach: the Central Library’s iconic Community Bookshelf, marble-and-brick historic blocks, and pocket greens like Oppenstein Brothers Memorial Park. Start close with espresso or brunch at Banksia Bistro or Made in KC Café + Bar, move into dinner at The Town Company, or follow the glow south toward Power &amp; Light.</p><p>When you want a change of scene, the Library KC Streetcar stop makes it simple to ride fare-free toward the Riverfront, Crossroads, Plaza, UMKC, and more. Explore the map, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how connected downtown living feels from Sky on Main.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>At Sky on Main, the amenities fit your day, from early workouts to late nights on the roof, and make it easy to get to know your neighbors.</p><p><br></p><p>Head up to the private Sky Vue Terrace for the rooftop grill, gaming area, and lounge, or unwind on the second-floor Sky Veranda with views of Downtown Kansas City. The Sky Lounge Club Room and game room are made for evenings with friends, and when work needs your attention, the co-working space gives you a quiet place to get it done without leaving the building.</p><p><br></p><p>The fitness center has free weights, a Peloton bike, and locker rooms with showers. You can also shoot around on the indoor basketball court or reset in the yoga and meditation room.</p><p><br></p><p>A 24-hour lobby attendant, package receiving, a 24-hour market by Bloom Bakery, dry cleaning drop-off, and a covered, gated garage with EV charging take care of the everyday.</p><p><br></p><p>Every one- and two-bedroom apartment includes wide-plank flooring, quartz countertops, stainless steel appliances, a full-size washer and dryer, and Google Fiber internet with speeds up to 2 Gig.</p><p><br></p><p>Browse the full list of community and apartment amenities below.</p>",
  "property_applynow_blurb": "<p><strong>Ready to rise above downtown?</strong> Start your online application for Sky on Main and take the next step toward a one- or two-bedroom apartment with open interiors, floor-to-ceiling windows, soaring ceilings, quartz islands, stainless appliances, in-home laundry, and the energy of Main Street just outside your door.</p>",
  "property_contactus_blurb": "<p><strong>Connect with Sky on Main.</strong> Have questions about elevated downtown living, available one- and two-bedroom layouts, or getting here in the Library District? Contact the leasing team for details, directions, and help planning your next step above Main Street.</p>",
  "property_faqs_blurb": "<p><strong>Questions about life above Main Street?</strong> Start here for quick answers about Sky on Main’s community, leasing details, apartment features, and everyday conveniences. If you don’t see what you need, the leasing team is happy to help you take the next step.</p>",
  "property_floorplans_blurb": "<p><strong>Choose the layout that fits how you live.</strong> Sky on Main offers streamlined one-bedroom homes, spacious two-bedroom, two-bath residences, and select den layouts that add a defined spot for an office, reading room, or extra storage. Inside, open kitchens with quartz countertops, premium stainless appliances, custom cabinetry, and wide-plank flooring flow into bright living areas framed by floor-to-ceiling windows and soaring ceilings. In-home front-loading laundry, generous closets, roller shades, and select corner or view exposures help each residence feel polished and practical. Compare current layouts, pricing, and availability, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see your favorite floor plan in person.</p>",
  "property_gallery_blurb": "<p>Sky on Main sits above the rhythm of Kansas City while keeping you close to everything happening below. When you arrive at our apartments in Downtown KC, you’ll notice it right away. The skyline opens up, downtown hums just beneath you, and the space feels made for enjoying, not just living in.</p><p><br></p><p>See Sky on Main from every angle. Our gallery takes you inside the apartments and shared spaces, giving you a closer look at our Kansas City high-rise apartments and the places where neighbors come together.</p><p><br></p><p>At our luxury apartments in KCMO, the details add up. Picture yourself cooking in a kitchen with quartz countertops and custom cabinetry, relaxing in a living space framed by expansive windows, or getting ready in a bathroom finished with porcelain tile. Then head up to the private rooftop Sky Vue Terrace, or relax in the Sky Lounge Club Room, game room, and fitness center.</p><p><br></p><p>The view is even better in person. Book a tour to see Sky on Main for yourself.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore Sky on Main from every angle.</strong> Use the interactive map to browse available <a href=\"/floor-plans\">one- and two-bedroom apartments</a>, see where the Library District puts you, and trace easy streetcar connections from Main Street to downtown dining, entertainment, and beyond.</p>",
  "property_pets_blurb": "<p><strong>Keep the leash by the door and the cat perch by the window.</strong> At Sky on Main, approved cats and dogs can settle into high-rise living with everyday conveniences made for pets—not just tolerated around them. Quick breaks are easier with an on-site pet relief area and indoor dog park, while wide-plank flooring, generous closets, and bright windows help your apartment feel simple to live in and easy to love.</p><p>For longer outings, downtown Kansas City offers nearby off-leash options and walkable blocks when fresh air is on the agenda. Need an extra hand? On-demand resident services through Spruce can help with dog walking and more. Explore more <a href=\"/amenities\">pet-friendly amenities</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how Sky on Main fits your routine.</p>",
  "property_referafriend_blurb": "<p><strong>Share life above the city.</strong> Love Sky on Main’s reimagined historic high-rise style, floor-to-ceiling windows, downtown energy, and everyday conveniences? Invite a friend to discover elevated Library District living—and use the referral form to help them take the next step.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at Sky on Main.</strong><br>Handle everyday home details with ease in your reimagined historic high-rise above Main Street. Pay rent, submit maintenance requests, and manage your account online—so you can get back to downtown living with floor-to-ceiling views and convenience close at hand.</p>",
  "property_reviews_blurb": "<p><strong>See what residents are saying.</strong> As you read through Sky on Main reviews, you’ll notice a few themes come up again and again: welcoming service, responsive maintenance, modern apartments, and a Main Street setting that keeps daily plans easy.</p><p>Residents frequently call out the team by name—Connie, Melissa, and Wendy—for being friendly, helpful, and “quick to respond.” They also praise the clean, well-kept building, great gym, prompt fixes, onsite security presence, and apartments with fresh finishes and impressive city views.</p><p>Most of all, reviews reflect a simple takeaway: life here feels smooth from move-in onward. As one resident put it, “I truly love living at Sky on Main!”</p>",
  "property_created_at": "1785792454072",
  "property_scheduletour_blurb": "<p><strong>See downtown from a higher point of view.</strong> Tour Sky on Main to experience open one- and two-bedroom layouts, floor-to-ceiling windows, soaring ceilings, quartz islands, and select skyline, river, and Power &amp; Light views in person. Schedule your visit and picture life above Main Street.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you — we received your inquiry.</strong><br>Our leasing team will follow up soon with details about Sky on Main, where elevated downtown living meets a reimagined historic high-rise with open one- and two-bedroom layouts, floor-to-ceiling windows, soaring ceilings, and everyday convenience above Main Street.</p>",
  "property_virtualtours_blurb": "<p><strong>Step inside before you stop by.</strong> Explore Sky on Main’s apartment virtual tours at your own pace, from one-bedroom layouts like A1, A2, A207, A208, A211, and A414 to two-bedroom options including B, B2, and B4. Each walkthrough helps you read the flow of the home—how the kitchen opens to the living area, where natural light lands, and how finishes like quartz countertops, stainless appliances, wide-plank flooring, and tall windows come together on screen.</p><p>If you want extra flexibility, take a closer look at B3 - Den and B5 - Den for a defined bonus space. Compare these tours with current <a href=\"/floor-plans\">floor plan details</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to experience your favorites in person.</p>",
  "property_copyright": "2026 All Rights Reserved. Sky on Main",
  "property_seo_title_home": "Sky on Main | Luxury Apartments Kansas City",
  "property_seo_description_home": "Sky on Main offers luxury 1 & 2-bedroom apartments in Kansas City with skyline views, a rooftop terrace, and more. Schedule a tour today.",
  "property_seo_title_floorplans": "Floor Plans | Downtown Kansas City Apartments",
  "property_seo_description_floorplans": "Compare 1 and 2 bedroom floor plans at Sky on Main, offering downtown Kansas City apartments with quartz kitchens and city views.",
  "property_seo_title_amenities": "Amenities | Luxury Apartments in Kansas City, MO",
  "property_seo_description_amenities": "Explore luxury apartments in Kansas City, MO at Sky on Main, with a rooftop terrace, fitness center, indoor basketball court, and co-working space.",
  "property_seo_title_gallery": "Gallery | Kansas City High Rise Apartments",
  "property_seo_description_gallery": "Browse photos of Sky on Main, a historic downtown high rise with modern interiors, skyline views, a rooftop terrace, and inviting lounge spaces.",
  "property_seo_title_virtualtours": "Virtual Tours | Luxury Apartments Kansas City",
  "property_seo_description_virtualtours": "Comparing the best Kansas City apartments? Take a virtual tour of Sky on Main to explore 1 and 2 bedroom homes and amenity spaces online anytime.",
  "property_seo_title_interactivemap": "Interactive Map | Sky on Main Apartments",
  "property_seo_description_interactivemap": "Find your urban oasis at Sky on Main in Kansas City! Use our interactive map to explore luxurious apartments, chic amenities, and vibrant community events.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Downtown Kansas City",
  "property_seo_description_neighborhood": "Sky on Main puts you in downtown Kansas City, steps from the KC Streetcar, Power & Light District, T-Mobile Center, and Crossroads Arts District.",
  "property_seo_title_contact": "Contact Us | Kansas City High Rise Apartments",
  "property_seo_description_contact": "Contact Sky on Main at 920 Main Street in downtown Kansas City. Call or send a message to ask about availability, tours, and leasing details.",
  "property_seo_title_faqs": "FAQs | Luxury Apartments Downtown Kansas City",
  "property_seo_description_faqs": "Find answers about applying, parking, pets, utilities, and more at Sky on Main, offering luxury apartments at 920 Main Street in Kansas City.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Kansas City, MO",
  "property_seo_description_reviews": "Join the vibrant Sky on Main community in Kansas City! Discover luxurious living, modern amenities, and resident reviews today!",
  "property_seo_title_applynow": "Apply Now | Apartments in Kansas City, MO",
  "property_seo_description_applynow": "Discover modern living at Sky on Main in Kansas City! Enjoy spacious layouts, great amenities, and vibrant events. Lease your new home today!",
  "property_seo_title_residentaccess": "Resident Access | Sky on Main",
  "property_seo_description_residentaccess": "Unlock convenience at Sky on Main! Log in to your resident portal for easy rent payments, maintenance requests, and community connections.",
  "property_seo_title_referafriend": "Refer A Friend | Sky on Main",
  "property_seo_description_referafriend": "Refer friends to Sky on Main in Kansas City and enjoy the perks of community living together! Great friends make great neighbors—join us today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Kansas City Luxury Apartments",
  "property_seo_description_scheduletour": "Tour Sky on Main, offering Kansas City luxury apartments at 920 Main Street. Book a guided tour or stop by for a self-guided tour to see the building.",
  "property_seo_title_privacy": "Privacy Policy | Sky on Main",
  "property_seo_description_privacy": "Your privacy matters at Sky on Main. Learn how we protect your information in our comprehensive policy for Kansas City residents. View our privacy practices.",
  "property_seo_title_accessibility": "Website Accessibility | Sky on Main",
  "property_seo_description_accessibility": "At Sky on Main in Kansas City, MO, we prioritize digital inclusion and accessibility for all. Your comfort and connection matter to us—learn more today!",
  "property_seo_title_sitemap": "Sitemap | Sky on Main",
  "property_seo_description_sitemap": "Navigate your journey at Sky on Main in Kansas City, MO. Check out our sitemap for a quick glance at community features, amenities, and everything we offer!",
  "property_seo_title_thankyou": "Thank You | Sky on Main",
  "property_seo_description_thankyou": "Thanks for reaching out to Sky on Main! Your journey to modern living in Kansas City begins here. Our team will be in touch soon to assist you!",
  "property_seo_title_pets": "Pet Friendly Apartments in Kansas City | Sky on Main",
  "property_seo_description_pets": "Explore pet friendly apartments in Kansas City at Sky on Main, with an on-site dog park. Review our full pet policy today.",
  "property_updated_at": "1793628812677",
  "amenities": [
    {
      "id": "ec_ac5005f49848acf21e66345b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "yardi",
      "external_id": "110965550",
      "title": "Co-Working Space",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "1",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b65f-ffeb-700a-a3a6-d7d069453847.webp",
      "amenity_image_media": {
        "alt_text": "Office with desk and chair, view into glass-enclosed meeting room.",
        "public_id": "01a0b65f-ffeb-700a-a3a6-d7d069453847",
        "storage_key": "property/6767906449167610/01a0b65f-ffeb-700a-a3a6-d7d069453847.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "A black chair sits in front of a white desk in a room with a glass wall.,A conference room with a glass table and chairs.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_352ae20250c6bc605e4e7137",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "yardi",
      "external_id": "110965607",
      "title": "Elevators",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "1",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b660-0000-726f-a9ed-ad542dc49efe.webp",
      "amenity_image_media": {
        "alt_text": "Elevator lobby with polished floors, wood paneling, and potted plants.",
        "public_id": "01a0b660-0000-726f-a9ed-ad542dc49efe",
        "storage_key": "property/6767906449167610/01a0b660-0000-726f-a9ed-ad542dc49efe.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Elevator lobby at Sky on Main with polished flooring, wood-paneled walls, decorative plants, and modern lighting.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6eaf4672373b639edc54c007",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "yardi",
      "external_id": "110965555",
      "title": "Dedicated KC Streetcar Stop",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "1",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b65f-f362-769b-b5bd-ecda6bbe770a.webp",
      "amenity_image_media": {
        "alt_text": "A modern light rail train at the River Market station.",
        "public_id": "01a0b65f-f362-769b-b5bd-ecda6bbe770a",
        "storage_key": "property/6767906449167610/01a0b65f-f362-769b-b5bd-ecda6bbe770a.webp",
        "width": 3072,
        "height": 2044
      },
      "amenity_image_alt_text": "A train at Sky On Main Apartments, Missouri City, MO",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c59fd0cb398d6b90739836c3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "yardi",
      "external_id": "110965564",
      "title": "Fitness Center",
      "amount": "false",
      "description": "Complete with locker rooms and showers for you and your guests!",
      "group": "Community",
      "is_featured": "1",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b660-011c-7569-8ee6-56e42f87e06d.webp",
      "amenity_image_media": {
        "alt_text": "Cybex weight machines and a basketball hoop in a modern fitness center",
        "public_id": "01a0b660-011c-7569-8ee6-56e42f87e06d",
        "storage_key": "property/6767906449167610/01a0b660-011c-7569-8ee6-56e42f87e06d.webp",
        "width": 1600,
        "height": 1067
      },
      "amenity_image_alt_text": ",,,a row of cardio machines at Sky On Main Apartments, Missouri City",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_abde9b398878461ba3831bf1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "yardi",
      "external_id": "111290589",
      "title": "24-Hour Lobby Attendant",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "1",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4cbb257d485cc5cc5f3b7547",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "yardi",
      "external_id": "110965563",
      "title": "Controlled Access to Community",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "1",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b231a42da328929920b1836e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "yardi",
      "external_id": "110965567",
      "title": "2nd Floor Sky Veranda",
      "amount": "false",
      "description": "Enjoy plush outdoor seating and views of the P&L District and downtown while entertaining",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b660-016d-731f-85c1-9541edc63ed6.webp",
      "amenity_image_media": {
        "alt_text": "Modern outdoor lounge area with grey sofas and yellow accents, overlooking city buildings.",
        "public_id": "01a0b660-016d-731f-85c1-9541edc63ed6",
        "storage_key": "property/6767906449167610/01a0b660-016d-731f-85c1-9541edc63ed6.webp",
        "width": 1600,
        "height": 1067
      },
      "amenity_image_alt_text": "Outdoor Terrace at Sky On Main Apartments, Missouri",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7cd0f8d8be4650f053da0e73",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "yardi",
      "external_id": "110965566",
      "title": "Free Weights",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b660-074e-708f-be20-b736fc854eba.webp",
      "amenity_image_media": {
        "alt_text": "Dumbbells on a rack in a gym",
        "public_id": "01a0b660-074e-708f-be20-b736fc854eba",
        "storage_key": "property/6767906449167610/01a0b660-074e-708f-be20-b736fc854eba.webp",
        "width": 1143,
        "height": 1600
      },
      "amenity_image_alt_text": "a row of dumbbells in a gym at Sky On Main Apartments, Missouri City 64105",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2393d97e501fc22aeed166bd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "yardi",
      "external_id": "110965562",
      "title": "Historic Building",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_df0635b9a38b8aefda598ff1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "yardi",
      "external_id": "110965558",
      "title": "Located by the Kansas City Public Library",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4692dfc029ebbde40908c9ba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "yardi",
      "external_id": "110965557",
      "title": "On-Site Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "1",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bf78eec45277ce9cd926090b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "yardi",
      "external_id": "110965556",
      "title": "On-Site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "1",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_161fa96bb4c999f8c955f5ec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "yardi",
      "external_id": "110965554",
      "title": "Package Receiving",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d4355459f5bb867ffef8a287",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "yardi",
      "external_id": "90480426",
      "title": "Indoor Basketball Court",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b660-287e-735b-a39b-5dd3b4a92c22.webp",
      "amenity_image_media": {
        "alt_text": "Basketball court and fitness center with weight machines.",
        "public_id": "01a0b660-287e-735b-a39b-5dd3b4a92c22",
        "storage_key": "property/6767906449167610/01a0b660-287e-735b-a39b-5dd3b4a92c22.webp",
        "width": 1600,
        "height": 1067
      },
      "amenity_image_alt_text": "a basketball court at Sky On Main Apartments, Missouri, 64105",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_273be5587046789628d360c1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "yardi",
      "external_id": "110965559",
      "title": "High Speed Internet",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a56751d8de71d71b310a77f9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "yardi",
      "external_id": "90481887",
      "title": "Covered and Gated Garage Parking*",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "1",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b660-0da5-7368-a8aa-8bdaca2e30ba.webp",
      "amenity_image_media": {
        "alt_text": "Exterior view of a multi-level parking garage in an urban setting.",
        "public_id": "01a0b660-0da5-7368-a8aa-8bdaca2e30ba",
        "storage_key": "property/6767906449167610/01a0b660-0da5-7368-a8aa-8bdaca2e30ba.webp",
        "width": 1200,
        "height": 900
      },
      "amenity_image_alt_text": "a large building on the corner of a city street at Sky On Main Apartments, Missouri City",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e6093a0925dd675d58774def",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "yardi",
      "external_id": "122195421",
      "title": "Dog Park",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "1",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b660-12e3-7570-8a14-3afa4c03000c.webp",
      "amenity_image_media": {
        "alt_text": "Fenced dog park with artificial turf and overhead structure",
        "public_id": "01a0b660-12e3-7570-8a14-3afa4c03000c",
        "storage_key": "property/6767906449167610/01a0b660-12e3-7570-8a14-3afa4c03000c.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Spacious indoor dog park at Sky on Main featuring artificial grass, secure fencing, and room for pets to exercise.,Indoor pet relief area at Sky on Main with artificial turf, enclosed fencing, and designated space for resident dogs.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_15998a2aa998aac6084fd7e1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "yardi",
      "external_id": "110966114",
      "title": "Power & Light District Nearby",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b660-2d6d-706e-b6ee-bbbcf157364d.webp",
      "amenity_image_media": {
        "alt_text": "Kansas City Power & Light building exterior signage",
        "public_id": "01a0b660-2d6d-706e-b6ee-bbbcf157364d",
        "storage_key": "property/6767906449167610/01a0b660-2d6d-706e-b6ee-bbbcf157364d.webp",
        "width": 3072,
        "height": 1944
      },
      "amenity_image_alt_text": "A large blue sign with the words  at Sky On Main Apartments, Missouri City, MO,View at Sky On Main Apartments, Missouri City 64105",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b0b3c1500c753d4a0ebb6752",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "yardi",
      "external_id": "90481891",
      "title": "Dry Cleaning Drop Off & Delivery",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_43122cbc843f3c4038761a4a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "yardi",
      "external_id": "120591703",
      "title": "Guest Suite & Short-Term Rental Available",
      "amount": "false",
      "description": "Call for Availability and Pricing. Take a tour of this unit layout on our Virtual Tours Page.",
      "group": "Community",
      "is_featured": "1",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b660-12c1-7294-9491-7c75496b1975.webp",
      "amenity_image_media": {
        "alt_text": "Modern open-plan kitchen and dining area with a large wooden table and stainless steel appliances.",
        "public_id": "01a0b660-12c1-7294-9491-7c75496b1975",
        "storage_key": "property/6767906449167610/01a0b660-12c1-7294-9491-7c75496b1975.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Modern kitchen and dining area in a furnished short-term rental apartment at Sky on Main featuring stainless steel appliances, contemporary lighting, and a large dining table.,Fully furnished bedroom in a short-term rental apartment at Sky on Main featuring a queen bed, bedside tables, modern artwork, and high ceilings.,Furnished bedroom in a short-term rental apartment at Sky on Main featuring a bed, wall-mounted television, full-length mirror, and modern finishes.,Spacious primary bedroom in a furnished short-term rental apartment at Sky on Main with a wall-mounted television, modern furnishings, and hardwood-style flooring.,Furnished bedroom in a short-term rental apartment at Sky on Main featuring a king-size bed, contemporary décor, bedside tables, and modern artwork.,Modern bathroom in a furnished short-term rental apartment at Sky on Main with a large vanity, glass-enclosed tub and shower, and blue mosaic tile accents.,Open-concept kitchen, dining, and living space in a furnished short-term rental apartment at Sky on Main with modern finishes and Downtown Kansas City views.,Spacious living room in a furnished short-term rental apartment at Sky on Main with leather seating, accent chairs, contemporary furnishings, and city views.,Fully equipped kitchen in a furnished short-term rental apartment at Sky on Main with white cabinetry, stainless steel appliances, pendant lighting, and a large island.,Open-concept furnished short-term rental apartment at Sky on Main featuring a dining table, living room seating, large windows, and views of Downtown Kansas City.,Modern bathroom vanity area in a short-term rental apartment at Sky on Main with stylish fixtures, storage cabinetry, and fresh linens.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_13ae7452c9c513915c8da570",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "yardi",
      "external_id": "90480436",
      "title": "Game Room",
      "amount": "false",
      "description": "Pool Table, Air Hockey, Arcade Games, Board Games, and More",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b660-168d-7025-9dca-28768259af95.webp",
      "amenity_image_media": {
        "alt_text": "Air hockey table and foosball table in game room",
        "public_id": "01a0b660-168d-7025-9dca-28768259af95",
        "storage_key": "property/6767906449167610/01a0b660-168d-7025-9dca-28768259af95.webp",
        "width": 1600,
        "height": 1067
      },
      "amenity_image_alt_text": ",Multi-purpose resident entertainment space at Sky on Main featuring foosball, air hockey, shuffleboard, lounge seating, and social gathering areas.,Resident club room at Sky on Main featuring shuffleboard, air hockey, foosball, and entertainment space for residents.,Resident game room at Sky on Main featuring a pool table, modern décor, and access to adjacent community spaces.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1ec722bd767ac5ce59ab9f31",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "yardi",
      "external_id": "90480445",
      "title": "Sky Vue Terrace",
      "amount": "false",
      "description": "Rooftop Grill, Gaming Area & Lounge",
      "group": "Community",
      "is_featured": "1",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b660-1c5b-711e-8d0c-74474b0c4540.webp",
      "amenity_image_media": {
        "alt_text": "Rooftop lounge area with modern seating and a fire pit, overlooking city buildings.",
        "public_id": "01a0b660-1c5b-711e-8d0c-74474b0c4540",
        "storage_key": "property/6767906449167610/01a0b660-1c5b-711e-8d0c-74474b0c4540.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Rooftop lounge at Sky on Main with outdoor seating arranged around a fire pit and views of Downtown Kansas City.,Rooftop terrace at Sky on Main featuring lounge chairs, dining areas, and panoramic views of Downtown Kansas City.,Rooftop gathering space at Sky on Main featuring modern lounge furniture, fire pit seating, and skyline views.,Outdoor grilling station on the rooftop terrace at Sky on Main with seating areas, counter space, and landscaped planters.,Rooftop pergola lounge at Sky on Main featuring cushioned seating, landscaped planters, and outdoor social space.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_86855f4bc0f3e38ca798a7ff",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "yardi",
      "external_id": "90481893",
      "title": "24-Hour Market by Bloom Bakery",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b660-1e0b-745b-b012-7d0414a303eb.webp",
      "amenity_image_media": {
        "alt_text": "Vending machines and coffee station in apartment building.",
        "public_id": "01a0b660-1e0b-745b-b012-7d0414a303eb",
        "storage_key": "property/6767906449167610/01a0b660-1e0b-745b-b012-7d0414a303eb.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Self-service micro market at Sky on Main with vending machines offering snacks, beverages, and convenience items for residents.,Self-service micro market at Sky on Main with vending machines offering snacks, beverages, and convenience items for residents.,On-site micro market at Sky on Main featuring beverage vending machines, grab-and-go snacks, an ATM, and coffee service.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a0ea0010b7b46b36d65fa96a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "yardi",
      "external_id": "90481903",
      "title": "Pet Friendly",
      "amount": "false",
      "description": "Price Brothers Pet Royalty Program",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7a16364071a31efd63260b84",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "yardi",
      "external_id": "110965645",
      "title": "Sky Lounge Club Room",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b660-252e-7221-abdf-c21fe882c81b.webp",
      "amenity_image_media": {
        "alt_text": "Modern coffee bar with white countertops, wooden cabinets, a coffee maker, and a variety of coffee pods and cups.",
        "public_id": "01a0b660-252e-7221-abdf-c21fe882c81b",
        "storage_key": "property/6767906449167610/01a0b660-252e-7221-abdf-c21fe882c81b.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Resident coffee bar at Sky on Main featuring complimentary coffee service, modern cabinetry, countertop seating, and stainless steel appliances.,Club room kitchenette at Sky on Main featuring a catering kitchen, bar-height seating, beverage station, and entertainment area.,Comfortable resident lounge at Sky on Main with sectional seating, modern lighting, wall-mounted televisions, and gathering space.,Resident lounge at Sky on Main in Downtown Kansas City featuring communal tables, bar seating, pendant lighting, and workspace areas.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_520f940cca2c4f5fc0a34b28",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "yardi",
      "external_id": "110965609",
      "title": "Planned Social Events",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3cef43982be8ae4e08cefbf8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "yardi",
      "external_id": "110965615",
      "title": "Yoga and Meditation Room",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b660-25a8-72c9-abb1-8a85161219be.webp",
      "amenity_image_media": {
        "alt_text": "Interior view of a gym with large mirrors, exercise equipment, and yoga balls.",
        "public_id": "01a0b660-25a8-72c9-abb1-8a85161219be",
        "storage_key": "property/6767906449167610/01a0b660-25a8-72c9-abb1-8a85161219be.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Fitness and yoga studio at Sky on Main with open workout space, mirrored walls, exercise accessories, and modern industrial design.,Bright yoga studio at Sky on Main featuring floor-to-ceiling windows, mirrored walls, wellness equipment, and views of Downtown Kansas City.,Yoga and fitness studio at Sky on Main with mirrored walls, fitness equipment, high ceilings, and dedicated exercise space.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_49caa03cf98a7e924913922c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "yardi",
      "external_id": "110965616",
      "title": "Peloton Bike",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b660-27b3-76ab-a0c2-4e896662bc8b.webp",
      "amenity_image_media": {
        "alt_text": "Treadmills and stair climber in a modern fitness center with large windows.",
        "public_id": "01a0b660-27b3-76ab-a0c2-4e896662bc8b",
        "storage_key": "property/6767906449167610/01a0b660-27b3-76ab-a0c2-4e896662bc8b.webp",
        "width": 1600,
        "height": 1067
      },
      "amenity_image_alt_text": "a row of exercise bikes in a gym at Sky On Main Apartments, Missouri, 64105",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f34e14f581a82e775da0750e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "yardi",
      "external_id": "110965643",
      "title": "Renter's Insurance Program",
      "amount": "false",
      "description": "Quick, easy and affordable coverage.",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8e4ce01467121e4633bc3341",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "yardi",
      "external_id": "121132451",
      "title": "Online Residents Center with Bill Pay, Service Request and Community Calendar",
      "amount": "false",
      "description": "eChecks, Credit and Debit Card Payment Accepted",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b1cb714296f86c27d37d2bc0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "yardi",
      "external_id": "120553404",
      "title": "On-Demand Resident Services Offered By Spruce*",
      "amount": "false",
      "description": "Chores, Cleaning, Dog Walking, Meal Delivery, and More are Available via Spruce App",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_481cce8c02c13d45bfe54bbe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "yardi",
      "external_id": "119505633",
      "title": "Energy Star Rated Historic Building",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_43b01e4250ffae73505578fa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "yardi",
      "external_id": "120553400",
      "title": "Guest and Public Parking Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c18b170fb48e12ef99cb6aa9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "yardi",
      "external_id": "120553408",
      "title": "Loading Dock and Freight Elevator Access",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5a9b3455a3fbc2d024a0f96e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "yardi",
      "external_id": "122755394",
      "title": "Flexible Rent Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bdc3b023160378f7f69c0bec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "yardi",
      "external_id": "120607515",
      "title": "Prime Retail & Restaurant Space Available",
      "amount": "false",
      "description": "Contact AREA For More Information 816-895-4800",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8adf3476b2530b4aec6cb5b4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "yardi",
      "external_id": "121610889",
      "title": "On-Site ATM",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b660-31f8-72ef-9af4-702adaee253d.webp",
      "amenity_image_media": {
        "alt_text": "ATM and vending machines in a common area with a small kitchen.",
        "public_id": "01a0b660-31f8-72ef-9af4-702adaee253d",
        "storage_key": "property/6767906449167610/01a0b660-31f8-72ef-9af4-702adaee253d.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Self-service micro market at Sky on Main with vending machines offering snacks, beverages, and convenience items for residents.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_776cd33f26587afa0bde937e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "yardi",
      "external_id": "110965603",
      "title": "Kansas City Skyline, Power & Light, and River Views",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1af55fc2054b4ba61725948e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "yardi",
      "external_id": "110965584",
      "title": "In-Home Front Loading Washer & Dryer",
      "amount": "false",
      "description": "Full Size",
      "group": "Apartment",
      "is_featured": "1",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b660-3259-71aa-921a-7e1824c384ec.webp",
      "amenity_image_media": {
        "alt_text": "Stackable Bosch washer and dryer in a laundry closet next to a stainless steel refrigerator.",
        "public_id": "01a0b660-3259-71aa-921a-7e1824c384ec",
        "storage_key": "property/6767906449167610/01a0b660-3259-71aa-921a-7e1824c384ec.webp",
        "width": 1600,
        "height": 1143
      },
      "amenity_image_alt_text": "a small laundry room at Sky On Main Apartments, Missouri City, MO",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_43a5e1dd571560649a481536",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "yardi",
      "external_id": "110965583",
      "title": "French-Door GE Refrigerator*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e6788bb3e94c09566ee6abae",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "yardi",
      "external_id": "110965582",
      "title": "Stainless LG Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b660-4dfa-758e-b92c-47ffa8dfd39b.webp",
      "amenity_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, subway tile backsplash, and a large island sink.",
        "public_id": "01a0b660-4dfa-758e-b92c-47ffa8dfd39b",
        "storage_key": "property/6767906449167610/01a0b660-4dfa-758e-b92c-47ffa8dfd39b.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "a white kitchen with stainless steel appliances and a sink at Sky On Main Apartments, Missouri City 64105",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9e160a9aef8b1d5a7932ec78",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "yardi",
      "external_id": "110965581",
      "title": "Large Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "1",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b660-3b72-720e-9852-d5cde411d416.webp",
      "amenity_image_media": {
        "alt_text": "Bedroom with two closets and a glimpse of a tiled bathroom.",
        "public_id": "01a0b660-3b72-720e-9852-d5cde411d416",
        "storage_key": "property/6767906449167610/01a0b660-3b72-720e-9852-d5cde411d416.webp",
        "width": 1600,
        "height": 1143
      },
      "amenity_image_alt_text": "Bedroom with window at Sky On Main Apartments, Missouri City, Missouri",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_82e52674c65ba625b7099106",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "yardi",
      "external_id": "110965579",
      "title": "Wide Plank Luxury LVT Flooring Throughout",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "1",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b660-3da8-779e-9adc-d15de5edb950.webp",
      "amenity_image_media": {
        "alt_text": "Modern kitchen with island and city views",
        "public_id": "01a0b660-3da8-779e-9adc-d15de5edb950",
        "storage_key": "property/6767906449167610/01a0b660-3da8-779e-9adc-d15de5edb950.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "A modern kitchen with wooden cabinets and a large island at Sky On Main Apartments, Missouri City, MO",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3475d2c54c8f5380ac9c1374",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "yardi",
      "external_id": "110965578",
      "title": "Additional Storage Available",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f3509a839eadc37eef291542",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "yardi",
      "external_id": "110965574",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "1",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3b922ce974f1c68e7c5a222d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "yardi",
      "external_id": "110965573",
      "title": "Ceiling Fans*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b660-3ff5-75d7-a1f3-7c0c0653c949.webp",
      "amenity_image_media": {
        "alt_text": "Empty room with two windows and a ceiling fan.",
        "public_id": "01a0b660-3ff5-75d7-a1f3-7c0c0653c949",
        "storage_key": "property/6767906449167610/01a0b660-3ff5-75d7-a1f3-7c0c0653c949.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "an empty living room with a window and a ceiling fan at Sky On Main Apartments, Missouri City, Missouri",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1edbc2724835f73934509a44",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "yardi",
      "external_id": "110965571",
      "title": "Cable Ready*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f7b1de0b001d408005613efd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "yardi",
      "external_id": "119505641",
      "title": "Soaring 12+ Ft. Ceilings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_912f1eea3badf6cf05a0fbe7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "yardi",
      "external_id": "110965569",
      "title": "Air Conditioner",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "1",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fb47c01cac675834da72cf2b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "yardi",
      "external_id": "110965575",
      "title": "Garbage Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8c980fbaac550813167b063e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "yardi",
      "external_id": "121523135",
      "title": "Furnished*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2095032dfdae6bfba794b822",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "yardi",
      "external_id": "110965577",
      "title": "Electronic Programmable Thermostat",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3664fb1b8743c120063a40d3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "yardi",
      "external_id": "90481886",
      "title": "Google Fiber High-Speed Internet",
      "amount": "false",
      "description": "Get Speeds of up to 2 Gig per Second",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2a1aa0a9ef7df2db0dda0888",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "yardi",
      "external_id": "90481881",
      "title": "Premium Stainless Steel GE Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b660-5e66-77ed-8fd2-2be50ddf1915.webp",
      "amenity_image_media": {
        "alt_text": "Modern kitchen with island, stainless steel appliances, and decorative 'EAT' sign.",
        "public_id": "01a0b660-5e66-77ed-8fd2-2be50ddf1915",
        "storage_key": "property/6767906449167610/01a0b660-5e66-77ed-8fd2-2be50ddf1915.webp",
        "width": 1600,
        "height": 1143
      },
      "amenity_image_alt_text": "kitchen with an eat sign on the wall at Sky On Main Apartments, Missouri City, MO, 64105",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0438ce31be380db968e4735d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "yardi",
      "external_id": "90481882",
      "title": "Quartz Countertops and Islands",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b1496d81230f4cc5516a3442",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "yardi",
      "external_id": "121985529",
      "title": "USB Outlets*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0d0dda5ab2901fa7b5f336b1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "yardi",
      "external_id": "90481878",
      "title": "Open-Layout Floor Plans",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8b91ea9d1e0adb581e93e7ad",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "yardi",
      "external_id": "90481879",
      "title": "High Ceilings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6e54ad6a764b10a577abaf39",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "yardi",
      "external_id": "90481884",
      "title": "Wall-Mounted TV Outlets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_168d0fc4e206e310d3dd9103",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "yardi",
      "external_id": "90481885",
      "title": "Porcelain Tile in Bathrooms with Custom Backsplashes",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b660-5f39-72f7-a537-72817b727664.webp",
      "amenity_image_media": {
        "alt_text": "Modern bathroom with a walk-in shower with blue tile and a white vanity with a sink.",
        "public_id": "01a0b660-5f39-72f7-a537-72817b727664",
        "storage_key": "property/6767906449167610/01a0b660-5f39-72f7-a537-72817b727664.webp",
        "width": 1143,
        "height": 1600
      },
      "amenity_image_alt_text": "a bathroom with white cabinets and a blue and white tiled wall at Sky On Main Apartments, Missouri City, MO, 64105",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4e0ccbffca6e7c90c1f11a50",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "yardi",
      "external_id": "110966136",
      "title": "Flat Rate Utilities",
      "amount": "false",
      "description": "Includes Electric, Internet, Water, Sewer, Trash, & Pest Control Services. $170 for all one bedrooms. $215 for all two bedrooms.",
      "group": "Apartment",
      "is_featured": "1",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_38339cce6a0c66af1a469949",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "yardi",
      "external_id": "121985527",
      "title": "Smart Lock*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b660-4c2a-7379-8d3c-6a3fccc3b936.webp",
      "amenity_image_media": {
        "alt_text": "Smart lock and door handle on apartment door",
        "public_id": "01a0b660-4c2a-7379-8d3c-6a3fccc3b936",
        "storage_key": "property/6767906449167610/01a0b660-4c2a-7379-8d3c-6a3fccc3b936.webp",
        "width": 1200,
        "height": 801
      },
      "amenity_image_alt_text": "an iphone on a white door with a door handle at Sky On Main Apartments, Missouri",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1a2781f49998c23bf93bdb99",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "yardi",
      "external_id": "110965618",
      "title": "Modern Kitchens with Quartz Countertops",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b660-5e66-77ed-8fd2-2be50ddf1915.webp",
      "amenity_image_media": {
        "alt_text": "Modern kitchen with island, stainless steel appliances, and decorative 'EAT' sign.",
        "public_id": "01a0b660-5e66-77ed-8fd2-2be50ddf1915",
        "storage_key": "property/6767906449167610/01a0b660-5e66-77ed-8fd2-2be50ddf1915.webp",
        "width": 1600,
        "height": 1143
      },
      "amenity_image_alt_text": "a kitchen with an eat sign on the wall at Sky On Main Apartments, Missouri City 64105",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5941937e88381020858f165f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "yardi",
      "external_id": "110965657",
      "title": "Custom Light Fixtures and Lighting",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b660-5427-74cb-a7d9-641ce9fb6e3c.webp",
      "amenity_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and an island with two bar stools.",
        "public_id": "01a0b660-5427-74cb-a7d9-641ce9fb6e3c",
        "storage_key": "property/6767906449167610/01a0b660-5427-74cb-a7d9-641ce9fb6e3c.webp",
        "width": 3072,
        "height": 2049
      },
      "amenity_image_alt_text": "Kitchen view at Sky On Main Apartments, Missouri City, Missouri,a closer look at the pendants in the kitchen at Sky On Main Apartments, Missouri City, Missouri",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_63dbbbeae0a591774b1ee517",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "yardi",
      "external_id": "110965752",
      "title": "Open Concept Floorplans",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1a7b11e15d59bff7b439bf9a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "yardi",
      "external_id": "120607617",
      "title": "Allergen Friendly Design",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_56f21ae953ffd17493da24da",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "yardi",
      "external_id": "121132448",
      "title": "Custom Crafted Modern Cabinetry",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b660-545c-7008-88fe-9c23066dff79.webp",
      "amenity_image_media": {
        "alt_text": "Modern kitchen with white island, stainless steel appliances, and city view.",
        "public_id": "01a0b660-545c-7008-88fe-9c23066dff79",
        "storage_key": "property/6767906449167610/01a0b660-545c-7008-88fe-9c23066dff79.webp",
        "width": 1920,
        "height": 937
      },
      "amenity_image_alt_text": "a kitchen with white walls and a wooden floor at Sky On Main Apartments, Missouri City",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b87bcc676315e878be62044a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "yardi",
      "external_id": "121132464",
      "title": "Tub with Frameless Glass Shower Door*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b660-5daf-7568-ad48-6e0b65d6d9ee.webp",
      "amenity_image_media": {
        "alt_text": "Modern bathroom with tiled shower and bathtub.",
        "public_id": "01a0b660-5daf-7568-ad48-6e0b65d6d9ee",
        "storage_key": "property/6767906449167610/01a0b660-5daf-7568-ad48-6e0b65d6d9ee.webp",
        "width": 1600,
        "height": 1143
      },
      "amenity_image_alt_text": "A shower with a blue tile wall and a white tub at Sky On Main Apartments, Missouri",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5db6761a8033549c323506fa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "yardi",
      "external_id": "121132485",
      "title": "Modern Hardware & Lighting",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f5294787421e85008270c85a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "yardi",
      "external_id": "121319713",
      "title": "Adjustable Shower Head and Rain Shower*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b660-75b8-701c-a911-fd73984a8e9f.webp",
      "amenity_image_media": {
        "alt_text": "Modern bathroom with a walk-in shower with blue mosaic tile, a white vanity, and a white toilet.",
        "public_id": "01a0b660-75b8-701c-a911-fd73984a8e9f",
        "storage_key": "property/6767906449167610/01a0b660-75b8-701c-a911-fd73984a8e9f.webp",
        "width": 1143,
        "height": 1600
      },
      "amenity_image_alt_text": "A bathroom with a white counter top and a towel hanging on the wall at Sky On Main Apartments, Missouri, 64105",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1f5219d056298a5018adf2a6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "yardi",
      "external_id": "121319776",
      "title": "Separate Office or Den w/ Closet*",
      "amount": "false",
      "description": "*in our B3 and B5 Floor Plans",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b660-7d44-7686-95ac-b538de3d0448.webp",
      "amenity_image_media": {
        "alt_text": "Desk and chair in a well-lit room with four floral art prints on the wall.",
        "public_id": "01a0b660-7d44-7686-95ac-b538de3d0448",
        "storage_key": "property/6767906449167610/01a0b660-7d44-7686-95ac-b538de3d0448.webp",
        "width": 2000,
        "height": 1334
      },
      "amenity_image_alt_text": "A white chair sits in front of a desk with a lamp on it at Sky On Main Apartments, Missouri City, MO, 64105",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e64c2bae8f43dbffb05c4f76",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "yardi",
      "external_id": "121642650",
      "title": "Main Street- Southern View",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_43fcdc473aba5def78ffaacf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "yardi",
      "external_id": "121855201",
      "title": "Built-in Desk*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_02d488f1814f290ce4c70531",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "yardi",
      "external_id": "121985600",
      "title": "Waterfall Kitchen Island*",
      "amount": "false",
      "description": "*Available in the A1 apartments in Phase One",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b660-6d3f-718c-8ff7-fbf913853955.webp",
      "amenity_image_media": {
        "alt_text": "Living room and dining area with white island, modern furniture, and a view of the bathroom.",
        "public_id": "01a0b660-6d3f-718c-8ff7-fbf913853955",
        "storage_key": "property/6767906449167610/01a0b660-6d3f-718c-8ff7-fbf913853955.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "a living room and dining room with a table and chairs at Sky On Main Apartments, Missouri, 64105",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7aa30c10e681134fe5faf09b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "yardi",
      "external_id": "122928243",
      "title": "Roller Shade Blinds",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_85707baaa3458c8cadee3be7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b65f-de4a-761b-b860-f9edeb8fad0c.webp",
      "image_media": {
        "alt_text": "Modern apartment kitchen with island and bar stools.",
        "public_id": "01a0b65f-de4a-761b-b860-f9edeb8fad0c",
        "storage_key": "property/6767906449167610/01a0b65f-de4a-761b-b860-f9edeb8fad0c.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "A sleek and modern apartment kitchen featuring a large island with bar stools, stainless steel appliances, and ample cabinet space.",
      "link": "false",
      "alt_text": "Modern apartment kitchen with island and bar stools.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Kitchen Phase 2(1).jpg"
    },
    {
      "id": "ec_6d73ea3e026437f29f7c763d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b660-899c-72ca-ac81-dad3e30c2e29.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and open living area.",
        "public_id": "01a0b660-899c-72ca-ac81-dad3e30c2e29",
        "storage_key": "property/6767906449167610/01a0b660-899c-72ca-ac81-dad3e30c2e29.webp",
        "width": 1600,
        "height": 1200
      },
      "title": "Apartment",
      "description": "Sleek, modern kitchen featuring stainless steel appliances, ample counter space, and a seamless flow into the open-plan living area.",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel appliances and open living area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/01-920 Main St 245-1.jpg"
    },
    {
      "id": "ec_0021f24b00f5e526e39e8b76",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b660-9207-762e-8c7a-d292d722cb7f.webp",
      "image_media": {
        "alt_text": "Dining area and kitchen with stainless steel appliances and island.",
        "public_id": "01a0b660-9207-762e-8c7a-d292d722cb7f",
        "storage_key": "property/6767906449167610/01a0b660-9207-762e-8c7a-d292d722cb7f.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "Elegant dining room with a marble-top table, plush chairs, and a modern kitchen with an island, stainless steel appliances, and ample cabinetry.",
      "link": "false",
      "alt_text": "Dining area and kitchen with stainless steel appliances and island.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Sky on Main - 28_final(1).jpg"
    },
    {
      "id": "ec_3bed10695bea33ed8f7b8a97",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b660-89c9-7352-ac0f-b48a44b61d7e.webp",
      "image_media": {
        "alt_text": "Bedroom with a large bed, windows with city views, and modern decor.",
        "public_id": "01a0b660-89c9-7352-ac0f-b48a44b61d7e",
        "storage_key": "property/6767906449167610/01a0b660-89c9-7352-ac0f-b48a44b61d7e.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this beautifully appointed bedroom, featuring a plush bed, large windows with panoramic city views, and elegant furnishings.",
      "link": "false",
      "alt_text": "Bedroom with a large bed, windows with city views, and modern decor.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Sky on Main - 19 - Staged.jpg"
    },
    {
      "id": "ec_d5289457eb8223a3b007ccf4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b660-8a43-7459-b4d8-ce4d04bbb64e.webp",
      "image_media": {
        "alt_text": "Modern living room with beige sofa, accent chair, coffee table, and large windows with city view.",
        "public_id": "01a0b660-8a43-7459-b4d8-ce4d04bbb64e",
        "storage_key": "property/6767906449167610/01a0b660-8a43-7459-b4d8-ce4d04bbb64e.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Spacious and elegantly furnished living room featuring a comfortable beige sofa, a stylish accent chair, and a modern coffee table. Large windows offer stunning city views, creating a bright and airy atmosphere.",
      "link": "false",
      "alt_text": "Modern living room with beige sofa, accent chair, coffee table, and large windows with city view.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Sky on Main - 08 - Staged.jpg"
    },
    {
      "id": "ec_21c283480ba9268e2797ecdb",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b660-a47d-7398-acf6-c6cb2c8a0ad4.webp",
      "image_media": {
        "alt_text": "Modern bathroom with double vanity, walk-in closet, and a shower.",
        "public_id": "01a0b660-a47d-7398-acf6-c6cb2c8a0ad4",
        "storage_key": "property/6767906449167610/01a0b660-a47d-7398-acf6-c6cb2c8a0ad4.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Spacious and modern bathroom featuring a double vanity with sleek faucets, a walk-in closet with ample storage, and a private shower area.",
      "link": "false",
      "alt_text": "Modern bathroom with double vanity, walk-in closet, and a shower.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Sky on Main - 18 - Staged.jpg"
    },
    {
      "id": "ec_f92496771bb78c856dc6eb27",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b660-9b20-7762-9cb4-c047297fb7f8.webp",
      "image_media": {
        "alt_text": "Rooftop lounge area with artificial turf, lounge seating, and tables under a covered patio.",
        "public_id": "01a0b660-9b20-7762-9cb4-c047297fb7f8",
        "storage_key": "property/6767906449167610/01a0b660-9b20-7762-9cb4-c047297fb7f8.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish rooftop lounge, complete with comfortable seating and scenic city views.",
      "link": "false",
      "alt_text": "Rooftop lounge area with artificial turf, lounge seating, and tables under a covered patio.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Sky-on-Main-031_Photo_Rooftop-Lounge_2026-07-30_MLS-Size (9).jpg"
    },
    {
      "id": "ec_9327385b399bc76b8e075a1a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b660-9bd6-739a-9d43-c07e92ae85c6.webp",
      "image_media": {
        "alt_text": "Rooftop lounge area with a fire pit and city views.",
        "public_id": "01a0b660-9bd6-739a-9d43-c07e92ae85c6",
        "storage_key": "property/6767906449167610/01a0b660-9bd6-739a-9d43-c07e92ae85c6.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Enjoy the urban oasis with our rooftop lounge, featuring a modern fire pit and comfortable seating, perfect for relaxing evenings with stunning city views.",
      "link": "false",
      "alt_text": "Rooftop lounge area with a fire pit and city views.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Sky-on-Main-031_Photo_Rooftop-Lounge_2026-07-30_MLS-Size (6).jpg"
    },
    {
      "id": "ec_8afb145ad5aa70392194ad53",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b660-9e14-73d5-a2ec-dd6df700275f.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with sofas and a coffee table on artificial grass under a covered patio.",
        "public_id": "01a0b660-9e14-73d5-a2ec-dd6df700275f",
        "storage_key": "property/6767906449167610/01a0b660-9e14-73d5-a2ec-dd6df700275f.webp",
        "width": 1200,
        "height": 801
      },
      "title": "Community",
      "description": "Enjoy the fresh air and relax in this stylish outdoor seating area, perfect for socializing or enjoying a quiet moment.",
      "link": "false",
      "alt_text": "Outdoor seating area with sofas and a coffee table on artificial grass under a covered patio.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Sky-on-Main-031_Photo_Rooftop-Lounge_2026-07-30_MLS-Size (10).jpg"
    },
    {
      "id": "ec_25259f85efc7666280dc2eee",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b660-bc4c-720f-8cf1-8427c569f06f.webp",
      "image_media": {
        "alt_text": "Outdoor grilling area with a built-in stainless steel grill, marble countertops, and a shaded seating area with a pergola.",
        "public_id": "01a0b660-bc4c-720f-8cf1-8427c569f06f",
        "storage_key": "property/6767906449167610/01a0b660-bc4c-720f-8cf1-8427c569f06f.webp",
        "width": 1200,
        "height": 801
      },
      "title": "Community",
      "description": "Enjoy al fresco dining and entertainment with our state-of-the-art outdoor grilling station, complete with a spacious counter and comfortable seating area.",
      "link": "false",
      "alt_text": "Outdoor grilling area with a built-in stainless steel grill, marble countertops, and a shaded seating area with a pergola.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Sky-on-Main-031_Photo_Rooftop-Lounge_2026-07-30_MLS-Size (7).jpg"
    },
    {
      "id": "ec_f81036b2e6232514b4e6fb18",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b660-1c5b-711e-8d0c-74474b0c4540.webp",
      "image_media": {
        "alt_text": "Rooftop lounge area with modern seating and a fire pit, overlooking city buildings.",
        "public_id": "01a0b660-1c5b-711e-8d0c-74474b0c4540",
        "storage_key": "property/6767906449167610/01a0b660-1c5b-711e-8d0c-74474b0c4540.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Enjoy the urban skyline from our chic rooftop lounge, complete with comfortable seating and a cozy fire pit. Perfect for relaxing or entertaining.",
      "link": "false",
      "alt_text": "Rooftop lounge area with modern seating and a fire pit, overlooking city buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Sky-on-Main-031_Photo_Rooftop-Lounge_2026-07-30_MLS-Size (5).jpg"
    },
    {
      "id": "ec_b9320d64b1bbead3e88d0a7e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b660-aa87-726a-94d0-3cc8cf5edd1e.webp",
      "image_media": {
        "alt_text": "Rooftop deck with lounge chairs and seating areas, overlooking city buildings.",
        "public_id": "01a0b660-aa87-726a-94d0-3cc8cf5edd1e",
        "storage_key": "property/6767906449167610/01a0b660-aa87-726a-94d0-3cc8cf5edd1e.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Enjoy relaxation and socializing on our modern rooftop deck, featuring comfortable lounge chairs, dining areas, and a grilling station with stunning city views.",
      "link": "false",
      "alt_text": "Rooftop deck with lounge chairs and seating areas, overlooking city buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Sky-on-Main-031_Photo_Rooftop-Lounge_2026-07-30_MLS-Size (8).jpg"
    },
    {
      "id": "ec_067a9be209da310ca1d8519c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b660-aa8e-773a-a71b-f79e4df60a52.webp",
      "image_media": {
        "alt_text": "In-unit stacked washer and dryer with decorative plants.",
        "public_id": "01a0b660-aa8e-773a-a71b-f79e4df60a52",
        "storage_key": "property/6767906449167610/01a0b660-aa8e-773a-a71b-f79e4df60a52.webp",
        "width": 1600,
        "height": 1200
      },
      "title": "Apartment",
      "description": "Convenient in-unit stacked washer and dryer, perfect for keeping up with laundry without leaving your home. Accompanied by stylish potted plants for a touch of greenery.",
      "link": "false",
      "alt_text": "In-unit stacked washer and dryer with decorative plants.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/13-920 Main St 245-13.jpg"
    },
    {
      "id": "ec_e5e1034fed783b244332b160",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b660-c410-707e-b03b-45071966184a.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and a large island with bar stools.",
        "public_id": "01a0b660-c410-707e-b03b-45071966184a",
        "storage_key": "property/6767906449167610/01a0b660-c410-707e-b03b-45071966184a.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Apartment",
      "description": "Sleek and spacious kitchen featuring a stainless steel refrigerator, microwave, and oven, with a large island perfect for casual dining or entertaining.",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel appliances and a large island with bar stools.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Sky on Main - 22 - Staged.jpg"
    },
    {
      "id": "ec_0214d28cda3a9528df78c52b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b660-c53f-759e-9d89-13fd023c2db5.webp",
      "image_media": {
        "alt_text": "Living room with green sofa, armchair, coffee table, and record player art.",
        "public_id": "01a0b660-c53f-759e-9d89-13fd023c2db5",
        "storage_key": "property/6767906449167610/01a0b660-c53f-759e-9d89-13fd023c2db5.webp",
        "width": 1600,
        "height": 1143
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this beautifully appointed living space, featuring a plush green sofa, a cozy armchair, and unique decorative art.",
      "link": "false",
      "alt_text": "Living room with green sofa, armchair, coffee table, and record player art.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Sky on Main _ Nicole Bissey Photography29(1).jpg"
    },
    {
      "id": "ec_acb9d30b7064e814452a4d9c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b660-b5da-702f-8160-3b0dfa28288c.webp",
      "image_media": {
        "alt_text": "Modern living room with a sectional sofa, coffee table, and city views.",
        "public_id": "01a0b660-b5da-702f-8160-3b0dfa28288c",
        "storage_key": "property/6767906449167610/01a0b660-b5da-702f-8160-3b0dfa28288c.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Spacious and stylish living area featuring a comfortable sectional sofa, a unique coffee table, and large windows offering panoramic city vistas.",
      "link": "false",
      "alt_text": "Modern living room with a sectional sofa, coffee table, and city views.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Sky on Main - 20 - Staged.jpg"
    },
    {
      "id": "ec_fe19ff1b934b9ca4fd353a70",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b660-cd05-752c-9273-5f6bbe83467b.webp",
      "image_media": {
        "alt_text": "Close-up of a modern shower with a blue mosaic tile wall and chrome fixtures.",
        "public_id": "01a0b660-cd05-752c-9273-5f6bbe83467b",
        "storage_key": "property/6767906449167610/01a0b660-cd05-752c-9273-5f6bbe83467b.webp",
        "width": 1143,
        "height": 1600
      },
      "title": "Apartment",
      "description": "Step into a spa-like experience with our beautifully designed showers, featuring stylish blue mosaic tiles and sleek chrome fixtures for a touch of elegance.",
      "link": "false",
      "alt_text": "Close-up of a modern shower with a blue mosaic tile wall and chrome fixtures.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Sky on Main _ Nicole Bissey Photography24.jpg"
    },
    {
      "id": "ec_453e8eb07d81ab843347593c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b660-c28b-709a-b4a0-324fca3da2cc.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white subway tile backsplash, and a large sink.",
        "public_id": "01a0b660-c28b-709a-b4a0-324fca3da2cc",
        "storage_key": "property/6767906449167610/01a0b660-c28b-709a-b4a0-324fca3da2cc.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Experience culinary convenience in this beautifully appointed kitchen, featuring sleek stainless steel appliances, ample counter space, and a stylish subway tile backsplash.",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel appliances, white subway tile backsplash, and a large sink.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Kitchen Sink Phase 2(1).jpg"
    },
    {
      "id": "ec_0f34681007d56edcef8f93e5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b660-f030-773a-a397-a26c6e745c66.webp",
      "image_media": {
        "alt_text": "Aerial view of a downtown cityscape with tall buildings and a street with a bus.",
        "public_id": "01a0b660-f030-773a-a397-a26c6e745c66",
        "storage_key": "property/6767906449167610/01a0b660-f030-773a-a397-a26c6e745c66.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Community",
      "description": "Experience urban living in the heart of the city, with easy access to transportation and a vibrant downtown atmosphere.",
      "link": "false",
      "alt_text": "Aerial view of a downtown cityscape with tall buildings and a street with a bus.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Price Brothers_Sky On Main_DJI_0277_POST SKY REPLACE_edit.jpg"
    },
    {
      "id": "ec_d7d2d55f829c99d9f424c398",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b660-ccb4-74ba-8e8b-d022efc9fe16.webp",
      "image_media": {
        "alt_text": "Indoor basketball court with basketball hoop and adjacent gym equipment.",
        "public_id": "01a0b660-ccb4-74ba-8e8b-d022efc9fe16",
        "storage_key": "property/6767906449167610/01a0b660-ccb4-74ba-8e8b-d022efc9fe16.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Community",
      "description": "Enjoy a game of basketball on our indoor court, or get a workout in our fully equipped fitness center.",
      "link": "false",
      "alt_text": "Indoor basketball court with basketball hoop and adjacent gym equipment.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Sky on Main _ Nicole Bissey Photography87.jpg"
    },
    {
      "id": "ec_98283b86fbf1199f9c613b4b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b660-d1ba-708c-ba63-817a2e08d862.webp",
      "image_media": {
        "alt_text": "Treadmills and elliptical machines in a modern fitness center with large windows overlooking a city street.",
        "public_id": "01a0b660-d1ba-708c-ba63-817a2e08d862",
        "storage_key": "property/6767906449167610/01a0b660-d1ba-708c-ba63-817a2e08d862.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring a variety of cardio machines like treadmills and ellipticals, with expansive windows offering city views.",
      "link": "false",
      "alt_text": "Treadmills and elliptical machines in a modern fitness center with large windows overlooking a city street.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Sky on Main _ Nicole Bissey Photography84.jpg"
    },
    {
      "id": "ec_70b51d9824abd5db6974e221",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b660-d3a0-724b-bcd4-38c898f58d04.webp",
      "image_media": {
        "alt_text": "Modern gym with weight machines, free weights, and a basketball hoop.",
        "public_id": "01a0b660-d3a0-724b-bcd4-38c898f58d04",
        "storage_key": "property/6767906449167610/01a0b660-d3a0-724b-bcd4-38c898f58d04.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring Cybex weight machines, free weights, and a basketball hoop for resident use.",
      "link": "false",
      "alt_text": "Modern gym with weight machines, free weights, and a basketball hoop.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Sky on Main _ Nicole Bissey Photography91(1).jpg"
    },
    {
      "id": "ec_4262ba5daa89bfba0ba79209",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b660-f2d5-7430-8a24-bcd3525747e4.webp",
      "image_media": {
        "alt_text": "Close-up of a Peloton stationary bike in a gym setting.",
        "public_id": "01a0b660-f2d5-7430-8a24-bcd3525747e4",
        "storage_key": "property/6767906449167610/01a0b660-f2d5-7430-8a24-bcd3525747e4.webp",
        "width": 1024,
        "height": 768
      },
      "title": "Community",
      "description": "Stay active and energized with our state-of-the-art fitness center, featuring premium equipment like Peloton bikes for your wellness routine.",
      "link": "false",
      "alt_text": "Close-up of a Peloton stationary bike in a gym setting.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/MO_KansasCity_SkyonMain_p1532313_9_09_1_PhotoGallery.jpg"
    },
    {
      "id": "ec_25bab51c83a4c8977d4b6c8b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b660-e062-718b-9ea1-18fa94c38585.webp",
      "image_media": {
        "alt_text": "Gym with weights and exercise machines, large windows with city view",
        "public_id": "01a0b660-e062-718b-9ea1-18fa94c38585",
        "storage_key": "property/6767906449167610/01a0b660-e062-718b-9ea1-18fa94c38585.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Community",
      "description": "State-of-the-art fitness center with a full range of weight machines and free weights, offering residents a convenient place to exercise with city views.",
      "link": "false",
      "alt_text": "Gym with weights and exercise machines, large windows with city view",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Sky on Main _ Nicole Bissey Photography90.jpg"
    },
    {
      "id": "ec_90d4b6c3068d6937332501d7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b660-fbe5-76b2-9fac-862fb4bda107.webp",
      "image_media": {
        "alt_text": "Modern gym with treadmills, stair climber, and stationary bike.",
        "public_id": "01a0b660-fbe5-76b2-9fac-862fb4bda107",
        "storage_key": "property/6767906449167610/01a0b660-fbe5-76b2-9fac-862fb4bda107.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring treadmills, a stair climber, and stationary bikes.",
      "link": "false",
      "alt_text": "Modern gym with treadmills, stair climber, and stationary bike.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Sky on Main _ Nicole Bissey Photography89.jpg"
    },
    {
      "id": "ec_f2104d7c3e3632648861dde4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b660-e311-7428-91bd-9303a95a303f.webp",
      "image_media": {
        "alt_text": "Fitness center with weight machines, benches, and free weights.",
        "public_id": "01a0b660-e311-7428-91bd-9303a95a303f",
        "storage_key": "property/6767906449167610/01a0b660-e311-7428-91bd-9303a95a303f.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring a variety of weight machines, benches, and free weights for a complete workout experience.",
      "link": "false",
      "alt_text": "Fitness center with weight machines, benches, and free weights.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Sky on Main _ Nicole Bissey Photography92.jpg"
    },
    {
      "id": "ec_d3fb0da3c80e3c1dad984079",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b661-12f6-73f3-a8f2-e264f40847e5.webp",
      "image_media": {
        "alt_text": "Modern balcony with sectional seating and city views.",
        "public_id": "01a0b661-12f6-73f3-a8f2-e264f40847e5",
        "storage_key": "property/6767906449167610/01a0b661-12f6-73f3-a8f2-e264f40847e5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind on this chic balcony, featuring comfortable sectional seating and stunning city vistas. Perfect for enjoying the urban lifestyle.",
      "link": "false",
      "alt_text": "Modern balcony with sectional seating and city views.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Sky on Main - 01(1).jpg"
    },
    {
      "id": "ec_b3096b68bee6b8c0785a84ca",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b660-fb46-779c-9f20-f0b5cfffbf7b.webp",
      "image_media": {
        "alt_text": "Outdoor dining area with a long wooden table and chairs, overlooking a city street.",
        "public_id": "01a0b660-fb46-779c-9f20-f0b5cfffbf7b",
        "storage_key": "property/6767906449167610/01a0b660-fb46-779c-9f20-f0b5cfffbf7b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy al fresco dining on the spacious balcony, complete with a large table and chairs, offering city views.",
      "link": "false",
      "alt_text": "Outdoor dining area with a long wooden table and chairs, overlooking a city street.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Sky on Main - 02_edit.jpg"
    },
    {
      "id": "ec_e6c6e7cd73ccd096a09b97e3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b660-25a8-72c9-abb1-8a85161219be.webp",
      "image_media": {
        "alt_text": "Interior view of a gym with large mirrors, exercise equipment, and yoga balls.",
        "public_id": "01a0b660-25a8-72c9-abb1-8a85161219be",
        "storage_key": "property/6767906449167610/01a0b660-25a8-72c9-abb1-8a85161219be.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "State-of-the-art fitness center with cardio and strength training equipment, perfect for your workout needs.",
      "link": "false",
      "alt_text": "Interior view of a gym with large mirrors, exercise equipment, and yoga balls.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Sky-on-Main-031_Photo_Yoga-Studio_2026-07-30_MLS-Size (3).jpg"
    },
    {
      "id": "ec_7f3051e882999656f706f467",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b660-fd61-729c-930a-85476727b3c9.webp",
      "image_media": {
        "alt_text": "Interior of a modern gym with weight machines, benches, and exercise balls.",
        "public_id": "01a0b660-fd61-729c-930a-85476727b3c9",
        "storage_key": "property/6767906449167610/01a0b660-fd61-729c-930a-85476727b3c9.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Stay active in our fully-equipped fitness center, featuring state-of-the-art cardio and strength training equipment.",
      "link": "false",
      "alt_text": "Interior of a modern gym with weight machines, benches, and exercise balls.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Sky-on-Main-031_Photo_Yoga-Studio_2026-07-30_MLS-Size (1).jpg"
    },
    {
      "id": "ec_b093eb1dec5d782aa90b26ea",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b661-2150-70a5-8bc6-19bc3152513e.webp",
      "image_media": {
        "alt_text": "Guided meditation on mirror screen with woman in yoga pose",
        "public_id": "01a0b661-2150-70a5-8bc6-19bc3152513e",
        "storage_key": "property/6767906449167610/01a0b661-2150-70a5-8bc6-19bc3152513e.webp",
        "width": 513,
        "height": 768
      },
      "title": "Lifestyle",
      "description": "Experience guided meditation sessions to enhance your well-being and achieve a state of calm with this interactive mirror.",
      "link": "false",
      "alt_text": "Guided meditation on mirror screen with woman in yoga pose",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/MO_KansasCity_SkyonMain_p1532313_8_08_1_PhotoGallery.jpg"
    },
    {
      "id": "ec_32aa7673d1dfa06d227c38f1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b661-1161-7020-a94e-53023b55ce6d.webp",
      "image_media": {
        "alt_text": "Gym with mirrors, weight bench, and large windows overlooking a parking garage.",
        "public_id": "01a0b661-1161-7020-a94e-53023b55ce6d",
        "storage_key": "property/6767906449167610/01a0b661-1161-7020-a94e-53023b55ce6d.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Modern apartment gym featuring mirrored walls, free weights, and a comfortable seating area with views of the city.",
      "link": "false",
      "alt_text": "Gym with mirrors, weight bench, and large windows overlooking a parking garage.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Sky-on-Main-031_Photo_Yoga-Studio_2026-07-30_MLS-Size (2).jpg"
    },
    {
      "id": "ec_bbea676a28c5265b9def2e1f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b661-18da-75ef-9952-967f4e617ce1.webp",
      "image_media": {
        "alt_text": "Modern home office setup with a wooden desk, office chair, and abstract art.",
        "public_id": "01a0b661-18da-75ef-9952-967f4e617ce1",
        "storage_key": "property/6767906449167610/01a0b661-18da-75ef-9952-967f4e617ce1.webp",
        "width": 1600,
        "height": 1143
      },
      "title": "Apartment",
      "description": "Create a productive and stylish workspace in your apartment with this modern home office setup, featuring a sleek wooden desk and contemporary decor.",
      "link": "false",
      "alt_text": "Modern home office setup with a wooden desk, office chair, and abstract art.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Sky on Main _ Nicole Bissey Photography33.jpg"
    },
    {
      "id": "ec_b3695a121ecb6a4fef320378",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b661-3246-756a-b224-d1fbf0625525.webp",
      "image_media": {
        "alt_text": "A pet bed with a Nutella plush toy is placed on the floor near a wooden desk and chair.",
        "public_id": "01a0b661-3246-756a-b224-d1fbf0625525",
        "storage_key": "property/6767906449167610/01a0b661-3246-756a-b224-d1fbf0625525.webp",
        "width": 1600,
        "height": 1143
      },
      "title": "Apartment",
      "description": "This image features a comfortable pet bed on the floor, complete with a fun Nutella-themed plush toy, next to a stylish wooden desk and chair. Perfect for your furry friend to relax while you work.",
      "link": "false",
      "alt_text": "A pet bed with a Nutella plush toy is placed on the floor near a wooden desk and chair.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Sky on Main _ Nicole Bissey Photography36.jpg"
    },
    {
      "id": "ec_b0e8847552454cecfbc26da6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b661-2036-7428-88f1-1a764e5bc3a2.webp",
      "image_media": {
        "alt_text": "Home office desk with decorative shelves and a view into a dining area.",
        "public_id": "01a0b661-2036-7428-88f1-1a764e5bc3a2",
        "storage_key": "property/6767906449167610/01a0b661-2036-7428-88f1-1a764e5bc3a2.webp",
        "width": 1600,
        "height": 1143
      },
      "title": "Apartment",
      "description": "A stylish home office setup featuring decorative shelves with plants and art, a gold geometric pencil holder, and a view into an adjacent dining space.",
      "link": "false",
      "alt_text": "Home office desk with decorative shelves and a view into a dining area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Sky on Main _ Nicole Bissey Photography32.jpg"
    },
    {
      "id": "ec_3873eac204fc4dc3710df74e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b661-26d0-72b6-b7a1-5ec317467264.webp",
      "image_media": {
        "alt_text": "Modern dining room with clear chairs around a round table, and a green sofa in the background.",
        "public_id": "01a0b661-26d0-72b6-b7a1-5ec317467264",
        "storage_key": "property/6767906449167610/01a0b661-26d0-72b6-b7a1-5ec317467264.webp",
        "width": 1600,
        "height": 1143
      },
      "title": "Apartment",
      "description": "Experience sophisticated dining and living in this beautifully appointed apartment, featuring a stylish round table and comfortable seating.",
      "link": "false",
      "alt_text": "Modern dining room with clear chairs around a round table, and a green sofa in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Sky on Main _ Nicole Bissey Photography28.jpg"
    },
    {
      "id": "ec_1ab5cafeeb446f627efaf9f2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b661-2758-764f-973d-7400247944be.webp",
      "image_media": {
        "alt_text": "Stackable Bosch washer and dryer set in a laundry closet.",
        "public_id": "01a0b661-2758-764f-973d-7400247944be",
        "storage_key": "property/6767906449167610/01a0b661-2758-764f-973d-7400247944be.webp",
        "width": 1600,
        "height": 1143
      },
      "title": "Apartment",
      "description": "Convenient in-unit washer and dryer for all your laundry needs.",
      "link": "false",
      "alt_text": "Stackable Bosch washer and dryer set in a laundry closet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Sky on Main _ Nicole Bissey Photography42.jpg"
    },
    {
      "id": "ec_bc5aeafb5397da8cf4f52645",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b661-2937-72ca-88ea-31aea71737c1.webp",
      "image_media": {
        "alt_text": "Modern living room with large windows, a gray sofa, coffee table, and TV.",
        "public_id": "01a0b661-2937-72ca-88ea-31aea71737c1",
        "storage_key": "property/6767906449167610/01a0b661-2937-72ca-88ea-31aea71737c1.webp",
        "width": 1600,
        "height": 1200
      },
      "title": "Apartment",
      "description": "Spacious and modern living area featuring a comfortable gray sofa, a stylish coffee table, and a wall-mounted TV, perfect for relaxation and entertainment.",
      "link": "false",
      "alt_text": "Modern living room with large windows, a gray sofa, coffee table, and TV.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/04-920 Main St 245-4.jpg"
    },
    {
      "id": "ec_0d30a09d922dc27fc828a4d0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b661-4321-757a-918b-2f35a1f51e0d.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a glass-enclosed bathtub and shower, and a vanity with a blue tiled backsplash.",
        "public_id": "01a0b661-4321-757a-918b-2f35a1f51e0d",
        "storage_key": "property/6767906449167610/01a0b661-4321-757a-918b-2f35a1f51e0d.webp",
        "width": 1600,
        "height": 1143
      },
      "title": "Apartment",
      "description": "Spacious and modern bathroom featuring a bathtub with a glass shower enclosure, a dual-flush toilet, and a sleek vanity with a captivating blue mosaic tile backsplash.",
      "link": "false",
      "alt_text": "Modern bathroom with a glass-enclosed bathtub and shower, and a vanity with a blue tiled backsplash.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Sky on Main _ Nicole Bissey Photography37.jpg"
    },
    {
      "id": "ec_e971349ccc45797aae882186",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b661-4990-7131-80d9-664b9cf6f506.webp",
      "image_media": {
        "alt_text": "Sleek living room with large windows overlooking city skyline, featuring a plush grey sofa and modern dining area.",
        "public_id": "01a0b661-4990-7131-80d9-664b9cf6f506",
        "storage_key": "property/6767906449167610/01a0b661-4990-7131-80d9-664b9cf6f506.webp",
        "width": 1600,
        "height": 1200
      },
      "title": "Apartment",
      "description": "Experience urban living in this stylish apartment, boasting a spacious living area with breathtaking city views and a chic dining space.",
      "link": "false",
      "alt_text": "Sleek living room with large windows overlooking city skyline, featuring a plush grey sofa and modern dining area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/05-920 Main St 245-5.jpg"
    },
    {
      "id": "ec_b2a46ddb4253207f14898118",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b661-3443-712f-81b8-f9f0deb42d2a.webp",
      "image_media": {
        "alt_text": "A staged bedroom with a king-sized bed, nightstand, desk, and large windows with a city view.",
        "public_id": "01a0b661-3443-712f-81b8-f9f0deb42d2a",
        "storage_key": "property/6767906449167610/01a0b661-3443-712f-81b8-f9f0deb42d2a.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this beautifully staged bedroom, featuring a plush king-sized bed and ample natural light from large windows overlooking the city skyline.",
      "link": "false",
      "alt_text": "A staged bedroom with a king-sized bed, nightstand, desk, and large windows with a city view.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Sky on Main - 10 - Staged.jpg"
    },
    {
      "id": "ec_3982afbc2929bd2379218c0f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b661-3542-717c-a488-f680cb955c72.webp",
      "image_media": {
        "alt_text": "Modern living room with green sofa and city view",
        "public_id": "01a0b661-3542-717c-a488-f680cb955c72",
        "storage_key": "property/6767906449167610/01a0b661-3542-717c-a488-f680cb955c72.webp",
        "width": 1600,
        "height": 1143
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a vibrant green sofa, chic decor, and large windows offering a city view. Perfect for relaxation and entertainment.",
      "link": "false",
      "alt_text": "Modern living room with green sofa and city view",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Sky on Main _ Nicole Bissey Photography30.jpg"
    },
    {
      "id": "ec_85c76394368e77dabdf2df99",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b661-3db7-76d8-a526-891bb6ed790b.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and sleek cabinetry.",
        "public_id": "01a0b661-3db7-76d8-a526-891bb6ed790b",
        "storage_key": "property/6767906449167610/01a0b661-3db7-76d8-a526-891bb6ed790b.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "A contemporary kitchen featuring stainless steel appliances, including a refrigerator and range, complemented by light gray cabinets and a white subway tile backsplash.",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel appliances and sleek cabinetry.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/08-DSC07874.jpg"
    },
    {
      "id": "ec_ee97981d05490ebeb98fe825",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b661-40c2-7109-b8ce-827af52e25ba.webp",
      "image_media": {
        "alt_text": "Two closet doors open to reveal spacious closets inside a bedroom.",
        "public_id": "01a0b661-40c2-7109-b8ce-827af52e25ba",
        "storage_key": "property/6767906449167610/01a0b661-40c2-7109-b8ce-827af52e25ba.webp",
        "width": 1600,
        "height": 1143
      },
      "title": "Apartment",
      "description": "Discover ample storage with spacious closets, perfect for organizing your belongings. This apartment offers convenience and functionality.",
      "link": "false",
      "alt_text": "Two closet doors open to reveal spacious closets inside a bedroom.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Sky on Main _ Nicole Bissey Photography53.jpg"
    },
    {
      "id": "ec_1e5c2f29a8acba573c6ace59",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b661-582c-7546-b3e7-bce3aa2f32c4.webp",
      "image_media": {
        "alt_text": "Hallway with elevators",
        "public_id": "01a0b661-582c-7546-b3e7-bce3aa2f32c4",
        "storage_key": "property/6767906449167610/01a0b661-582c-7546-b3e7-bce3aa2f32c4.webp",
        "width": 1024,
        "height": 768
      },
      "title": "Community",
      "description": "Modern hallway with multiple elevators and elegant finishes.",
      "link": "false",
      "alt_text": "Hallway with elevators",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/MO_KansasCity_SkyonMain_p1532313_3_03_1_PhotoGallery.jpg"
    },
    {
      "id": "ec_00a680c4b3908ccdd9e98db4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b660-0000-726f-a9ed-ad542dc49efe.webp",
      "image_media": {
        "alt_text": "Elevator lobby with polished floors, wood paneling, and potted plants.",
        "public_id": "01a0b660-0000-726f-a9ed-ad542dc49efe",
        "storage_key": "property/6767906449167610/01a0b660-0000-726f-a9ed-ad542dc49efe.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Elegant elevator lobby featuring sleek stainless steel elevators, warm wood accents, and sophisticated tiling, creating a welcoming atmosphere.",
      "link": "false",
      "alt_text": "Elevator lobby with polished floors, wood paneling, and potted plants.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Sky-on-Main-031_Photo_Elevators_2026-07-30_MLS-Size.jpg"
    },
    {
      "id": "ec_df9f026cc057c70991c0b4ea",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b661-4b5a-77ee-9cef-c47c9870bb1e.webp",
      "image_media": {
        "alt_text": "Grand piano in a common area with seating and plants.",
        "public_id": "01a0b661-4b5a-77ee-9cef-c47c9870bb1e",
        "storage_key": "property/6767906449167610/01a0b661-4b5a-77ee-9cef-c47c9870bb1e.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "A grand piano and seating area in a building's common space, offering a touch of elegance.",
      "link": "false",
      "alt_text": "Grand piano in a common area with seating and plants.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Sky-on-Main-031_Photo_Lobby-Piano_2026-07-30_MLS-Size.jpg"
    },
    {
      "id": "ec_9343ea1765d523e3e5aaac52",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b661-4c61-76ad-914d-c90b435f88c4.webp",
      "image_media": {
        "alt_text": "Game room with air hockey table and seating area.",
        "public_id": "01a0b661-4c61-76ad-914d-c90b435f88c4",
        "storage_key": "property/6767906449167610/01a0b661-4c61-76ad-914d-c90b435f88c4.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Community",
      "description": "Enjoy a fun evening in our resident game room, complete with an air hockey table and comfortable seating.",
      "link": "false",
      "alt_text": "Game room with air hockey table and seating area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Sky on Main _ Nicole Bissey Photography62.jpg"
    },
    {
      "id": "ec_b3d37fc4fd549ed22559ac0b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b661-5359-734e-a126-1296da3e3530.webp",
      "image_media": {
        "alt_text": "Billiard table in a recreation room",
        "public_id": "01a0b661-5359-734e-a126-1296da3e3530",
        "storage_key": "property/6767906449167610/01a0b661-5359-734e-a126-1296da3e3530.webp",
        "width": 1200,
        "height": 801
      },
      "title": "Community",
      "description": "Enjoy leisure time with a game of billiards in our well-appointed recreation room. This space also features a foosball table for added fun.",
      "link": "false",
      "alt_text": "Billiard table in a recreation room",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Sky-on-Main-031_Photo_Club-Room_2026-07-30_MLS-Size (4).jpg"
    },
    {
      "id": "ec_f0c36f79f680016403fe63f7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b661-6fe5-723f-aa7d-08515bcaf4fd.webp",
      "image_media": {
        "alt_text": "Billiard balls racked on a pool table in a community game room.",
        "public_id": "01a0b661-6fe5-723f-aa7d-08515bcaf4fd",
        "storage_key": "property/6767906449167610/01a0b661-6fe5-723f-aa7d-08515bcaf4fd.webp",
        "width": 1143,
        "height": 1600
      },
      "title": "Community",
      "description": "Enjoy some friendly competition in our community game room, featuring a professional pool table for residents to use.",
      "link": "false",
      "alt_text": "Billiard balls racked on a pool table in a community game room.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Sky on Main _ Nicole Bissey Photography69.jpg"
    },
    {
      "id": "ec_843e084afaab37c512441083",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b661-5633-7598-b118-6a0b495eac43.webp",
      "image_media": {
        "alt_text": "Game room with air hockey, foosball, shuffleboard, and arcade games.",
        "public_id": "01a0b661-5633-7598-b118-6a0b495eac43",
        "storage_key": "property/6767906449167610/01a0b661-5633-7598-b118-6a0b495eac43.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Enjoy endless fun in our resident game room, featuring air hockey, foosball, shuffleboard, and classic arcade games for all to enjoy.",
      "link": "false",
      "alt_text": "Game room with air hockey, foosball, shuffleboard, and arcade games.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Sky-on-Main-031_Photo_Club-Room_2026-07-30_MLS-Size (5).jpg"
    },
    {
      "id": "ec_c0dfe6d12d02387522e6d587",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b661-7041-73e3-8dbd-46f8e041c9ae.webp",
      "image_media": {
        "alt_text": "Close-up of a foosball table in a community lounge area.",
        "public_id": "01a0b661-7041-73e3-8dbd-46f8e041c9ae",
        "storage_key": "property/6767906449167610/01a0b661-7041-73e3-8dbd-46f8e041c9ae.webp",
        "width": 1143,
        "height": 1600
      },
      "title": "Community",
      "description": "Enjoy a fun game of foosball in our resident lounge, a perfect way to unwind and socialize.",
      "link": "false",
      "alt_text": "Close-up of a foosball table in a community lounge area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Sky on Main _ Nicole Bissey Photography68.jpg"
    },
    {
      "id": "ec_55cf39e25f68a5f3349e8db2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b661-5b9c-746d-9e04-d0f10398364a.webp",
      "image_media": {
        "alt_text": "Community game room with shuffleboard, foosball, and air hockey tables.",
        "public_id": "01a0b661-5b9c-746d-9e04-d0f10398364a",
        "storage_key": "property/6767906449167610/01a0b661-5b9c-746d-9e04-d0f10398364a.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Enjoy endless fun in our community game room, featuring shuffleboard, foosball, and air hockey tables. A perfect space for residents to connect and unwind.",
      "link": "false",
      "alt_text": "Community game room with shuffleboard, foosball, and air hockey tables.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Sky-on-Main-031_Photo_Club-Room_2026-07-30_MLS-Size (1).jpg"
    },
    {
      "id": "ec_d5bbe0502f6990dc38873131",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b661-631d-754d-8ee2-2974f9dc9675.webp",
      "image_media": {
        "alt_text": "Game room with pool table, foosball table, and shuffleboard.",
        "public_id": "01a0b661-631d-754d-8ee2-2974f9dc9675",
        "storage_key": "property/6767906449167610/01a0b661-631d-754d-8ee2-2974f9dc9675.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Community",
      "description": "Enjoy a night of fun in the community game room, featuring a pool table, foosball, and shuffleboard.",
      "link": "false",
      "alt_text": "Game room with pool table, foosball table, and shuffleboard.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Sky on Main _ Nicole Bissey Photography61(1).jpg"
    },
    {
      "id": "ec_31fe7a3ec217c17213505467",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b661-6457-71ef-8049-903b068ee4b5.webp",
      "image_media": {
        "alt_text": "Shelf with board games and decorative books",
        "public_id": "01a0b661-6457-71ef-8049-903b068ee4b5",
        "storage_key": "property/6767906449167610/01a0b661-6457-71ef-8049-903b068ee4b5.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Lifestyle",
      "description": "A ladder shelf holds a collection of board games like Yahtzee, Operation, and Jenga, along with decorative books, suggesting a fun and engaging community space.",
      "link": "false",
      "alt_text": "Shelf with board games and decorative books",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Sky on Main _ Nicole Bissey Photography66.jpg"
    },
    {
      "id": "ec_1d183ee6d787b94913b92967",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b661-6642-7403-bf20-130d5d666653.webp",
      "image_media": {
        "alt_text": "Modern pendant lights hang above a sleek counter in a community common area with a pool table visible in the background.",
        "public_id": "01a0b661-6642-7403-bf20-130d5d666653",
        "storage_key": "property/6767906449167610/01a0b661-6642-7403-bf20-130d5d666653.webp",
        "width": 1067,
        "height": 1600
      },
      "title": "Community",
      "description": "Elegant pendant lighting enhances the communal space, offering a sophisticated atmosphere for residents. A pool table in the background adds a touch of leisure.",
      "link": "false",
      "alt_text": "Modern pendant lights hang above a sleek counter in a community common area with a pool table visible in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Sky on Main _ Nicole Bissey Photography73.jpg"
    },
    {
      "id": "ec_b4697cb8d84c159bb37d91ed",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b661-6db7-743f-9477-ea7339370351.webp",
      "image_media": {
        "alt_text": "Modern community lounge with a large island, bar stools, coffee station, and a TV.",
        "public_id": "01a0b661-6db7-743f-9477-ea7339370351",
        "storage_key": "property/6767906449167610/01a0b661-6db7-743f-9477-ea7339370351.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Enjoy our stylish community lounge, featuring a spacious island with seating, a fully equipped coffee station, and a large screen TV for entertainment and gatherings.",
      "link": "false",
      "alt_text": "Modern community lounge with a large island, bar stools, coffee station, and a TV.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Sky-on-Main-031_Photo_Club-Room_2026-07-30_MLS-Size (3).jpg"
    },
    {
      "id": "ec_f446808aa38f1dd615bd09ec",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b661-6ee0-723b-8d72-121ed86d3bb3.webp",
      "image_media": {
        "alt_text": "Modern communal kitchen and dining area with bar stools and tables.",
        "public_id": "01a0b661-6ee0-723b-8d72-121ed86d3bb3",
        "storage_key": "property/6767906449167610/01a0b661-6ee0-723b-8d72-121ed86d3bb3.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Enjoy this stylish communal kitchen and dining space, perfect for residents to gather and socialize.",
      "link": "false",
      "alt_text": "Modern communal kitchen and dining area with bar stools and tables.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Sky-on-Main-031_Photo_2026-07-30_MLS-Size (26).jpg"
    },
    {
      "id": "ec_ec4bc0d8b2764797093753c0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b660-252e-7221-abdf-c21fe882c81b.webp",
      "image_media": {
        "alt_text": "Modern coffee bar with white countertops, wooden cabinets, a coffee maker, and a variety of coffee pods and cups.",
        "public_id": "01a0b660-252e-7221-abdf-c21fe882c81b",
        "storage_key": "property/6767906449167610/01a0b660-252e-7221-abdf-c21fe882c81b.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Enjoy complimentary coffee and refreshments at our stylish coffee bar, perfect for starting your day or taking a break.",
      "link": "false",
      "alt_text": "Modern coffee bar with white countertops, wooden cabinets, a coffee maker, and a variety of coffee pods and cups.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Sky-on-Main-031_Photo_2026-07-30_MLS-Size (27).jpg"
    },
    {
      "id": "ec_28d96ba94f0e6180e16ed7b3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b661-87bf-7341-a58f-377112b29dbf.webp",
      "image_media": {
        "alt_text": "Modern lounge area with a pool table in the background.",
        "public_id": "01a0b661-87bf-7341-a58f-377112b29dbf",
        "storage_key": "property/6767906449167610/01a0b661-87bf-7341-a58f-377112b29dbf.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Community",
      "description": "Enjoy our stylish community lounge, perfect for relaxation and recreation, featuring a pool table for your entertainment.",
      "link": "false",
      "alt_text": "Modern lounge area with a pool table in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Sky on Main _ Nicole Bissey Photography72.jpg"
    },
    {
      "id": "ec_5b76c787883c8bbfeeb1c330",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b661-775a-7190-a904-5886eec514c8.webp",
      "image_media": {
        "alt_text": "Community lounge area with a large screen display, comfortable sectional seating, and modern decor.",
        "public_id": "01a0b661-775a-7190-a904-5886eec514c8",
        "storage_key": "property/6767906449167610/01a0b661-775a-7190-a904-5886eec514c8.webp",
        "width": 1200,
        "height": 801
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish community lounge, featuring a large screen for entertainment and ample comfortable seating.",
      "link": "false",
      "alt_text": "Community lounge area with a large screen display, comfortable sectional seating, and modern decor.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Sky-on-Main-031_Photo_Club-Room_2026-07-30_MLS-Size (2).jpg"
    },
    {
      "id": "ec_f9fcc4659c6d815bce6bf9d9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b660-12e3-7570-8a14-3afa4c03000c.webp",
      "image_media": {
        "alt_text": "Fenced dog park with artificial turf and overhead structure",
        "public_id": "01a0b660-12e3-7570-8a14-3afa4c03000c",
        "storage_key": "property/6767906449167610/01a0b660-12e3-7570-8a14-3afa4c03000c.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Enjoy our dedicated dog park area, perfect for your furry friends to play and socialize in a safe, enclosed space.",
      "link": "false",
      "alt_text": "Fenced dog park with artificial turf and overhead structure",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Sky-on-Main-031_Photo_Dog-Park_2026-07-30_MLS-Size (2).jpg"
    },
    {
      "id": "ec_b319c8c91a933e502cb3c895",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b661-8f2d-73b9-a6ee-4f36472b4486.webp",
      "image_media": {
        "alt_text": "Indoor dog park with artificial turf and fencing.",
        "public_id": "01a0b661-8f2d-73b9-a6ee-4f36472b4486",
        "storage_key": "property/6767906449167610/01a0b661-8f2d-73b9-a6ee-4f36472b4486.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Enjoy our convenient indoor dog park, complete with artificial turf and secure fencing for your furry friend's playtime, no matter the weather.",
      "link": "false",
      "alt_text": "Indoor dog park with artificial turf and fencing.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Sky-on-Main-031_Photo_Dog-Park_2026-07-30_MLS-Size (1).jpg"
    },
    {
      "id": "ec_30f88588c1874b220c3bf5cb",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b660-1e0b-745b-b012-7d0414a303eb.webp",
      "image_media": {
        "alt_text": "Vending machines and coffee station in apartment building.",
        "public_id": "01a0b660-1e0b-745b-b012-7d0414a303eb",
        "storage_key": "property/6767906449167610/01a0b660-1e0b-745b-b012-7d0414a303eb.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Convenient vending machines and a coffee station available for residents in the apartment building.",
      "link": "false",
      "alt_text": "Vending machines and coffee station in apartment building.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Sky-on-Main-031_Photo_Micro-Market_2026-07-30_MLS-Size (3).jpg"
    },
    {
      "id": "ec_202a4af3709152eaebd4619a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b661-971e-7079-ba99-15849ded7e8e.webp",
      "image_media": {
        "alt_text": "Vending machines with snacks and drinks in a common area.",
        "public_id": "01a0b661-971e-7079-ba99-15849ded7e8e",
        "storage_key": "property/6767906449167610/01a0b661-971e-7079-ba99-15849ded7e8e.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Convenient vending machines stocked with a variety of snacks and beverages, available for residents.",
      "link": "false",
      "alt_text": "Vending machines with snacks and drinks in a common area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Sky-on-Main-031_Photo_Micro-Market_2026-07-30_MLS-Size (4).jpg"
    },
    {
      "id": "ec_378432031263c8d48a7d31a6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b660-31f8-72ef-9af4-702adaee253d.webp",
      "image_media": {
        "alt_text": "ATM and vending machines in a common area with a small kitchen.",
        "public_id": "01a0b660-31f8-72ef-9af4-702adaee253d",
        "storage_key": "property/6767906449167610/01a0b660-31f8-72ef-9af4-702adaee253d.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Conveniently access cash with the on-site ATM and grab a snack or drink from the vending machines, located near the communal kitchen area.",
      "link": "false",
      "alt_text": "ATM and vending machines in a common area with a small kitchen.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Sky-on-Main-031_Photo_2026-07-30_MLS-Size (30).jpg"
    },
    {
      "id": "ec_950fc36fa479af4cb3709fc6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b661-7df5-77c3-97ba-5160f779c3cc.webp",
      "image_media": {
        "alt_text": "Living room with a sofa, coffee table, TV, and an open-concept kitchen with bar seating.",
        "public_id": "01a0b661-7df5-77c3-97ba-5160f779c3cc",
        "storage_key": "property/6767906449167610/01a0b661-7df5-77c3-97ba-5160f779c3cc.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Experience modern living in this spacious apartment, featuring a stylish living area, a fully-equipped open-concept kitchen with bar seating, and a large television for entertainment.",
      "link": "false",
      "alt_text": "Living room with a sofa, coffee table, TV, and an open-concept kitchen with bar seating.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Sky on Main - 15 - Staged.jpg"
    },
    {
      "id": "ec_c75f56501f6bc6942208b904",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b661-97ac-764f-9d76-a31b7d3ec056.webp",
      "image_media": {
        "alt_text": "Modern bathroom with blue tile shower and vanity with white countertops.",
        "public_id": "01a0b661-97ac-764f-9d76-a31b7d3ec056",
        "storage_key": "property/6767906449167610/01a0b661-97ac-764f-9d76-a31b7d3ec056.webp",
        "width": 1600,
        "height": 1143
      },
      "title": "Apartment",
      "description": "Step into luxury with this modern bathroom featuring a sleek white vanity, bright white countertops, and a stunning blue tiled shower enclosure. Perfect for unwinding after a long day.",
      "link": "false",
      "alt_text": "Modern bathroom with blue tile shower and vanity with white countertops.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Sky on Main _ Nicole Bissey Photography44.jpg"
    },
    {
      "id": "ec_756663bffc98c9c5836e32af",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b661-9f1a-712e-a20c-e4777e4f78fc.webp",
      "image_media": {
        "alt_text": "Queen-size bed with white linens and yellow accent pillows in a modern bedroom.",
        "public_id": "01a0b661-9f1a-712e-a20c-e4777e4f78fc",
        "storage_key": "property/6767906449167610/01a0b661-9f1a-712e-a20c-e4777e4f78fc.webp",
        "width": 1600,
        "height": 1143
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a queen-size bed with plush white linens, dressed with cheerful yellow accent pillows and a charcoal throw blanket.",
      "link": "false",
      "alt_text": "Queen-size bed with white linens and yellow accent pillows in a modern bedroom.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Sky on Main _ Nicole Bissey Photography47.jpg"
    },
    {
      "id": "ec_7ea8c226063a3d04c0df0f0e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b661-a711-754b-a647-912ffaa8f8b8.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and a large island.",
        "public_id": "01a0b661-a711-754b-a647-912ffaa8f8b8",
        "storage_key": "property/6767906449167610/01a0b661-a711-754b-a647-912ffaa8f8b8.webp",
        "width": 1600,
        "height": 1143
      },
      "title": "Apartment",
      "description": "Experience gourmet cooking in this sleek, modern kitchen. Featuring stainless steel appliances, ample cabinet space, and a spacious island perfect for entertaining.",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and a large island.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Sky on Main _ Nicole Bissey Photography27(1).jpg"
    },
    {
      "id": "ec_9034a8de63cdcb797b2cbadf",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b661-9a49-7444-93f2-c486f3084790.webp",
      "image_media": {
        "alt_text": "Living room with modern furnishings, artwork, and city views.",
        "public_id": "01a0b661-9a49-7444-93f2-c486f3084790",
        "storage_key": "property/6767906449167610/01a0b661-9a49-7444-93f2-c486f3084790.webp",
        "width": 2000,
        "height": 1335
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this beautifully appointed living room, featuring contemporary furniture and large windows with panoramic city views.",
      "link": "false",
      "alt_text": "Living room with modern furnishings, artwork, and city views.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Sky on Main - 25 - Staged.jpg"
    },
    {
      "id": "ec_5d5e82515cc0675355f3696a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b661-9f9d-75ad-a5bc-bf89eb8097ee.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, dresser, and TV with a city view.",
        "public_id": "01a0b661-9f9d-75ad-a5bc-bf89eb8097ee",
        "storage_key": "property/6767906449167610/01a0b661-9f9d-75ad-a5bc-bf89eb8097ee.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Relax in this spacious bedroom featuring a comfortable king-size bed, a modern dresser with a TV, and large windows offering stunning city views.",
      "link": "false",
      "alt_text": "Bedroom with a king-size bed, dresser, and TV with a city view.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Sky on Main - 24 - Staged.jpg"
    },
    {
      "id": "ec_b622c93781acb3a61479aa27",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b661-a2ff-76ab-b5b0-e8e0bea258af.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and a large island with bar stools.",
        "public_id": "01a0b661-a2ff-76ab-b5b0-e8e0bea258af",
        "storage_key": "property/6767906449167610/01a0b661-a2ff-76ab-b5b0-e8e0bea258af.webp",
        "width": 1600,
        "height": 1200
      },
      "title": "Apartment",
      "description": "Step into this sleek and modern kitchen, featuring stainless steel appliances, ample white cabinetry, and a spacious island perfect for casual dining or entertaining.",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and a large island with bar stools.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/03-920 Main St 245-3.jpg"
    },
    {
      "id": "ec_398d8f32e16f54fc867707dc",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b661-be29-704d-ba83-617e357152ea.webp",
      "image_media": {
        "alt_text": "Bedroom with a large window overlooking a city street with a tram.",
        "public_id": "01a0b661-be29-704d-ba83-617e357152ea",
        "storage_key": "property/6767906449167610/01a0b661-be29-704d-ba83-617e357152ea.webp",
        "width": 1600,
        "height": 1200
      },
      "title": "Apartment",
      "description": "Experience city living from the comfort of your bedroom, featuring expansive windows with views of the bustling street and passing tram.",
      "link": "false",
      "alt_text": "Bedroom with a large window overlooking a city street with a tram.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/09-920 Main St 245-9.jpg"
    },
    {
      "id": "ec_1ec62987e1dfc2b0a3e20d86",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b661-ac63-70db-b99a-f57053baac0a.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a vessel sink, white vanity, and blue tiled shower.",
        "public_id": "01a0b661-ac63-70db-b99a-f57053baac0a",
        "storage_key": "property/6767906449167610/01a0b661-ac63-70db-b99a-f57053baac0a.webp",
        "width": 1600,
        "height": 1200
      },
      "title": "Apartment",
      "description": "Step into luxury with this stunning bathroom, featuring a sleek vessel sink, ample vanity storage, and a beautifully tiled shower with a glass enclosure.",
      "link": "false",
      "alt_text": "Modern bathroom with a vessel sink, white vanity, and blue tiled shower.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/11-920 Main St 245-11.jpg"
    },
    {
      "id": "ec_d89da8cf29c0467c56cbbe3c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b661-adfe-7032-9533-2bc4c368f01c.webp",
      "image_media": {
        "alt_text": "Modern open-concept living and kitchen area with sleek white cabinetry, stainless steel appliances, and a breakfast bar.",
        "public_id": "01a0b661-adfe-7032-9533-2bc4c368f01c",
        "storage_key": "property/6767906449167610/01a0b661-adfe-7032-9533-2bc4c368f01c.webp",
        "width": 1600,
        "height": 1200
      },
      "title": "Apartment",
      "description": "Experience sophisticated urban living in this stylish apartment, featuring an open-concept layout with a modern kitchen and comfortable living space.",
      "link": "false",
      "alt_text": "Modern open-concept living and kitchen area with sleek white cabinetry, stainless steel appliances, and a breakfast bar.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/06-920 Main St 245-6.jpg"
    },
    {
      "id": "ec_78c5a195de8ed6c4297c06f9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b661-b196-70b0-af8c-efc0628c76de.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen bed and a large window overlooking the city",
        "public_id": "01a0b661-b196-70b0-af8c-efc0628c76de",
        "storage_key": "property/6767906449167610/01a0b661-b196-70b0-af8c-efc0628c76de.webp",
        "width": 1600,
        "height": 1200
      },
      "title": "Apartment",
      "description": "Spacious bedroom with a comfortable queen bed and a large window offering stunning city views. Includes a walk-in closet for ample storage.",
      "link": "false",
      "alt_text": "Bedroom with a queen bed and a large window overlooking the city",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/10-920 Main St 245-10.jpg"
    },
    {
      "id": "ec_0d1dafbe66039ad547153cbe",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b661-ce65-7077-8777-6515e6253823.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and a large island.",
        "public_id": "01a0b661-ce65-7077-8777-6515e6253823",
        "storage_key": "property/6767906449167610/01a0b661-ce65-7077-8777-6515e6253823.webp",
        "width": 1600,
        "height": 1200
      },
      "title": "Apartment",
      "description": "Experience contemporary living in this sleek kitchen, featuring stainless steel appliances, ample cabinet space, and a stylish island perfect for casual dining.",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and a large island.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/02-920 Main St 245-2.jpg"
    },
    {
      "id": "ec_da1f9ac50b96d656199ff0c9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b661-ce60-7758-b5c3-03151a3c897e.webp",
      "image_media": {
        "alt_text": "Modern bathroom with blue tiled shower and white vanity with vessel sink.",
        "public_id": "01a0b661-ce60-7758-b5c3-03151a3c897e",
        "storage_key": "property/6767906449167610/01a0b661-ce60-7758-b5c3-03151a3c897e.webp",
        "width": 1600,
        "height": 1200
      },
      "title": "Apartment",
      "description": "Experience luxury in this beautifully appointed bathroom featuring a sleek white vanity, vessel sink, and a striking blue tiled shower-bathtub combination.",
      "link": "false",
      "alt_text": "Modern bathroom with blue tiled shower and white vanity with vessel sink.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/12-920 Main St 245-12.jpg"
    },
    {
      "id": "ec_d53b83f197a49cc44e1aa5f8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b661-cdfc-7697-95c2-7d19a12a453e.webp",
      "image_media": {
        "alt_text": "Modern kitchen with island, stainless steel appliances, and white cabinetry.",
        "public_id": "01a0b661-cdfc-7697-95c2-7d19a12a453e",
        "storage_key": "property/6767906449167610/01a0b661-cdfc-7697-95c2-7d19a12a453e.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Expansive kitchen featuring a large island with a waterfall countertop, sleek white cabinetry, and top-of-the-line stainless steel appliances, perfect for culinary exploration.",
      "link": "false",
      "alt_text": "Modern kitchen with island, stainless steel appliances, and white cabinetry.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/01-DSC07806.jpg"
    },
    {
      "id": "ec_2c262ccc475527eddadb417c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b661-bd27-75a9-b123-3c9a8ca9357e.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white cabinetry, subway tile backsplash, and large sink.",
        "public_id": "01a0b661-bd27-75a9-b123-3c9a8ca9357e",
        "storage_key": "property/6767906449167610/01a0b661-bd27-75a9-b123-3c9a8ca9357e.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Expansive and modern kitchen featuring stainless steel appliances, ample cabinet space, and a sleek design perfect for any home chef.",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel appliances, white cabinetry, subway tile backsplash, and large sink.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/06-DSC07868.jpg"
    },
    {
      "id": "ec_de36a72ab87de3b85363e1b0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b661-c885-70eb-8e33-844c9b1adbef.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, island, and ample counter space.",
        "public_id": "01a0b661-c885-70eb-8e33-844c9b1adbef",
        "storage_key": "property/6767906449167610/01a0b661-c885-70eb-8e33-844c9b1adbef.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Fully equipped kitchen featuring stainless steel appliances, a spacious island with a waterfall countertop, and sleek white cabinetry.",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel appliances, island, and ample counter space.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/12-DSC07964.jpg"
    },
    {
      "id": "ec_ed79067fbfcb371ae0662116",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b661-cb2b-7779-8462-c42c9bb80042.webp",
      "image_media": {
        "alt_text": "Built-in desk with ample space and outlets, next to a closet and window with city view.",
        "public_id": "01a0b661-cb2b-7779-8462-c42c9bb80042",
        "storage_key": "property/6767906449167610/01a0b661-cb2b-7779-8462-c42c9bb80042.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "This apartment features a versatile built-in desk area, perfect for a home office or study nook. Enjoy natural light from the large window offering city views.",
      "link": "false",
      "alt_text": "Built-in desk with ample space and outlets, next to a closet and window with city view.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/14-DSC07999.jpg"
    },
    {
      "id": "ec_c918343ae53f57a98958fa09",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b661-d4df-76db-bea1-ce04521170b1.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a vanity, sink, toilet, and glass-enclosed shower.",
        "public_id": "01a0b661-d4df-76db-bea1-ce04521170b1",
        "storage_key": "property/6767906449167610/01a0b661-d4df-76db-bea1-ce04521170b1.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Step into this sleek and modern bathroom featuring a spacious vanity with ample storage, a pristine white sink, a contemporary toilet, and a luxurious glass-enclosed shower.",
      "link": "false",
      "alt_text": "Modern bathroom with a vanity, sink, toilet, and glass-enclosed shower.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/16-DSC08009.jpg"
    },
    {
      "id": "ec_d824bd50b862506c1fb0570a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b661-d88e-71db-9591-4450bdf118f4.webp",
      "image_media": {
        "alt_text": "Modern bathroom with white vanity, blue mosaic tile backsplash, and glass-enclosed shower.",
        "public_id": "01a0b661-d88e-71db-9591-4450bdf118f4",
        "storage_key": "property/6767906449167610/01a0b661-d88e-71db-9591-4450bdf118f4.webp",
        "width": 1000,
        "height": 667
      },
      "title": "Apartment",
      "description": "Step into this contemporary bathroom featuring a sleek white vanity, a striking blue mosaic tile backsplash, and a spacious glass-enclosed shower for a spa-like experience.",
      "link": "false",
      "alt_text": "Modern bathroom with white vanity, blue mosaic tile backsplash, and glass-enclosed shower.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/A1 Bathroom Phase 1(2).jpg"
    },
    {
      "id": "ec_06fa999445c2c161adcecf7c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b661-d84d-749b-92b3-b4d6f12a6b87.webp",
      "image_media": {
        "alt_text": "Modern shower stall with white tile and chrome fixtures",
        "public_id": "01a0b661-d84d-749b-92b3-b4d6f12a6b87",
        "storage_key": "property/6767906449167610/01a0b661-d84d-749b-92b3-b4d6f12a6b87.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Step into a spa-like experience in this beautifully tiled shower, featuring a rainfall showerhead and built-in shelving for convenience.",
      "link": "false",
      "alt_text": "Modern shower stall with white tile and chrome fixtures",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Shower Phase 2(1).jpg"
    },
    {
      "id": "ec_8a23d926c0e9049208afcafb",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b661-d9f0-7212-be31-9338aa7171c6.webp",
      "image_media": {
        "alt_text": "Modern bathroom with blue tiled shower and built-in shelves",
        "public_id": "01a0b661-d9f0-7212-be31-9338aa7171c6",
        "storage_key": "property/6767906449167610/01a0b661-d9f0-7212-be31-9338aa7171c6.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Step into a clean and modern bathroom, featuring a striking blue tiled shower and convenient built-in shelving for all your storage needs.",
      "link": "false",
      "alt_text": "Modern bathroom with blue tiled shower and built-in shelves",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Shower Phase 1(1).jpg"
    },
    {
      "id": "ec_6da0ea428a1ebd6adea5f624",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b661-dbe4-766c-bd9d-a5996bf12c59.webp",
      "image_media": {
        "alt_text": "Spacious living area and kitchen with island in a modern apartment.",
        "public_id": "01a0b661-dbe4-766c-bd9d-a5996bf12c59",
        "storage_key": "property/6767906449167610/01a0b661-dbe4-766c-bd9d-a5996bf12c59.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Experience comfortable living in this beautifully appointed apartment, featuring a modern kitchen with an island and a spacious living area.",
      "link": "false",
      "alt_text": "Spacious living area and kitchen with island in a modern apartment.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/A1 Kitchen Phase 2(1).jpg"
    },
    {
      "id": "ec_3aa27a4f0038b68bf7840b0b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b661-f4fc-71e1-9d23-4923c24b1eba.webp",
      "image_media": {
        "alt_text": "Modern living room and kitchen area with island, sofa, and shower stall.",
        "public_id": "01a0b661-f4fc-71e1-9d23-4923c24b1eba",
        "storage_key": "property/6767906449167610/01a0b661-f4fc-71e1-9d23-4923c24b1eba.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Experience sophisticated urban living in this spacious apartment, featuring a modern open-concept living area with a sleek kitchen island and a luxurious bathroom with a tiled shower.",
      "link": "false",
      "alt_text": "Modern living room and kitchen area with island, sofa, and shower stall.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/A1 Kitchen Phase 1.jpg"
    },
    {
      "id": "ec_78bf941cb96dacef34598689",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b661-e174-7456-9c52-64ae9b26c079.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and a deep sink.",
        "public_id": "01a0b661-e174-7456-9c52-64ae9b26c079",
        "storage_key": "property/6767906449167610/01a0b661-e174-7456-9c52-64ae9b26c079.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Step into a beautifully designed kitchen featuring sleek cabinetry, a full suite of stainless steel appliances, and a large undermount sink perfect for any culinary endeavor.",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel appliances and a deep sink.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Kitchen Sink Phase 1(1).jpg"
    },
    {
      "id": "ec_0f1c4b0746cccd2b84f2c916",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b661-e3bd-713e-9865-1297f505c19c.webp",
      "image_media": {
        "alt_text": "Stacked washer and dryer in a closet",
        "public_id": "01a0b661-e3bd-713e-9865-1297f505c19c",
        "storage_key": "property/6767906449167610/01a0b661-e3bd-713e-9865-1297f505c19c.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "In-unit stacked washer and dryer for convenient laundry access.",
      "link": "false",
      "alt_text": "Stacked washer and dryer in a closet",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Washer and Dryer Phase 2(1).jpg"
    },
    {
      "id": "ec_33f4ba43b31e2e64e8bfdc9f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b661-e451-779f-be58-20881d9c628d.webp",
      "image_media": {
        "alt_text": "Stacked Bosch washer and dryer in a closet.",
        "public_id": "01a0b661-e451-779f-be58-20881d9c628d",
        "storage_key": "property/6767906449167610/01a0b661-e451-779f-be58-20881d9c628d.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "In-unit washer and dryer for your convenience.",
      "link": "false",
      "alt_text": "Stacked Bosch washer and dryer in a closet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Washer and Dryer Phase 1(1).jpg"
    },
    {
      "id": "ec_6436cba38c1c34bfea6377c5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b661-fcb4-73bc-b0f2-b3297456363d.webp",
      "image_media": {
        "alt_text": "Apartment door with Yale smart lock and brushed nickel handle.",
        "public_id": "01a0b661-fcb4-73bc-b0f2-b3297456363d",
        "storage_key": "property/6767906449167610/01a0b661-fcb4-73bc-b0f2-b3297456363d.webp",
        "width": 1200,
        "height": 802
      },
      "title": "Apartment",
      "description": "Secure and modern apartment entry with a Yale smart lock for convenient access. Features a brushed nickel door handle.",
      "link": "false",
      "alt_text": "Apartment door with Yale smart lock and brushed nickel handle.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Lock Phase 2(1).jpg"
    },
    {
      "id": "ec_1dc5c99451ad7edb0a364209",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b661-ed08-7499-91ff-225f638b6c7d.webp",
      "image_media": {
        "alt_text": "Modern kitchen with island, stainless steel appliances, and pendant lighting.",
        "public_id": "01a0b661-ed08-7499-91ff-225f638b6c7d",
        "storage_key": "property/6767906449167610/01a0b661-ed08-7499-91ff-225f638b6c7d.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Sleek and modern kitchen featuring a spacious island with bar seating, stainless steel appliances, and elegant pendant lighting. Perfect for entertaining and everyday living.",
      "link": "false",
      "alt_text": "Modern kitchen with island, stainless steel appliances, and pendant lighting.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Kitchen Phase 1(1).jpg"
    },
    {
      "id": "ec_bcddc94707f97dd5f94f7b53",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b662-04c7-717d-90ef-95133af25415.webp",
      "image_media": {
        "alt_text": "Modern bathroom with double vanity, toilet, and glass-enclosed shower with blue tile.",
        "public_id": "01a0b662-04c7-717d-90ef-95133af25415",
        "storage_key": "property/6767906449167610/01a0b662-04c7-717d-90ef-95133af25415.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Experience luxury in this modern bathroom featuring a spacious double vanity, sleek fixtures, and a stunning glass-enclosed shower with vibrant blue tile accents.",
      "link": "false",
      "alt_text": "Modern bathroom with double vanity, toilet, and glass-enclosed shower with blue tile.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Sky-on-Main-031_Photo_Short-Term-Rental_2026-07-30_MLS-Size (1).jpg"
    },
    {
      "id": "ec_e6eb058d3c4c8485d48c4906",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b662-04c8-7068-85e2-adcb6f48c6d5.webp",
      "image_media": {
        "alt_text": "Modern open-plan kitchen and living area with island and dining table.",
        "public_id": "01a0b662-04c8-7068-85e2-adcb6f48c6d5",
        "storage_key": "property/6767906449167610/01a0b662-04c8-7068-85e2-adcb6f48c6d5.webp",
        "width": 1200,
        "height": 801
      },
      "title": "Apartment",
      "description": "Expansive open-concept living space featuring a sleek, modern kitchen with a large island and a comfortable dining and living area, perfect for entertaining.",
      "link": "false",
      "alt_text": "Modern open-plan kitchen and living area with island and dining table.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Sky-on-Main-031_Photo_Short-Term-Rental_2026-07-30_MLS-Size (10).jpg"
    },
    {
      "id": "ec_bf7a25915f9a20e0e0f9fbf1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b662-0c77-74c6-8aef-2f2e8492c2fc.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and an island with bar stools.",
        "public_id": "01a0b662-0c77-74c6-8aef-2f2e8492c2fc",
        "storage_key": "property/6767906449167610/01a0b662-0c77-74c6-8aef-2f2e8492c2fc.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring white cabinetry, a large island with seating, and stainless steel appliances, perfect for entertaining.",
      "link": "false",
      "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and an island with bar stools.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Sky-on-Main-031_Photo_Short-Term-Rental_2026-07-30_MLS-Size (9).jpg"
    },
    {
      "id": "ec_deb92baf19cb700d4a2aabef",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b660-12c1-7294-9491-7c75496b1975.webp",
      "image_media": {
        "alt_text": "Modern open-plan kitchen and dining area with a large wooden table and stainless steel appliances.",
        "public_id": "01a0b660-12c1-7294-9491-7c75496b1975",
        "storage_key": "property/6767906449167610/01a0b660-12c1-7294-9491-7c75496b1975.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Enjoy spacious living in this modern apartment featuring an open-concept kitchen and dining area. Perfect for entertaining or a quiet meal.",
      "link": "false",
      "alt_text": "Modern open-plan kitchen and dining area with a large wooden table and stainless steel appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Sky-on-Main-031_Photo_Short-Term-Rental_2026-07-30_MLS-Size (8).jpg"
    },
    {
      "id": "ec_21ffbb372a3721aefcac2ac4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b662-0265-718a-8b48-d98808cd1d25.webp",
      "image_media": {
        "alt_text": "Open-concept living and dining area with modern furniture and city views.",
        "public_id": "01a0b662-0265-718a-8b48-d98808cd1d25",
        "storage_key": "property/6767906449167610/01a0b662-0265-718a-8b48-d98808cd1d25.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious living and dining area in a modern apartment, featuring stylish furniture, large windows with city views, and elegant decor.",
      "link": "false",
      "alt_text": "Open-concept living and dining area with modern furniture and city views.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Sky-on-Main-031_Photo_Short-Term-Rental_2026-07-30_MLS-Size (6).jpg"
    },
    {
      "id": "ec_4384ffda70c966c36a34651d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b662-0586-76c9-a7ac-c6498fdafd31.webp",
      "image_media": {
        "alt_text": "Modern living room with leather sofas, armchairs, coffee tables, and a TV, overlooking a city skyline.",
        "public_id": "01a0b662-0586-76c9-a7ac-c6498fdafd31",
        "storage_key": "property/6767906449167610/01a0b662-0586-76c9-a7ac-c6498fdafd31.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Step into comfort and style in this beautifully appointed living room, featuring plush seating and a stunning city view. Perfect for relaxing or entertaining.",
      "link": "false",
      "alt_text": "Modern living room with leather sofas, armchairs, coffee tables, and a TV, overlooking a city skyline.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Sky-on-Main-031_Photo_Short-Term-Rental_2026-07-30_MLS-Size (7).jpg"
    },
    {
      "id": "ec_fdf147bd0f39650478c9b7a8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b662-0b1f-720a-9e63-8a4dfdf1d032.webp",
      "image_media": {
        "alt_text": "Modern bedroom with a king-size bed, plush blue bedding, nightstands, and artwork.",
        "public_id": "01a0b662-0b1f-720a-9e63-8a4dfdf1d032",
        "storage_key": "property/6767906449167610/01a0b662-0b1f-720a-9e63-8a4dfdf1d032.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed bedroom, featuring a plush king-size bed, elegant nightstands, and sophisticated wall art.",
      "link": "false",
      "alt_text": "Modern bedroom with a king-size bed, plush blue bedding, nightstands, and artwork.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Sky-on-Main-031_Photo_Short-Term-Rental_2026-07-30_MLS-Size (11).jpg"
    },
    {
      "id": "ec_2c12abe6d0b4180b2ca9b899",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b662-2c7a-7637-9fac-902dbabe1897.webp",
      "image_media": {
        "alt_text": "Luxurious bedroom with a king-size bed, modern art, and a TV.",
        "public_id": "01a0b662-2c7a-7637-9fac-902dbabe1897",
        "storage_key": "property/6767906449167610/01a0b662-2c7a-7637-9fac-902dbabe1897.webp",
        "width": 1200,
        "height": 801
      },
      "title": "Apartment",
      "description": "Step into comfort in this beautifully appointed bedroom, featuring a plush king-size bed and elegant decor. The open layout flows seamlessly into the living area.",
      "link": "false",
      "alt_text": "Luxurious bedroom with a king-size bed, modern art, and a TV.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Sky-on-Main-031_Photo_Short-Term-Rental_2026-07-30_MLS-Size (12).jpg"
    },
    {
      "id": "ec_ab98de1484ac3df92a31460b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b662-1262-752a-bf53-efd89c1aa5f6.webp",
      "image_media": {
        "alt_text": "Modern bathroom vanity with a white countertop, mosaic tile backsplash, and a large mirror.",
        "public_id": "01a0b662-1262-752a-bf53-efd89c1aa5f6",
        "storage_key": "property/6767906449167610/01a0b662-1262-752a-bf53-efd89c1aa5f6.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Bright and modern bathroom featuring a spacious vanity with a sleek mosaic tile backsplash and ample counter space.",
      "link": "false",
      "alt_text": "Modern bathroom vanity with a white countertop, mosaic tile backsplash, and a large mirror.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Sky-on-Main-031_Photo_Short-Term-Rental_2026-07-30_MLS-Size (2).jpg"
    },
    {
      "id": "ec_8d3282de88e18b7e00b9265d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b662-12bc-7172-baf4-905ad2bcfe51.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, mounted TV, and a full-length mirror.",
        "public_id": "01a0b662-12bc-7172-baf4-905ad2bcfe51",
        "storage_key": "property/6767906449167610/01a0b662-12bc-7172-baf4-905ad2bcfe51.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "A spacious bedroom featuring a comfortable queen-size bed, a modern mounted television, and a stylish full-length mirror, perfect for any apartment.",
      "link": "false",
      "alt_text": "Bedroom with a queen-size bed, mounted TV, and a full-length mirror.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Sky-on-Main-031_Photo_Short-Term-Rental_2026-07-30_MLS-Size (3).jpg"
    },
    {
      "id": "ec_f38f960617672dfcf7c2f292",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b662-135f-7715-b755-132495d03e8e.webp",
      "image_media": {
        "alt_text": "A cozy bedroom with a king-sized bed, bedside tables, and a piece of abstract art.",
        "public_id": "01a0b662-135f-7715-b755-132495d03e8e",
        "storage_key": "property/6767906449167610/01a0b662-135f-7715-b755-132495d03e8e.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Step into comfort and style in this inviting bedroom, featuring a plush king-sized bed, elegant bedside tables, and a striking piece of abstract art to enhance the ambiance.",
      "link": "false",
      "alt_text": "A cozy bedroom with a king-sized bed, bedside tables, and a piece of abstract art.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Sky-on-Main-031_Photo_Short-Term-Rental_2026-07-30_MLS-Size (4).jpg"
    },
    {
      "id": "ec_f2297e6cded127bffe47a0a0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b662-16c9-758a-9969-56c0357caf46.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a vanity, toilet, and a bathtub with a glass shower enclosure and blue tiled accent wall.",
        "public_id": "01a0b662-16c9-758a-9969-56c0357caf46",
        "storage_key": "property/6767906449167610/01a0b662-16c9-758a-9969-56c0357caf46.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "A sleek and modern bathroom featuring a white vanity with a vessel sink, a clean-lined toilet, and a bathtub with a striking blue mosaic tile accent wall and a glass enclosure.",
      "link": "false",
      "alt_text": "Modern bathroom with a vanity, toilet, and a bathtub with a glass shower enclosure and blue tiled accent wall.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Sky-on-Main-031_Photo_Short-Term-Rental_2026-07-30_MLS-Size (5).jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_c93b5cef-6dbf-4cc5-8f44-23e81eb8bf54",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "custom",
      "poi_name": "Hemma Hemma Dinette",
      "poi_type": "Restaurants",
      "poi_address": "1100 Main St #101, Kansas City, MO 64105, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b665-10f5-75fc-9476-de5f9815902b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b665-10f5-75fc-9476-de5f9815902b",
        "storage_key": "property/6767906449167610/01a0b665-10f5-75fc-9476-de5f9815902b.webp",
        "width": 853,
        "height": 1280
      },
      "poi_business_url": "http://www.hemmadinette.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16920333803675570901&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hemma-hemma-dinette",
      "poi_latitude": "39.1006478",
      "poi_longitude": "-94.5834627",
      "poi_miles_from_property": "0.1",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 816-603-2519",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc987-16c3-7159-938c-864735d501d9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-16c3-7159-938c-864735d501d9",
        "storage_key": "property/6767906449167610/019fc987-16c3-7159-938c-864735d501d9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJraxZIgDxwIcR1dIdWfIZ0eo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_97eba838-a18f-4d57-aeb3-11b74fd285e2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "custom",
      "poi_name": "The Majestic",
      "poi_type": "Restaurants",
      "poi_address": "931 Broadway Blvd, Kansas City, MO 64105, USA",
      "poi_short_description": "There's an old-school vibe at this vibrant steakhouse classic, featuring cocktails & nightly jazz.",
      "poi_long_description": "There's an old-school vibe at this vibrant steakhouse classic, featuring cocktails & nightly jazz.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc98c-e727-72ab-a991-de4fb096fd56.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98c-e727-72ab-a991-de4fb096fd56",
        "storage_key": "property/6767906449167610/019fc98c-e727-72ab-a991-de4fb096fd56.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.majestickc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6063602527445915096&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-majestic",
      "poi_latitude": "39.1026746",
      "poi_longitude": "-94.5881421",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 816-221-1888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc987-16c3-7159-938c-864735d501d9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-16c3-7159-938c-864735d501d9",
        "storage_key": "property/6767906449167610/019fc987-16c3-7159-938c-864735d501d9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJzw6nMlnwwIcR2BWTU18-JlQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_b2e55656-7153-4859-9ded-351788638d6f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "custom",
      "poi_name": "HomeGrown Kansas City - Power & Light",
      "poi_type": "Restaurants",
      "poi_address": "101 E 13th St, Kansas City, MO 64106, USA",
      "poi_short_description": "Daytime restaurant serving traditional breakfast and brunch fare, plus coffee, beer, and cocktails.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b665-0f52-7518-b97e-ebc8958cc1d3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b665-0f52-7518-b97e-ebc8958cc1d3",
        "storage_key": "property/6767906449167610/01a0b665-0f52-7518-b97e-ebc8958cc1d3.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://homegrownkitchen.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7730982066777944964&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "homegrown-kansas-city---power--light",
      "poi_latitude": "39.098484",
      "poi_longitude": "-94.5819875",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 816-428-6056",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc987-16c3-7159-938c-864735d501d9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-16c3-7159-938c-864735d501d9",
        "storage_key": "property/6767906449167610/019fc987-16c3-7159-938c-864735d501d9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJFWKwvizxwIcRhPM2rzr3SWs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "custom_87e62bea-ff90-4610-bebf-7a08edafe3ba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "custom",
      "poi_name": "Bristol Seafood + Steak + Social",
      "poi_type": "Restaurants",
      "poi_address": "51 E 14th St, Kansas City, MO 64106, USA",
      "poi_short_description": "Upscale restaurant serving steak, market-fresh seafood & wine in a chic, contemporary setting.",
      "poi_long_description": "Upscale restaurant serving steak, market-fresh seafood & wine in a chic, contemporary setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc98d-1fde-71eb-8744-af787edafefb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98d-1fde-71eb-8744-af787edafefb",
        "storage_key": "property/6767906449167610/019fc98d-1fde-71eb-8744-af787edafefb.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.bristolseafoodgrill.com/location/bristol-seafood-grill-kansas-city/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17729407784736481007&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bristol-seafood--steak--social",
      "poi_latitude": "39.0969842",
      "poi_longitude": "-94.5828043",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 816-448-6007",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc987-16c3-7159-938c-864735d501d9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-16c3-7159-938c-864735d501d9",
        "storage_key": "property/6767906449167610/019fc987-16c3-7159-938c-864735d501d9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJY-R_jGfwwIcR715DH3KCC_Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_f37b3755-caa2-4d08-86c1-b483e7fa72da",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "custom",
      "poi_name": "801 Chophouse",
      "poi_type": "Restaurants",
      "poi_address": "71 E 14th St, Kansas City, MO 64106, USA",
      "poi_short_description": "Prime cuts of beef, seafood & a large wine selection offered in an elegant, clubby setting.",
      "poi_long_description": "Prime cuts of beef, seafood & a large wine selection offered in an elegant, clubby setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019ff6d6-8d5d-75f4-942c-72ab04fc8406.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6d6-8d5d-75f4-942c-72ab04fc8406",
        "storage_key": "property/6767906449167610/019ff6d6-8d5d-75f4-942c-72ab04fc8406.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://801chophouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4114247279222876642&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "801-chophouse",
      "poi_latitude": "39.0969787",
      "poi_longitude": "-94.5825145",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 816-994-8800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc987-16c3-7159-938c-864735d501d9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-16c3-7159-938c-864735d501d9",
        "storage_key": "property/6767906449167610/019fc987-16c3-7159-938c-864735d501d9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJfy9J7WfwwIcR4mkyLBq-GDk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_397e2bc1-632f-44a2-836c-e5970d4e0393",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "custom",
      "poi_name": "The Town Company",
      "poi_type": "Restaurants",
      "poi_address": "1228 Baltimore Ave, Kansas City, MO 64105, USA",
      "poi_short_description": "Chic restaurant in the Hotel Kansas City serving upscale cuisine with carefully sourced ingredients.",
      "poi_long_description": "Chic restaurant in the Hotel Kansas City serving upscale cuisine with carefully sourced ingredients.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc98c-e144-774e-9a34-c6c53fa43573.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98c-e144-774e-9a34-c6c53fa43573",
        "storage_key": "property/6767906449167610/019fc98c-e144-774e-9a34-c6c53fa43573.webp",
        "width": 1280,
        "height": 823
      },
      "poi_business_url": "https://www.hotelkc.com/dine/the-town-company",
      "poi_directions_map_url": "https://maps.google.com/?cid=2327544064091670809&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-town-company",
      "poi_latitude": "39.0988801",
      "poi_longitude": "-94.5845601",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 816-895-0381",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc987-16c3-7159-938c-864735d501d9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-16c3-7159-938c-864735d501d9",
        "storage_key": "property/6767906449167610/019fc987-16c3-7159-938c-864735d501d9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ630XkHHxwIcRGclAk_4YTSA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_47ecec94-749a-4eff-9506-82e5248352a5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "custom",
      "poi_name": "The Stilwell",
      "poi_type": "Restaurants",
      "poi_address": "1515 Wyandotte St, Kansas City, MO 64108, USA",
      "poi_short_description": "Relaxed, stylish eatery serving local fare, cocktails and wine.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b665-0d6f-739c-90df-a2aa5e2239f8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b665-0d6f-739c-90df-a2aa5e2239f8",
        "storage_key": "property/6767906449167610/01a0b665-0d6f-739c-90df-a2aa5e2239f8.webp",
        "width": 1280,
        "height": 841
      },
      "poi_business_url": "https://www.thestilwellkc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12050051124866163814&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-stilwell",
      "poi_latitude": "39.09565389999999",
      "poi_longitude": "-94.5850882",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 816-897-7050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc987-16c3-7159-938c-864735d501d9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-16c3-7159-938c-864735d501d9",
        "storage_key": "property/6767906449167610/019fc987-16c3-7159-938c-864735d501d9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJeU8zgdTxwIcRZqTxdqdhOqc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_150b6e2a-c854-492b-884e-f01284e1982e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "custom",
      "poi_name": "Tannin Wine Bar & Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "1526 Walnut St, Kansas City, MO 64108, USA",
      "poi_short_description": "Seasonal American plates & a range of wines in a brick-lined space with bar, lounge & table seating.",
      "poi_long_description": "Seasonal American plates & a range of wines in a brick-lined space with bar, lounge & table seating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a01010-84cf-707f-9ff0-efa9b436d826.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01010-84cf-707f-9ff0-efa9b436d826",
        "storage_key": "property/6767906449167610/01a01010-84cf-707f-9ff0-efa9b436d826.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://tanninwinebar.com/?utm_source=google&utm_medium=seo&utm_campaign=gbp-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=16092817060116975843&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tannin-wine-bar--kitchen",
      "poi_latitude": "39.0949396",
      "poi_longitude": "-94.5826586",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 816-842-2660",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc992-e8b4-74aa-8072-5118fb5aa00b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc992-e8b4-74aa-8072-5118fb5aa00b",
        "storage_key": "property/6767906449167610/019fc992-e8b4-74aa-8072-5118fb5aa00b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJi1F1GmjwwIcR41CeT9orVd8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "wine_bar"
    },
    {
      "id": "custom_59851af4-525d-4dc2-8519-e4e26d7b8c45",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "custom",
      "poi_name": "Anton's",
      "poi_type": "Restaurants",
      "poi_address": "1610 Main St, Kansas City, MO 64108, USA",
      "poi_short_description": "Convivial, sustainably focused American tavern spotlighting dry-aged steaks & numerous draft beers.",
      "poi_long_description": "Convivial, sustainably focused American tavern spotlighting dry-aged steaks & numerous draft beers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc98c-e156-72ea-aafa-540191e3afbe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98c-e156-72ea-aafa-540191e3afbe",
        "storage_key": "property/6767906449167610/019fc98c-e156-72ea-aafa-540191e3afbe.webp",
        "width": 1232,
        "height": 816
      },
      "poi_business_url": "https://antonskc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6928687343238855470&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "antons",
      "poi_latitude": "39.09413139999999",
      "poi_longitude": "-94.5836868",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 816-888-8800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc987-16c3-7159-938c-864735d501d9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-16c3-7159-938c-864735d501d9",
        "storage_key": "property/6767906449167610/019fc987-16c3-7159-938c-864735d501d9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJaW6MmULwwIcRLjt_zW2kJ2A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_c317c495-6710-44d6-8d4f-a1f749902bbb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "custom",
      "poi_name": "Lula Southern Cookhouse",
      "poi_type": "Restaurants",
      "poi_address": "1617 Main St Ste 100, Kansas City, MO 64108, USA",
      "poi_short_description": "Relaxed, family-friendly eatery dishing up southern classics such as fried chicken and catfish alongside cocktails.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b665-0bd8-704e-b14d-181bae3afe7e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b665-0bd8-704e-b14d-181bae3afe7e",
        "storage_key": "property/6767906449167610/01a0b665-0bd8-704e-b14d-181bae3afe7e.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.lulakc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9766021219343966854&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lula-southern-cookhouse",
      "poi_latitude": "39.0938064",
      "poi_longitude": "-94.5831797",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 816-648-0808",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc987-16c3-7159-938c-864735d501d9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-16c3-7159-938c-864735d501d9",
        "storage_key": "property/6767906449167610/019fc987-16c3-7159-938c-864735d501d9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJjYzOm8rxwIcRhqLsb47gh4c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_bfd3fee1-6b15-4f5b-9ef5-0119ffc85a22",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "custom",
      "poi_name": "Extra Virgin",
      "poi_type": "Restaurants",
      "poi_address": "1900 Main St, Kansas City, MO 64108, USA",
      "poi_short_description": "Well-known spot for inventive Mediterranean tapas in lively, festive digs with a streetside patio.",
      "poi_long_description": "Well-known spot for inventive Mediterranean tapas in lively, festive digs with a streetside patio.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc98c-dfcd-714d-bbf7-6c8e47e59208.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98c-dfcd-714d-bbf7-6c8e47e59208",
        "storage_key": "property/6767906449167610/019fc98c-dfcd-714d-bbf7-6c8e47e59208.webp",
        "width": 720,
        "height": 480
      },
      "poi_business_url": "http://www.extravirginkc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6321131323208913767&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "extra-virgin",
      "poi_latitude": "39.0902121",
      "poi_longitude": "-94.5840456",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 816-842-2205",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc987-16c3-7159-938c-864735d501d9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-16c3-7159-938c-864735d501d9",
        "storage_key": "property/6767906449167610/019fc987-16c3-7159-938c-864735d501d9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJXZaq9kHwwIcRZ1N2mnIruVc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mediterranean_restaurant"
    },
    {
      "id": "custom_e4c2375a-9009-42c9-aaf9-568e855a71dd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "custom",
      "poi_name": "The Rieger Hotel - 3 Bedroom Condo w/ Rooftop",
      "poi_type": "Restaurants",
      "poi_address": "Kansas City, MO 64108, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10763502980371541674&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-rieger-hotel---3-bedroom-condo-w-rooftop",
      "poi_latitude": "39.0894814",
      "poi_longitude": "-94.5839996",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b665-403e-74bc-bd81-867d93b53029.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0b665-403e-74bc-bd81-867d93b53029",
        "storage_key": "property/6767906449167610/01a0b665-403e-74bc-bd81-867d93b53029.webp",
        "width": 192,
        "height": 122
      },
      "poi_google_place_id": "ChIJScMuHmrwwIcRqm7n4-6kX5U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "lodging"
    },
    {
      "id": "custom_32e8ab92-3ccf-47d8-825e-d06310793186",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "custom",
      "poi_name": "Jack Stack Barbecue - Freight House",
      "poi_type": "Restaurants",
      "poi_address": "101 W 22nd St, Kansas City, MO 64108, USA",
      "poi_short_description": "Bustling local chain known for its vast barbecue menu encompassing steak & seafood.",
      "poi_long_description": "Bustling local chain known for its vast barbecue menu encompassing steak & seafood.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b65f-2c3d-75c8-9da5-6c217da1f78f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b65f-2c3d-75c8-9da5-6c217da1f78f",
        "storage_key": "property/6767906449167610/01a0b65f-2c3d-75c8-9da5-6c217da1f78f.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.jackstackbbq.com/?olonwp=JjBtp_vMLk25gkYh_bnoiQ",
      "poi_directions_map_url": "https://maps.google.com/?cid=14717886139068817346&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jack-stack-barbecue---freight-house",
      "poi_latitude": "39.0875678",
      "poi_longitude": "-94.5850052",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 816-472-7427",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc987-16c3-7159-938c-864735d501d9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-16c3-7159-938c-864735d501d9",
        "storage_key": "property/6767906449167610/019fc987-16c3-7159-938c-864735d501d9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJmzokTUDwwIcRwp_X-3ZvQMw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_e9f839be-0754-4d19-902e-16219da5adb6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "custom",
      "poi_name": "Lidia’s",
      "poi_type": "Restaurants",
      "poi_address": "101 W 22nd St, Kansas City, MO 64108, USA",
      "poi_short_description": "Celebrated upscale spot for Northern Italian dining in a glitzy locale with blown-glass chandeliers.",
      "poi_long_description": "Celebrated upscale spot for Northern Italian dining in a glitzy locale with blown-glass chandeliers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc98c-e0ec-7187-963b-44e3a2d7cb2f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98c-e0ec-7187-963b-44e3a2d7cb2f",
        "storage_key": "property/6767906449167610/019fc98c-e0ec-7187-963b-44e3a2d7cb2f.webp",
        "width": 640,
        "height": 480
      },
      "poi_business_url": "http://www.lidias-kc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14489280469360899567&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lidias",
      "poi_latitude": "39.0877163",
      "poi_longitude": "-94.5847287",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 816-221-3722",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc987-16c3-7159-938c-864735d501d9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-16c3-7159-938c-864735d501d9",
        "storage_key": "property/6767906449167610/019fc987-16c3-7159-938c-864735d501d9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJmzokTUDwwIcR7_VCw9FDFMk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_6e6e8d22-cf13-4d2d-a110-a4215c69eeb3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "custom",
      "poi_name": "Mildred's Food + Drink",
      "poi_type": "Restaurants",
      "poi_address": "1901 Wyandotte St, Kansas City, MO 64108, USA",
      "poi_short_description": "Laid-back cafe serving espresso drinks & breakfast & lunch sandwiches, plus salads.",
      "poi_long_description": "Laid-back cafe serving espresso drinks & breakfast & lunch sandwiches, plus salads.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b665-0c31-7377-8f49-34e7bd6bee9c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b665-0c31-7377-8f49-34e7bd6bee9c",
        "storage_key": "property/6767906449167610/01a0b665-0c31-7377-8f49-34e7bd6bee9c.webp",
        "width": 1024,
        "height": 683
      },
      "poi_business_url": "http://www.mildredskc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7430117393546909237&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mildreds-food--drink",
      "poi_latitude": "39.0908134",
      "poi_longitude": "-94.5858474",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 816-507-6837",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc992-e8b3-74cc-b95e-37c8319e6baa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc992-e8b3-74cc-b95e-37c8319e6baa",
        "storage_key": "property/6767906449167610/019fc992-e8b3-74cc-b95e-37c8319e6baa.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJWRbZzUPwwIcRNZbQKWcUHWc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "custom_011f4e98-ba52-4f4c-a926-c24514df8177",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "921 Main St, Kansas City, MO 64105, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019ff6ad-2cdf-71db-b8eb-19dac7b167fb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6ad-2cdf-71db-b8eb-19dac7b167fb",
        "storage_key": "property/6767906449167610/019ff6ad-2cdf-71db-b8eb-19dac7b167fb.webp",
        "width": 1000,
        "height": 667
      },
      "poi_business_url": "https://www.cvs.com/store-locator/kansas-city-mo-pharmacies/921-main-street-kansas-city-mo-64105/storeid=8592?WT.mc_id=LS_GOOGLE_RX_8592",
      "poi_directions_map_url": "https://maps.google.com/?cid=3354058715846669665&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "39.10253429999999",
      "poi_longitude": "-94.5829035",
      "poi_miles_from_property": "0.04",
      "poi_walking_minutes": "1 min",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 816-842-2514",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019ff6ad-9539-7399-9315-3fa4ae755ee6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6ad-9539-7399-9315-3fa4ae755ee6",
        "storage_key": "property/6767906449167610/019ff6ad-9539-7399-9315-3fa4ae755ee6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJiWb6m2DwwIcRYfXXqaECjC4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_e4882344-03ec-4df5-b3b9-edc86f249583",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "custom",
      "poi_name": "In-N-Out Store",
      "poi_type": "Shopping & Retail",
      "poi_address": "5510 Prospect Ave, Kansas City, MO 64130, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=9076765353601411331&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "in-n-out-store",
      "poi_latitude": "39.02615",
      "poi_longitude": "-94.55535",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 816-569-6070",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc987-16c2-74ef-983a-beeea44ef193.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-16c2-74ef-983a-beeea44ef193",
        "storage_key": "property/6767906449167610/019fc987-16c2-74ef-983a-beeea44ef193.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ88Nb-3jlwIcRAyn8kv8l930",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_9b4a74f6-5b0e-4a6b-b87b-5327ca0c18ec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "custom",
      "poi_name": "Cosentino's Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "10 E 13th St, Kansas City, MO 64106, USA",
      "poi_short_description": "Downtown eatery and market carrying staples, organic produce and deli salads to go.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc98d-93bc-7627-a92d-e0445afc2139.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98d-93bc-7627-a92d-e0445afc2139",
        "storage_key": "property/6767906449167610/019fc98d-93bc-7627-a92d-e0445afc2139.webp",
        "width": 1280,
        "height": 869
      },
      "poi_business_url": "http://cosentinos.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4624231086112210795&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cosentinos-market",
      "poi_latitude": "39.0986917",
      "poi_longitude": "-94.5831143",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 816-595-0050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc987-16c3-7159-938c-8a66b159188b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-16c3-7159-938c-8a66b159188b",
        "storage_key": "property/6767906449167610/019fc987-16c3-7159-938c-8a66b159188b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9cy7gF3wwIcRa38JL6yRLEA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_63087cd2-df78-4ddf-8268-9909fb102d3b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "custom",
      "poi_name": "City Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "20 E 5th St, Kansas City, MO 64106, USA",
      "poi_short_description": "Airy market with indoor/outdoor stands of produce, baked goods, spices, flowers, crafts & jewelry.",
      "poi_long_description": "Airy market with indoor/outdoor stands of produce, baked goods, spices, flowers, crafts & jewelry.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b665-0ee1-7272-bab5-1ff8fb019a88.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b665-0ee1-7272-bab5-1ff8fb019a88",
        "storage_key": "property/6767906449167610/01a0b665-0ee1-7272-bab5-1ff8fb019a88.webp",
        "width": 1280,
        "height": 753
      },
      "poi_business_url": "http://thecitymarketkc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13752651509944153819&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "city-market",
      "poi_latitude": "39.1090172",
      "poi_longitude": "-94.5822776",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 816-842-1271",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc987-16c2-74ef-983a-beeea44ef193.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-16c2-74ef-983a-beeea44ef193",
        "storage_key": "property/6767906449167610/019fc987-16c2-74ef-983a-beeea44ef193.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJxzC42YrwwIcR2_b1Aa87274",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "market"
    },
    {
      "id": "custom_44238451-9daf-453b-a8d0-e7a09095bbb7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "custom",
      "poi_name": "Carollo's Grocery & Deli",
      "poi_type": "Restaurants",
      "poi_address": "9 E 3rd St, Kansas City, MO 64106, USA",
      "poi_short_description": "Italian specialties such as cannoli, gelato, and sandwiches offered in a grocery store setting.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019ff6ad-4258-7386-87fe-b58561817819.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6ad-4258-7386-87fe-b58561817819",
        "storage_key": "property/6767906449167610/019ff6ad-4258-7386-87fe-b58561817819.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.carollosspecialtyitaliangrocery.com/#/",
      "poi_directions_map_url": "https://maps.google.com/?cid=249095598329742208&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carollos-grocery--deli",
      "poi_latitude": "39.1097397",
      "poi_longitude": "-94.582792",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 816-456-3222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc987-16c2-74ef-983a-beeea44ef193.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-16c2-74ef-983a-beeea44ef193",
        "storage_key": "property/6767906449167610/019fc987-16c2-74ef-983a-beeea44ef193.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJw-FGNIvwwIcRgMOOfSD3dAM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "deli"
    },
    {
      "id": "custom_ebe064ae-6ff9-4d61-9ebe-a8ad64c3d12d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "custom",
      "poi_name": "Shop Local KC",
      "poi_type": "Shopping & Retail",
      "poi_address": "2450 Grand Blvd Ste 209, Kansas City, MO 64108, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b665-133f-767f-81fc-d6c384432c82.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b665-133f-767f-81fc-d6c384432c82",
        "storage_key": "property/6767906449167610/01a0b665-133f-767f-81fc-d6c384432c82.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.shoplocalkc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11002344526323831349&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shop-local-kc",
      "poi_latitude": "39.08269",
      "poi_longitude": "-94.582324",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 816-437-7217",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc987-16c2-74ef-983a-beeea44ef193.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-16c2-74ef-983a-beeea44ef193",
        "storage_key": "property/6767906449167610/019fc987-16c2-74ef-983a-beeea44ef193.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ4yzd-nbxwIcRNdL-ww0usJg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gift_shop"
    },
    {
      "id": "custom_d60cdb82-0bb6-40bf-9be8-19fbf3ba0d30",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "custom",
      "poi_name": "Level One Game Shop",
      "poi_type": "Shopping & Retail",
      "poi_address": "400 Grand Blvd #420, Kansas City, MO 64106, USA",
      "poi_short_description": "Friendly staff at this game store sell new and used tabletop games and miniatures, with space to play them.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b665-12cd-7235-ba1a-f88a1a3b48a1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b665-12cd-7235-ba1a-f88a1a3b48a1",
        "storage_key": "property/6767906449167610/01a0b665-12cd-7235-ba1a-f88a1a3b48a1.webp",
        "width": 1280,
        "height": 767
      },
      "poi_business_url": "http://levelonegameshop.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6138590446979841873&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "level-one-game-shop",
      "poi_latitude": "39.1097417",
      "poi_longitude": "-94.5815956",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 816-482-7702",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc987-16c2-74ef-983a-beeea44ef193.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-16c2-74ef-983a-beeea44ef193",
        "storage_key": "property/6767906449167610/019fc987-16c2-74ef-983a-beeea44ef193.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJP1JQFovwwIcRUf_W5XynMFU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_32df5151-6b63-49f0-a612-419ae0fcf9c4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "custom",
      "poi_name": "Halls Kansas City",
      "poi_type": "Shopping & Retail",
      "poi_address": "2450 Grand Blvd, Kansas City, MO 64108, USA",
      "poi_short_description": "Upscale shopping venue for men's and women's apparel and shoes as well as fragrances and jewelry.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a01010-8ee9-7148-b924-07009d9e2f80.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01010-8ee9-7148-b924-07009d9e2f80",
        "storage_key": "property/6767906449167610/01a01010-8ee9-7148-b924-07009d9e2f80.webp",
        "width": 1000,
        "height": 667
      },
      "poi_business_url": "https://www.halls.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8144936423458074947&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "halls-kansas-city",
      "poi_latitude": "39.08247110000001",
      "poi_longitude": "-94.5824878",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 816-274-3222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc987-16c2-74ef-983a-beeea44ef193.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-16c2-74ef-983a-beeea44ef193",
        "storage_key": "property/6767906449167610/019fc987-16c2-74ef-983a-beeea44ef193.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJQSadeRXwwIcRQ_Fb_oWgCHE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_8362a798-23cf-4266-97f5-294eeaf2ca2c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "custom",
      "poi_name": "Made in KC - Union Station",
      "poi_type": "Shopping & Retail",
      "poi_address": "30 W Pershing Rd, Kansas City, MO 64108, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://madeinkc.co/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12651837875251985228&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "made-in-kc---union-station",
      "poi_latitude": "39.0838419",
      "poi_longitude": "-94.5849511",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 816-225-2489",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc987-16c2-74ef-983a-beeea44ef193.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-16c2-74ef-983a-beeea44ef193",
        "storage_key": "property/6767906449167610/019fc987-16c2-74ef-983a-beeea44ef193.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJdbYYiXLxwIcRTDs65oNblK8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gift_shop"
    },
    {
      "id": "custom_7860a7e2-9cbe-4284-abbd-a3c68ead4543",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "custom",
      "poi_name": "Rocky Mountain Chocolate Factory",
      "poi_type": "Restaurants",
      "poi_address": "Union, 30 W Pershing Rd Ste 130, Kansas City, MO 64108, USA",
      "poi_short_description": "Retailer offering premium chocolate & other confections, plus cocoa & gift baskets.",
      "poi_long_description": "Retailer offering premium chocolate & other confections, plus cocoa & gift baskets.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a01010-9162-7120-909d-4991ab763942.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01010-9162-7120-909d-4991ab763942",
        "storage_key": "property/6767906449167610/01a01010-9162-7120-909d-4991ab763942.webp",
        "width": 636,
        "height": 1280
      },
      "poi_business_url": "https://www.rmcf.com/pages/store-locator?utm_source=google&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=6727994580651352287&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rocky-mountain-chocolate-factory",
      "poi_latitude": "39.0849772",
      "poi_longitude": "-94.5857404",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 816-421-2571",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc987-16c2-74ef-983a-beeea44ef193.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-16c2-74ef-983a-beeea44ef193",
        "storage_key": "property/6767906449167610/019fc987-16c2-74ef-983a-beeea44ef193.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJp391fz_wwIcR3yB6tmyjXl0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chocolate_shop"
    },
    {
      "id": "custom_3b131c23-b335-4dbc-943d-ed701c09ca10",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "custom",
      "poi_name": "Spectrum Station",
      "poi_type": "Education",
      "poi_address": "911 Main St, Kansas City, MO 64105, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc98d-aeca-7569-86e9-cb9a59e08862.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98d-aeca-7569-86e9-cb9a59e08862",
        "storage_key": "property/6767906449167610/019fc98d-aeca-7569-86e9-cb9a59e08862.webp",
        "width": 361,
        "height": 285
      },
      "poi_business_url": "http://www.spectrumstation.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6966800725838265907&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "spectrum-station",
      "poi_latitude": "39.1032382",
      "poi_longitude": "-94.5827285",
      "poi_miles_from_property": "0.09",
      "poi_walking_minutes": "2 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 816-898-6543",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc987-16ea-751a-af0e-9932574e14c5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-16ea-751a-af0e-9932574e14c5",
        "storage_key": "property/6767906449167610/019fc987-16ea-751a-af0e-9932574e14c5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJq86nhmDwwIcRM_6FNFkMr2A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_1b4867bf-7ec4-4a97-ba88-d55e241b46fa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "custom",
      "poi_name": "Crossroads Charter Schools",
      "poi_type": "Education",
      "poi_address": "1011 Central St, Kansas City, MO 64105, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019ff6d6-91c2-724f-a676-e6c5305ef063.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6d6-91c2-724f-a676-e6c5305ef063",
        "storage_key": "property/6767906449167610/019ff6d6-91c2-724f-a676-e6c5305ef063.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://crossroadsschoolskc.org/central-street/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6411766330210918135&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crossroads-charter-schools",
      "poi_latitude": "39.1019416",
      "poi_longitude": "-94.5868335",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 816-221-2600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc987-16ea-751a-af0e-9932574e14c5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-16ea-751a-af0e-9932574e14c5",
        "storage_key": "property/6767906449167610/019fc987-16ea-751a-af0e-9932574e14c5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJLcKsll7wwIcR9x4In4Er-1g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_9b254d87-18c7-472b-a2bc-c6fe2def30ad",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "custom",
      "poi_name": "Crossroads Academy - Quality Hill",
      "poi_type": "Education",
      "poi_address": "1080 Washington St, Kansas City, MO 64105, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019ff6d6-9667-76af-b45b-776ccd7ea8c9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6d6-9667-76af-b45b-776ccd7ea8c9",
        "storage_key": "property/6767906449167610/019ff6d6-9667-76af-b45b-776ccd7ea8c9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://crossroadsschoolskc.org/quality-hill/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1739164144611189564&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crossroads-academy---quality-hill",
      "poi_latitude": "39.1013279",
      "poi_longitude": "-94.5903971",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 816-221-3191",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc987-16ea-751a-af0e-9932574e14c5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-16ea-751a-af0e-9932574e14c5",
        "storage_key": "property/6767906449167610/019fc987-16ea-751a-af0e-9932574e14c5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJU0OrelnwwIcRPGOlNZPAIhg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_c1f7db83-7bd1-40d8-8770-c60e3b695377",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "custom",
      "poi_name": "Crossroads Preparatory Academy",
      "poi_type": "Education",
      "poi_address": "816 Broadway Blvd, Kansas City, MO 64105, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019ff6d6-9590-756d-8ded-64128dcfb28d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6d6-9590-756d-8ded-64128dcfb28d",
        "storage_key": "property/6767906449167610/019ff6d6-9590-756d-8ded-64128dcfb28d.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://crossroadsschoolskc.org/preparatory-academy/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16843612352382056394&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crossroads-preparatory-academy",
      "poi_latitude": "39.10401239999999",
      "poi_longitude": "-94.5884408",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 816-369-0090",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc987-16ea-751a-af0e-9932574e14c5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-16ea-751a-af0e-9932574e14c5",
        "storage_key": "property/6767906449167610/019fc987-16ea-751a-af0e-9932574e14c5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ6W7Sae7xwIcRyjcddjGIwOk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_d869b709-b095-4047-9010-f5bd7d8ddb97",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "custom",
      "poi_name": "Primitivo Garcia Elementary School",
      "poi_type": "Education",
      "poi_address": "1000 W 17 St, Kansas City, MO 64108, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc98d-d0c1-70bf-951b-f2ac69fc68e5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98d-d0c1-70bf-951b-f2ac69fc68e5",
        "storage_key": "property/6767906449167610/019fc98d-d0c1-70bf-951b-f2ac69fc68e5.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://primitivogarcia.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10435885958455630198&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "primitivo-garcia-elementary-school",
      "poi_latitude": "39.0942702",
      "poi_longitude": "-94.595658",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 816-418-8725",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc987-16ea-751a-af0e-9932574e14c5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-16ea-751a-af0e-9932574e14c5",
        "storage_key": "property/6767906449167610/019fc987-16ea-751a-af0e-9932574e14c5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJGVAkzU_wwIcRdhk8zvy205A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_b452fa3c-bac1-4f74-b8a2-df31d13818c1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "custom",
      "poi_name": "Northeast Middle School",
      "poi_type": "Education",
      "poi_address": "4904 Independence Ave, Kansas City, MO 64124, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc98d-c1d1-70f9-b45b-aea65a9a1d8c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98d-c1d1-70f9-b45b-aea65a9a1d8c",
        "storage_key": "property/6767906449167610/019fc98d-c1d1-70f9-b45b-aea65a9a1d8c.webp",
        "width": 1152,
        "height": 1152
      },
      "poi_business_url": "https://www.kcpublicschools.org/northeastmiddle",
      "poi_directions_map_url": "https://maps.google.com/?cid=5789643385490120708&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northeast-middle-school",
      "poi_latitude": "39.1066091",
      "poi_longitude": "-94.523825",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 816-418-3400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc987-16ea-751a-af0e-9932574e14c5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-16ea-751a-af0e-9932574e14c5",
        "storage_key": "property/6767906449167610/019fc987-16ea-751a-af0e-9932574e14c5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJE1jF5v76wIcRBCBU-PvxWFA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_eb10d205-306f-40c3-a75a-b94eac8995a1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "custom",
      "poi_name": "Northeast High School",
      "poi_type": "Education",
      "poi_address": "415 Van Brunt Blvd, Kansas City, MO 64124, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc98d-e3f2-74ea-bf8c-96992433f620.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98d-e3f2-74ea-bf8c-96992433f620",
        "storage_key": "property/6767906449167610/019fc98d-e3f2-74ea-bf8c-96992433f620.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.kcpublicschools.org/Northeast",
      "poi_directions_map_url": "https://maps.google.com/?cid=11420094535967042704&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northeast-high-school",
      "poi_latitude": "39.108404",
      "poi_longitude": "-94.525303",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 816-418-3300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc987-16ea-751a-af0e-9932574e14c5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-16ea-751a-af0e-9932574e14c5",
        "storage_key": "property/6767906449167610/019fc987-16ea-751a-af0e-9932574e14c5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ9Xl8DP_6wIcRkOyxZXlTfJ4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_543c2012-b143-442c-b54b-f87e1897f261",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "custom",
      "poi_name": "Corporate Kids Child Development",
      "poi_type": "Education",
      "poi_address": "601 E 12th St #149, Kansas City, MO 64106, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://corporatekidskc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3507113962666769135&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "corporate-kids-child-development",
      "poi_latitude": "39.0988423",
      "poi_longitude": "-94.5761634",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 816-572-9403",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc987-16ea-751a-af0e-9932574e14c5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-16ea-751a-af0e-9932574e14c5",
        "storage_key": "property/6767906449167610/019fc987-16ea-751a-af0e-9932574e14c5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJh16PQ2TwwIcR77qQS5HFqzA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_50ba3080-39a0-4817-92dc-36e15d691115",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "custom",
      "poi_name": "Park University in Kansas City MO",
      "poi_type": "Education",
      "poi_address": "911 Main St, Kansas City, MO 64105, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc98d-ec8b-77b7-9d78-51016ad8497b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98d-ec8b-77b7-9d78-51016ad8497b",
        "storage_key": "property/6767906449167610/019fc98d-ec8b-77b7-9d78-51016ad8497b.webp",
        "width": 1200,
        "height": 649
      },
      "poi_business_url": "https://www.park.edu/academics/explore-majors-programs/?location=mo-kansas-city",
      "poi_directions_map_url": "https://maps.google.com/?cid=1164686809976618031&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "park-university-in-kansas-city-mo",
      "poi_latitude": "39.10314959999999",
      "poi_longitude": "-94.5826919",
      "poi_miles_from_property": "0.09",
      "poi_walking_minutes": "2 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 816-559-5601",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc987-16ea-751a-af0e-9932574e14c5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-16ea-751a-af0e-9932574e14c5",
        "storage_key": "property/6767906449167610/019fc987-16ea-751a-af0e-9932574e14c5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ-X36gWDwwIcRLzw9n3vMKRA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_3afc009e-7f12-4bc7-b12b-d81085e877ed",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "custom",
      "poi_name": "ArtsTech",
      "poi_type": "Entertainment",
      "poi_address": "1522 Holmes St, Kansas City, MO 64108, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b665-189b-73e7-90ef-42e4d85af034.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b665-189b-73e7-90ef-42e4d85af034",
        "storage_key": "property/6767906449167610/01a0b665-189b-73e7-90ef-42e4d85af034.webp",
        "width": 640,
        "height": 278
      },
      "poi_business_url": "http://www.artstech-kc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9586521421936901841&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "artstech",
      "poi_latitude": "39.0949359",
      "poi_longitude": "-94.5754493",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 816-461-0201",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc987-16d5-776b-b512-3bbd66a5dede.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-16d5-776b-b512-3bbd66a5dede",
        "storage_key": "property/6767906449167610/019fc987-16d5-776b-b512-3bbd66a5dede.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGVKFdG_wwIcR0b44EnEqCoU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "non_profit_organization"
    },
    {
      "id": "custom_7923efaf-33e9-4559-ba40-50b4211d330b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "custom",
      "poi_name": "The Midland Theatre",
      "poi_type": "Entertainment",
      "poi_address": "1228 Main St, Kansas City, MO 64105, USA",
      "poi_short_description": "Historic circa-1927 theater hosting live music & entertainment in an opulent space.",
      "poi_long_description": "Historic circa-1927 theater hosting live music & entertainment in an opulent space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc98e-2e0f-70ad-983c-2597bcfc3eb4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98e-2e0f-70ad-983c-2597bcfc3eb4",
        "storage_key": "property/6767906449167610/019fc98e-2e0f-70ad-983c-2597bcfc3eb4.webp",
        "width": 720,
        "height": 580
      },
      "poi_business_url": "http://www.midlandkc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=519383206880627892&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-midland-theatre",
      "poi_latitude": "39.0988704",
      "poi_longitude": "-94.5839658",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 816-283-9900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc987-16d5-776b-b512-3bbd66a5dede.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-16d5-776b-b512-3bbd66a5dede",
        "storage_key": "property/6767906449167610/019fc987-16d5-776b-b512-3bbd66a5dede.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJk-QNhV3wwIcRtExsXEY4NQc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "custom_3fdfcf84-bb84-48a8-ba9e-c8ecc1376278",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "custom",
      "poi_name": "Folly Theater",
      "poi_type": "Entertainment",
      "poi_address": "300 W 12th St, Kansas City, MO 64105, USA",
      "poi_short_description": "Elegant theater since 1900 showcasing theatrical & musical performances, plus other events.",
      "poi_long_description": "Elegant theater since 1900 showcasing theatrical & musical performances, plus other events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b665-19e0-719f-a247-2da9f55a7c68.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b665-19e0-719f-a247-2da9f55a7c68",
        "storage_key": "property/6767906449167610/01a0b665-19e0-719f-a247-2da9f55a7c68.webp",
        "width": 1280,
        "height": 830
      },
      "poi_business_url": "http://follytheater.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1659353997130338439&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "folly-theater",
      "poi_latitude": "39.100252",
      "poi_longitude": "-94.5872139",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 816-474-4444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc987-16d5-776b-b512-3bbd66a5dede.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-16d5-776b-b512-3bbd66a5dede",
        "storage_key": "property/6767906449167610/019fc987-16d5-776b-b512-3bbd66a5dede.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNxeXGVzwwIcRhxCUM6s1Bxc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_9d73ea7e-260b-4829-90b8-ee986201f8c8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "custom",
      "poi_name": "T-Mobile Center",
      "poi_type": "Entertainment",
      "poi_address": "1407 Grand Blvd, Kansas City, MO 64106, USA",
      "poi_short_description": "Indoor arena with nearly 20,000 seats hosts pro & college sporting events, big-name concerts & more.",
      "poi_long_description": "Indoor arena with nearly 20,000 seats hosts pro & college sporting events, big-name concerts & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc986-cd1c-727f-8e55-a2fe68b6693a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc986-cd1c-727f-8e55-a2fe68b6693a",
        "storage_key": "property/6767906449167610/019fc986-cd1c-727f-8e55-a2fe68b6693a.webp",
        "width": 1280,
        "height": 881
      },
      "poi_business_url": "http://www.t-mobilecenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12445204140955467076&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "t-mobile-center",
      "poi_latitude": "39.0974667",
      "poi_longitude": "-94.5801529",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 816-949-7100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc987-16d5-776b-b512-3bbd66a5dede.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-16d5-776b-b512-3bbd66a5dede",
        "storage_key": "property/6767906449167610/019fc987-16d5-776b-b512-3bbd66a5dede.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJi31tv2fwwIcRRP3eijo_tqw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_f5ba7f02-4e5f-4b5c-a44e-cf82d7b0bbcc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "custom",
      "poi_name": "Kauffman Center for the Performing Arts",
      "poi_type": "Entertainment",
      "poi_address": "1601 Broadway Blvd, Kansas City, MO 64108, USA",
      "poi_short_description": "2 performance halls joined together under a glass dome, hosting music, opera, theater & dance.",
      "poi_long_description": "2 performance halls joined together under a glass dome, hosting music, opera, theater & dance.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019ff6ad-5314-721c-9e7f-2cce6db04aca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6ad-5314-721c-9e7f-2cce6db04aca",
        "storage_key": "property/6767906449167610/019ff6ad-5314-721c-9e7f-2cce6db04aca.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.kauffmancenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6371724031435486048&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kauffman-center-for-the-performing-arts",
      "poi_latitude": "39.0941068",
      "poi_longitude": "-94.5876247",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 816-994-7222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc987-16d5-776b-b512-3bbd66a5dede.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-16d5-776b-b512-3bbd66a5dede",
        "storage_key": "property/6767906449167610/019fc987-16d5-776b-b512-3bbd66a5dede.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ99d4bkPwwIcRYDOIbD_pbFg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_7040d945-da58-4d3d-bc2e-a031f8232055",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "custom",
      "poi_name": "National WWI Museum and Memorial",
      "poi_type": "Entertainment",
      "poi_address": "2 Memorial Dr, Kansas City, MO 64108, USA",
      "poi_short_description": "The nation's only public museum dedicated to WWI, with a large collection of photos, weapons & more.",
      "poi_long_description": "The nation's only public museum dedicated to WWI, with a large collection of photos, weapons & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc986-c66d-7069-bb56-7306de4b8424.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc986-c66d-7069-bb56-7306de4b8424",
        "storage_key": "property/6767906449167610/019fc986-c66d-7069-bb56-7306de4b8424.webp",
        "width": 1280,
        "height": 1071
      },
      "poi_business_url": "https://www.theworldwar.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10469991631701161311&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "national-wwi-museum-and-memorial",
      "poi_latitude": "39.080663",
      "poi_longitude": "-94.5860835",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 816-888-8100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc987-16dc-7429-827a-6d86f109fa8f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-16dc-7429-827a-6d86f109fa8f",
        "storage_key": "property/6767906449167610/019fc987-16dc-7429-827a-6d86f109fa8f.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJpzAyJjzwwIcRXzXcqOrhTJE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_ba197e88-f4d8-4b48-9228-23be7322234d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "custom",
      "poi_name": "Kansas City",
      "poi_type": "Transportation & Transit",
      "poi_address": "30 W Pershing Rd Union Station, Kansas City, MO 64108, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc987-0f70-721d-8401-88c101b02a36.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc987-0f70-721d-8401-88c101b02a36",
        "storage_key": "property/6767906449167610/019fc987-0f70-721d-8401-88c101b02a36.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amtrak.com/servlet/ContentServer?pagename=am/am2Station/Station_Page&code=KCY",
      "poi_directions_map_url": "https://maps.google.com/?cid=3787247529242741214&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kansas-city",
      "poi_latitude": "39.0847966",
      "poi_longitude": "-94.5853578",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 800-872-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc987-194d-758e-a9aa-460ee15f1718.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-194d-758e-a9aa-460ee15f1718",
        "storage_key": "property/6767906449167610/019fc987-194d-758e-a9aa-460ee15f1718.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJxbu2nD_wwIcR3kn96I8BjzQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_bcdc7e55-1bfc-4e55-9d8c-8e533315ad80",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "custom",
      "poi_name": "SEA LIFE Kansas City Aquarium",
      "poi_type": "Entertainment",
      "poi_address": "2475 Grand Blvd Ste 100, Kansas City, MO 64108, USA",
      "poi_short_description": "Family-friendly exhibits featuring more than 5,000 sea creatures, plus a play area & group packages.",
      "poi_long_description": "Family-friendly exhibits featuring more than 5,000 sea creatures, plus a play area & group packages.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019ff6ad-4129-73fa-b7db-0ae0f75f7f68.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6ad-4129-73fa-b7db-0ae0f75f7f68",
        "storage_key": "property/6767906449167610/019ff6ad-4129-73fa-b7db-0ae0f75f7f68.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.visitsealife.com/kansas-city/?utm_source=local-listing&utm_medium=organic&utm_campaign=tickets",
      "poi_directions_map_url": "https://maps.google.com/?cid=5590252280065768693&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sea-life-kansas-city-aquarium",
      "poi_latitude": "39.0820805",
      "poi_longitude": "-94.5812573",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 816-471-4386",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019ff6ad-9537-74eb-8e0b-2666c404c313.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6ad-9537-74eb-8e0b-2666c404c313",
        "storage_key": "property/6767906449167610/019ff6ad-9537-74eb-8e0b-2666c404c313.webp",
        "width": 192,
        "height": 176
      },
      "poi_google_place_id": "ChIJtyRwuxXwwIcR9TwjjtSQlE0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "aquarium"
    },
    {
      "id": "custom_0ec9a087-d2d4-48f5-b48b-dee0df4bfe0c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "custom",
      "poi_name": "The Nelson-Atkins Museum of Art",
      "poi_type": "Entertainment",
      "poi_address": "4525 Oak St, Kansas City, MO 64111, USA",
      "poi_short_description": "Art collection spanning 5,000 years in neoclassical & modern galleries, plus a sculpture garden.",
      "poi_long_description": "Art collection spanning 5,000 years in neoclassical & modern galleries, plus a sculpture garden.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc986-ee36-762d-a8d9-5289c415d2a5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc986-ee36-762d-a8d9-5289c415d2a5",
        "storage_key": "property/6767906449167610/019fc986-ee36-762d-a8d9-5289c415d2a5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.nelson-atkins.org/?utm_source=gmb&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=3122843275976164549&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-nelson-atkins-museum-of-art",
      "poi_latitude": "39.0449506",
      "poi_longitude": "-94.5809284",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 816-751-1278",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc987-16dc-7429-827a-6d86f109fa8f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-16dc-7429-827a-6d86f109fa8f",
        "storage_key": "property/6767906449167610/019fc987-16dc-7429-827a-6d86f109fa8f.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJRSCf3ervwIcRxcTG-WmRVis",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "custom_54d04365-00fb-45dc-b9c4-3b7cdbedbe03",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "custom",
      "poi_name": "Kemper Museum of Contemporary Art",
      "poi_type": "Entertainment",
      "poi_address": "4420 Warwick Blvd, Kansas City, MO 64111, USA",
      "poi_short_description": "Modest museum housing a permanent collection & special exhibitions of challenging contemporary art.",
      "poi_long_description": "Modest museum housing a permanent collection & special exhibitions of challenging contemporary art.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b665-233c-70b3-b9b3-efee3de94018.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b665-233c-70b3-b9b3-efee3de94018",
        "storage_key": "property/6767906449167610/01a0b665-233c-70b3-b9b3-efee3de94018.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.kemperart.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4417124555838519064&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kemper-museum-of-contemporary-art",
      "poi_latitude": "39.04643",
      "poi_longitude": "-94.5851292",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 816-753-5784",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc987-16dc-7429-827a-6d86f109fa8f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-16dc-7429-827a-6d86f109fa8f",
        "storage_key": "property/6767906449167610/019fc987-16dc-7429-827a-6d86f109fa8f.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJjz4brcHvwIcRGPdob2HHTD0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "custom_3d33483e-8d79-498b-b4b9-fe3dd9e899f5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "custom",
      "poi_name": "University Health Truman Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "2301 Holmes St, Kansas City, MO 64108, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc98e-726a-7217-b430-035b4af53f9b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98e-726a-7217-b430-035b4af53f9b",
        "storage_key": "property/6767906449167610/019fc98e-726a-7217-b430-035b4af53f9b.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.universityhealthkc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3094198644431175220&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-health-truman-medical-center",
      "poi_latitude": "39.0841581",
      "poi_longitude": "-94.5752125",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 816-404-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc987-16ec-7256-83e7-f34d3e4f9bd1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-16ec-7256-83e7-f34d3e4f9bd1",
        "storage_key": "property/6767906449167610/019fc987-16ec-7256-83e7-f34d3e4f9bd1.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJidv_PG3wwIcRNL7Q-UXN8Co",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_1f8c3cee-9ff8-48e7-b7e1-a73f380dda55",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "custom",
      "poi_name": "Walgreens Pharmacy at University Health Truman Medical Ctr.",
      "poi_type": "Health and Wellness",
      "poi_address": "2301 Holmes St, Kansas City, MO 64108, USA",
      "poi_short_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_long_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019ff6ad-5a80-7024-802e-88720d630c6a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6ad-5a80-7024-802e-88720d630c6a",
        "storage_key": "property/6767906449167610/019ff6ad-5a80-7024-802e-88720d630c6a.webp",
        "width": 1280,
        "height": 905
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-2301+holmes+st-kansas+city-mo-64108/id=10845",
      "poi_directions_map_url": "https://maps.google.com/?cid=2122014859472525265&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-pharmacy-at-university-health-truman-medical-ctr",
      "poi_latitude": "39.0844879",
      "poi_longitude": "-94.5752976",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 816-471-2072",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019ff6ad-9539-7399-9315-3fa4ae755ee6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6ad-9539-7399-9315-3fa4ae755ee6",
        "storage_key": "property/6767906449167610/019ff6ad-9539-7399-9315-3fa4ae755ee6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ2S-3xLwwIcR0df1kkXpch0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_3852b8e9-df81-48f4-a67b-28d97eb32fc1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "custom",
      "poi_name": "Kirk Family YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "222 W 11th St, Kansas City, MO 64105, USA",
      "poi_short_description": "Clean fitness space offering classes, pools and weight-machine areas.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc986-d84e-724f-9ed2-859ab2cd6f6c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc986-d84e-724f-9ed2-859ab2cd6f6c",
        "storage_key": "property/6767906449167610/019fc986-d84e-724f-9ed2-859ab2cd6f6c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://kansascityymca.org/locations/downtownkc",
      "poi_directions_map_url": "https://maps.google.com/?cid=4676158556010780852&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kirk-family-ymca",
      "poi_latitude": "39.1011617",
      "poi_longitude": "-94.5865972",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 816-842-9622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc987-16d5-776b-b512-3bbd66a5dede.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-16d5-776b-b512-3bbd66a5dede",
        "storage_key": "property/6767906449167610/019fc987-16d5-776b-b512-3bbd66a5dede.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdRvfnJLxwIcRtBhtbG4N5UA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_cbe03ef9-be0d-4e8d-a7a0-db2308d6d566",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "custom",
      "poi_name": "Genesis Health Clubs - Power & Light",
      "poi_type": "Health and Wellness",
      "poi_address": "1261 Main St, Kansas City, MO 64105, USA",
      "poi_short_description": "Spacious, clean gym offering a range of classes, equipment and personal training.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc986-e226-7430-a173-968391fd4028.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc986-e226-7430-a173-968391fd4028",
        "storage_key": "property/6767906449167610/019fc986-e226-7430-a173-968391fd4028.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.genesishealthclubs.com/locations/power-light.html?utm_campaign=search&utm_medium=organic&utm_source=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=5275511582065765821&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "genesis-health-clubs---power--light",
      "poi_latitude": "39.0991682",
      "poi_longitude": "-94.5830873",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 816-268-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc987-16d5-776b-b512-3bbd66a5dede.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-16d5-776b-b512-3bbd66a5dede",
        "storage_key": "property/6767906449167610/019fc987-16d5-776b-b512-3bbd66a5dede.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJb2cpfF3wwIcRvS19QdVhNkk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_f320e356-bc41-4582-927e-fbcb9393f652",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "custom",
      "poi_name": "Metro KC Fitness - Downtown",
      "poi_type": "Health and Wellness",
      "poi_address": "320 E 12th St, Kansas City, MO 64106, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019ff6ad-69bd-72ba-baff-ac09c37b4a8a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6ad-69bd-72ba-baff-ac09c37b4a8a",
        "storage_key": "property/6767906449167610/019ff6ad-69bd-72ba-baff-ac09c37b4a8a.webp",
        "width": 855,
        "height": 1280
      },
      "poi_business_url": "https://metrokcfitness.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14412595682124127148&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "metro-kc-fitness---downtown",
      "poi_latitude": "39.1001221",
      "poi_longitude": "-94.5787922",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 816-895-3200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc987-16d5-776b-b512-3bbd66a5dede.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-16d5-776b-b512-3bbd66a5dede",
        "storage_key": "property/6767906449167610/019fc987-16d5-776b-b512-3bbd66a5dede.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDRZyaJzxwIcRrFtWZGnTA8g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_98026ba7-ad5b-415f-8874-be0d38b3c09c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "custom",
      "poi_name": "Maya Yoga",
      "poi_type": "Health and Wellness",
      "poi_address": "215 W 18th St #200, Kansas City, MO 64108, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019ff6d6-a141-7612-951e-b5a79eee28f7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6d6-a141-7612-951e-b5a79eee28f7",
        "storage_key": "property/6767906449167610/019ff6d6-a141-7612-951e-b5a79eee28f7.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.mayayoga.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1419740360680708652&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "maya-yoga",
      "poi_latitude": "39.0916825",
      "poi_longitude": "-94.5867509",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 816-283-8985",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc987-16ea-751a-af0e-9932574e14c5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-16ea-751a-af0e-9932574e14c5",
        "storage_key": "property/6767906449167610/019fc987-16ea-751a-af0e-9932574e14c5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ2bjjvkPwwIcRLJqo_1XusxM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_2955ed13-077a-466e-bdd9-c2740a6a05be",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "custom",
      "poi_name": "StretchLab Kansas City",
      "poi_type": "Health and Wellness",
      "poi_address": "106 W 11th St, Kansas City, MO 64105, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b665-24c1-708f-9a4a-5d6291e7559a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b665-24c1-708f-9a4a-5d6291e7559a",
        "storage_key": "property/6767906449167610/01a0b665-24c1-708f-9a4a-5d6291e7559a.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "https://www.stretchlab.com/location/kansascity",
      "poi_directions_map_url": "https://maps.google.com/?cid=2995144127809731606&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stretchlab-kansas-city",
      "poi_latitude": "39.100971",
      "poi_longitude": "-94.5843821",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 816-608-3770",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc987-16d5-776b-b512-3bbd66a5dede.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-16d5-776b-b512-3bbd66a5dede",
        "storage_key": "property/6767906449167610/019fc987-16d5-776b-b512-3bbd66a5dede.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJeyOXUibxwIcRFjwyHbfjkCk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "wellness_center"
    },
    {
      "id": "custom_a5ac4888-5225-4d2b-9299-05bd70958c75",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "custom",
      "poi_name": "theGYMkc: River Market",
      "poi_type": "Health and Wellness",
      "poi_address": "407 Grand Blvd, Kansas City, MO 64106, USA",
      "poi_short_description": "Gym offering 24-hour access and a range of equipment, including dumbbells.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc98f-3a69-740c-a49c-a5b726e1d28d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98f-3a69-740c-a49c-a5b726e1d28d",
        "storage_key": "property/6767906449167610/019fc98f-3a69-740c-a49c-a5b726e1d28d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.thegymkc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8762989458295887014&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "thegymkc-river-market",
      "poi_latitude": "39.1094432",
      "poi_longitude": "-94.580378",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 816-960-0502",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc987-16d5-776b-b512-3bbd66a5dede.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-16d5-776b-b512-3bbd66a5dede",
        "storage_key": "property/6767906449167610/019fc987-16d5-776b-b512-3bbd66a5dede.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWXGtYPTwwIcRphQ46HtknHk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_a20236ea-4909-4c50-ab7d-31d8ec8410c3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "custom",
      "poi_name": "Orangetheory Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1706 Baltimore Ave, Kansas City, MO 64108, USA",
      "poi_short_description": "Heart rate-based group workout using cardio and strength-training exercises.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019ff6d6-a4f5-76ea-9017-3f4bd3a52761.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6d6-a4f5-76ea-9017-3f4bd3a52761",
        "storage_key": "property/6767906449167610/019ff6d6-a4f5-76ea-9017-3f4bd3a52761.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.orangetheory.com/en-us/locations/kansas-city-missouri-1167?utm_medium=seo&utm_source=gg&utm_term=corporate&utm_campaign=soci",
      "poi_directions_map_url": "https://maps.google.com/?cid=4872878791804400293&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orangetheory-fitness",
      "poi_latitude": "39.092476",
      "poi_longitude": "-94.5848958",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 816-659-1055",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc987-16d5-776b-b512-3bbd66a5dede.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-16d5-776b-b512-3bbd66a5dede",
        "storage_key": "property/6767906449167610/019fc987-16d5-776b-b512-3bbd66a5dede.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1UhBrhvxwIcRpTIJi3Hxn0M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_b2fb4403-781a-4c86-a941-61cd6189a5d2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "custom",
      "poi_name": "Barney Allis Plaza",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1220 Wyandotte St, Kansas City, MO 64105, USA",
      "poi_short_description": "Tree-lined city plaza with fountains, sculptures & seating areas, plus open green space for events.",
      "poi_long_description": "Tree-lined city plaza with fountains, sculptures & seating areas, plus open green space for events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc990-2fcf-76ad-af01-9132f94ac152.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc990-2fcf-76ad-af01-9132f94ac152",
        "storage_key": "property/6767906449167610/019fc990-2fcf-76ad-af01-9132f94ac152.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.kcconvention.com/venue/barney-allis-plaza/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16067549673991288025&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "barney-allis-plaza",
      "poi_latitude": "39.0991719",
      "poi_longitude": "-94.5866802",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 816-513-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc987-16e1-70bb-8b77-8140aa4cc8a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-16e1-70bb-8b77-8140aa4cc8a5",
        "storage_key": "property/6767906449167610/019fc987-16e1-70bb-8b77-8140aa4cc8a5.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ31Z_SFzwwIcR2bQxiUxn-94",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_3c943a68-c8a6-4b6f-bc59-27ba63ffc224",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "custom",
      "poi_name": "Mulkey Square Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1100 Summit St, Kansas City, MO 64105, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019ff6d6-a97a-749e-8233-5ae7c67ecac0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6d6-a97a-749e-8233-5ae7c67ecac0",
        "storage_key": "property/6767906449167610/019ff6d6-a97a-749e-8233-5ae7c67ecac0.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://kcparks.org/places/mulkey-square/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17646417750968350706&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mulkey-square-park",
      "poi_latitude": "39.0985023",
      "poi_longitude": "-94.5944858",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc987-16e1-70bb-8b77-8140aa4cc8a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-16e1-70bb-8b77-8140aa4cc8a5",
        "storage_key": "property/6767906449167610/019fc987-16e1-70bb-8b77-8140aa4cc8a5.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJYYvX5oLxwIcR8redJHOr5PQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_0e083aee-88c1-4eeb-a3a3-ed695fdb246d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "custom",
      "poi_name": "The Kansas City Public Library: Central Library",
      "poi_type": "Education",
      "poi_address": "14 W 10th St, Kansas City, MO 64105, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc986-9714-7609-a9ba-4d4dd1ffe8c3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc986-9714-7609-a9ba-4d4dd1ffe8c3",
        "storage_key": "property/6767906449167610/019fc986-9714-7609-a9ba-4d4dd1ffe8c3.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.kclibrary.org/central",
      "poi_directions_map_url": "https://maps.google.com/?cid=649253124474496512&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-kansas-city-public-library-central-library",
      "poi_latitude": "39.1026894",
      "poi_longitude": "-94.5838852",
      "poi_miles_from_property": "0.1",
      "poi_walking_minutes": "3 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 816-701-3400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc987-16da-77ed-b10d-1e415dabcd5c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-16da-77ed-b10d-1e415dabcd5c",
        "storage_key": "property/6767906449167610/019fc987-16da-77ed-b10d-1e415dabcd5c.webp",
        "width": 192,
        "height": 174
      },
      "poi_google_place_id": "ChIJsZKiPV7wwIcRAGad3UacAgk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_5d046c41-b5f4-492a-88d9-646b0f2a3ae2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "custom",
      "poi_name": "Berkley Riverfront",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "950 Riverfront Dr, Kansas City, MO 64120, USA",
      "poi_short_description": "Downtown green space along the Missouri River features broad biking & walking paths & open fields.",
      "poi_long_description": "Downtown green space along the Missouri River features broad biking & walking paths & open fields.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc987-01d4-71bd-996c-9e9fef99c9d8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc987-01d4-71bd-996c-9e9fef99c9d8",
        "storage_key": "property/6767906449167610/019fc987-01d4-71bd-996c-9e9fef99c9d8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://berkleyriverfront.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3315902073752463479&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "berkley-riverfront",
      "poi_latitude": "39.1168217",
      "poi_longitude": "-94.5726106",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 816-559-3750",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc987-16e1-70bb-8b77-8140aa4cc8a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-16e1-70bb-8b77-8140aa4cc8a5",
        "storage_key": "property/6767906449167610/019fc987-16e1-70bb-8b77-8140aa4cc8a5.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJV2yvAJDwwIcRdyj_H15zBC4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_1a2d4b4a-c51f-42d5-8ffa-417835d9fca0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "custom",
      "poi_name": "Penn Valley Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "West 29th Street, Broadway Blvd, Kansas City, MO 64108, USA",
      "poi_short_description": "Park with the National WWI Museum & Memorial, a theater & tennis, baseball & skateboarding venues.",
      "poi_long_description": "Park with the National WWI Museum & Memorial, a theater & tennis, baseball & skateboarding venues.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc987-02f7-7392-9d7f-d0e260f770a6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc987-02f7-7392-9d7f-d0e260f770a6",
        "storage_key": "property/6767906449167610/019fc987-02f7-7392-9d7f-d0e260f770a6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://kcparks.org/places/penn-valley-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15561286278733833014&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "penn-valley-park",
      "poi_latitude": "39.0757432",
      "poi_longitude": "-94.588766",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 816-513-7500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc987-16e1-70bb-8b77-8140aa4cc8a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-16e1-70bb-8b77-8140aa4cc8a5",
        "storage_key": "property/6767906449167610/019fc987-16e1-70bb-8b77-8140aa4cc8a5.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJYcMmnDvwwIcRNiMXXGzL9Nc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_cb03286b-da4b-438a-92c9-51c66e823c21",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "custom",
      "poi_name": "City Market Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "300-398 Main St, Kansas City, MO 64105, USA",
      "poi_short_description": "City Market park featuring produce vendors, live music, restaurants, and local artists.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019ff6d6-a8c4-75d9-9e7c-c3cbfcda68c4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6d6-a8c4-75d9-9e7c-c3cbfcda68c4",
        "storage_key": "property/6767906449167610/019ff6d6-a8c4-75d9-9e7c-c3cbfcda68c4.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=16153869327600272507&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "city-market-park",
      "poi_latitude": "39.1095212",
      "poi_longitude": "-94.5835627",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 832-423-4921",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc987-16e1-70bb-8b77-8140aa4cc8a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-16e1-70bb-8b77-8140aa4cc8a5",
        "storage_key": "property/6767906449167610/019fc987-16e1-70bb-8b77-8140aa4cc8a5.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJCZ76zvTwwIcRe0SxC5ESLuA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_03f83934-8f9f-4e58-b172-1611dfdd15e6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "custom",
      "poi_name": "Riverfront Park Boat Ramp",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Riverfront Dr, Kansas City, MO 64120, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b665-2727-74eb-94cc-1c7d6aa4277b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b665-2727-74eb-94cc-1c7d6aa4277b",
        "storage_key": "property/6767906449167610/01a0b665-2727-74eb-94cc-1c7d6aa4277b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://kcparks.org/park/riverfront-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6116440279439183151&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "riverfront-park-boat-ramp",
      "poi_latitude": "39.1373668",
      "poi_longitude": "-94.5421107",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 816-513-7500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc987-16d5-776b-b512-3bbd66a5dede.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-16d5-776b-b512-3bbd66a5dede",
        "storage_key": "property/6767906449167610/019fc987-16d5-776b-b512-3bbd66a5dede.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJzxiZ3hf6wIcRLw3dIQf24VQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_aab6544a-b081-4d80-ae3d-b3c619f48522",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "custom",
      "poi_name": "Mill Creek Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "W 43rd St &, Broadway Blvd, Kansas City, MO 64111, USA",
      "poi_short_description": "Relaxed outdoor spot featuring a circular walking track and a fountain, plus an array of workout equipment.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b665-291b-7759-b893-8fa3e123a6ab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b665-291b-7759-b893-8fa3e123a6ab",
        "storage_key": "property/6767906449167610/01a0b665-291b-7759-b893-8fa3e123a6ab.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://kcparks.org/places/mill-creek-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=488052792635368784&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mill-creek-park",
      "poi_latitude": "39.0460414",
      "poi_longitude": "-94.5883526",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 816-513-7500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc987-16e1-70bb-8b77-8140aa4cc8a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-16e1-70bb-8b77-8140aa4cc8a5",
        "storage_key": "property/6767906449167610/019fc987-16e1-70bb-8b77-8140aa4cc8a5.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2_VoTU3vwIcRUCWr2G3pxQY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_83a9fccc-84b3-48a4-9bc8-0d66e21ed338",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "custom",
      "poi_name": "Library (9th & Main St)",
      "poi_type": "Transportation & Transit",
      "poi_address": "Kansas City, MO 64105, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019ff6ad-6f2b-76cb-8b19-ed5d99e9163b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6ad-6f2b-76cb-8b19-ed5d99e9163b",
        "storage_key": "property/6767906449167610/019ff6ad-6f2b-76cb-8b19-ed5d99e9163b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://kcstreetcar.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7193222836045595963&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "library-9th--main-st",
      "poi_latitude": "39.10301279999999",
      "poi_longitude": "-94.5831955",
      "poi_miles_from_property": "0.02",
      "poi_walking_minutes": "1 min",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc992-e974-74e4-9494-80c5e45a2481.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc992-e974-74e4-9494-80c5e45a2481",
        "storage_key": "property/6767906449167610/019fc992-e974-74e4-9494-80c5e45a2481.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJgY_FgWDwwIcRO8W53A5202M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tram_stop"
    },
    {
      "id": "custom_daa6db6c-ee75-45bb-9415-a886ca22fe74",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "custom",
      "poi_name": "On 10th at Main Eastbound",
      "poi_type": "Transportation & Transit",
      "poi_address": "Kansas City, MO 64105, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b665-2b19-7418-97e6-b2bcc914b99a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b665-2b19-7418-97e6-b2bcc914b99a",
        "storage_key": "property/6767906449167610/01a0b665-2b19-7418-97e6-b2bcc914b99a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=2686118896958968144&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "on-10th-at-main-eastbound",
      "poi_latitude": "39.102273",
      "poi_longitude": "-94.583122",
      "poi_miles_from_property": "0.02",
      "poi_walking_minutes": "1 min",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc992-e974-74e4-9494-80c5e45a2481.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc992-e974-74e4-9494-80c5e45a2481",
        "storage_key": "property/6767906449167610/019fc992-e974-74e4-9494-80c5e45a2481.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJB1F_H17wwIcRUBG0tecCRyU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_a01e45ad-632b-4c6e-9ec6-b7da76917d7d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "custom",
      "poi_name": "Power & Light (14th & Main St)",
      "poi_type": "Transportation & Transit",
      "poi_address": "Kansas City, MO 64105, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019ff6ad-7837-778b-b5b2-c67cd371b35f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6ad-7837-778b-b5b2-c67cd371b35f",
        "storage_key": "property/6767906449167610/019ff6ad-7837-778b-b5b2-c67cd371b35f.webp",
        "width": 1280,
        "height": 914
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11422164513129239605&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "power--light-14th--main-st",
      "poi_latitude": "39.0967741",
      "poi_longitude": "-94.5834221",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc992-e974-74e4-9494-80c5e45a2481.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc992-e974-74e4-9494-80c5e45a2481",
        "storage_key": "property/6767906449167610/019fc992-e974-74e4-9494-80c5e45a2481.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJG8iDXl3wwIcRNRQkgxuug54",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tram_stop"
    },
    {
      "id": "custom_c0829c18-ed22-43b4-bfc1-f8fa2a85c7ad",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "custom",
      "poi_name": "Power & Light on Main at 14th St SB",
      "poi_type": "Transportation & Transit",
      "poi_address": "Kansas City, MO 64106, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b665-2b6f-779f-83ad-fa4b02610b28.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b665-2b6f-779f-83ad-fa4b02610b28",
        "storage_key": "property/6767906449167610/01a0b665-2b6f-779f-83ad-fa4b02610b28.webp",
        "width": 1024,
        "height": 685
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11765774767497972322&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "power--light-on-main-at-14th-st-sb",
      "poi_latitude": "39.0969084",
      "poi_longitude": "-94.5832458",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc992-e974-74e4-9494-80c5e45a2481.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc992-e974-74e4-9494-80c5e45a2481",
        "storage_key": "property/6767906449167610/019fc992-e974-74e4-9494-80c5e45a2481.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6QJiYF3wwIcRYor4M9BtSKM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tram_stop"
    },
    {
      "id": "custom_8173c199-e69e-4e84-85bc-cd337c601157",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "custom",
      "poi_name": "Greyhound: Bus Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "1101 Troost Ave, Kansas City, MO 64106, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019ff6ad-75db-70c7-b9e2-20e6fe4a6209.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6ad-75db-70c7-b9e2-20e6fe4a6209",
        "storage_key": "property/6767906449167610/019ff6ad-75db-70c7-b9e2-20e6fe4a6209.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.greyhound.com/bus/kansas-city-mo/kansas-city-bus-station?utm_source=google_maps&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=16685443334022975407&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "greyhound-bus-station",
      "poi_latitude": "39.1000335",
      "poi_longitude": "-94.5693013",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 800-231-2222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc987-16d5-776b-b512-3bbd66a5dede.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-16d5-776b-b512-3bbd66a5dede",
        "storage_key": "property/6767906449167610/019fc987-16d5-776b-b512-3bbd66a5dede.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWy-YvXvwwIcRr09ZHE-ajuc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_54a812e1-3fdb-45dc-860d-5cb2582acec9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "custom",
      "poi_name": "RideKC Streetcar",
      "poi_type": "Transportation & Transit",
      "poi_address": "Kansas City, MO 64106, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019ff6ad-6c93-75bf-a4f8-d427af4f0480.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6ad-6c93-75bf-a4f8-d427af4f0480",
        "storage_key": "property/6767906449167610/019ff6ad-6c93-75bf-a4f8-d427af4f0480.webp",
        "width": 1280,
        "height": 959
      },
      "poi_business_url": "http://kcstreetcar.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14607043082411620649&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ridekc-streetcar",
      "poi_latitude": "39.1084242",
      "poi_longitude": "-94.582015",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 816-627-2527",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc987-16d5-776b-b512-3bbd66a5dede.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-16d5-776b-b512-3bbd66a5dede",
        "storage_key": "property/6767906449167610/019fc987-16d5-776b-b512-3bbd66a5dede.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ95W1BQDxwIcRKbn4wUqktso",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_e06b7b0f-c06e-4818-8ed2-3d5a38d50a72",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "custom",
      "poi_name": "Kansas City International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "1 Kansas City Blvd, Kansas City, MO 64153, USA",
      "poi_short_description": "Airport featuring domestic & global flights plus free WiFi & a variety of eateries.",
      "poi_long_description": "Airport featuring domestic & global flights plus free WiFi & a variety of eateries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc991-19c9-758f-b8bb-2323cb419055.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc991-19c9-758f-b8bb-2323cb419055",
        "storage_key": "property/6767906449167610/019fc991-19c9-758f-b8bb-2323cb419055.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.flykc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14109162014977743520&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kansas-city-international-airport",
      "poi_latitude": "39.3013901",
      "poi_longitude": "-94.7104232",
      "poi_miles_from_property": "20.9",
      "poi_walking_minutes": "7 hours 49 mins",
      "poi_biking_minutes": "2 hours 40 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 816-243-5237",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc987-1946-72be-88ec-c7c07f33b45c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-1946-72be-88ec-c7c07f33b45c",
        "storage_key": "property/6767906449167610/019fc987-1946-72be-88ec-c7c07f33b45c.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJmYfmiAhewIcRoNouXRnQzcM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_836dbaa1-6a7f-4f83-873e-3d51e9c87318",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "custom",
      "poi_name": "H&R Block",
      "poi_type": "Major Employers & Offices",
      "poi_address": "One H and R, Block Way, Kansas City, MO 64105, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc991-50cb-72fa-a350-5e805c994e8f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc991-50cb-72fa-a350-5e805c994e8f",
        "storage_key": "property/6767906449167610/019fc991-50cb-72fa-a350-5e805c994e8f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.hrblock.com/tax-offices/local/missouri-tax-preparation/kansas-city-tax-professionals/?otppartnerid=9308&campaignid=pw_mcm_9308_9762&utm_medium=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=17520317420083081084&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hr-block",
      "poi_latitude": "39.0982642",
      "poi_longitude": "-94.5829906",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 816-854-5500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc987-16d5-776b-b512-3bbd66a5dede.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-16d5-776b-b512-3bbd66a5dede",
        "storage_key": "property/6767906449167610/019fc987-16d5-776b-b512-3bbd66a5dede.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJB8i63JCKwIcRfO8j8N2rJPM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "consultant"
    },
    {
      "id": "custom_3345b771-8779-44a4-9968-07668c366ff7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "custom",
      "poi_name": "Federal Reserve Bank of Kansas City",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1 Memorial Dr, Kansas City, MO 64198, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019ff6ad-81a1-722b-b6f2-d9937d82db4c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6ad-81a1-722b-b6f2-d9937d82db4c",
        "storage_key": "property/6767906449167610/019ff6ad-81a1-722b-b6f2-d9937d82db4c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.kansascityfed.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17710993233906432888&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "federal-reserve-bank-of-kansas-city",
      "poi_latitude": "39.0753294",
      "poi_longitude": "-94.5858203",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 800-333-1010",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc987-194e-73e1-bdf2-fd8dee85cc49.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-194e-73e1-bdf2-fd8dee85cc49",
        "storage_key": "property/6767906449167610/019fc987-194e-73e1-bdf2-fd8dee85cc49.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJa9xf5TzwwIcRePtWZoIWyvU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "finance"
    },
    {
      "id": "custom_e7020672-0925-4a84-a6d9-0dba333e483c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "custom",
      "poi_name": "Hallmark Corporate",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2501 McGee St, Kansas City, MO 64108, USA",
      "poi_short_description": "Retail chain specializing in greeting cards, gift wrap, ornaments & gifts for all occasions.",
      "poi_long_description": "Retail chain specializing in greeting cards, gift wrap, ornaments & gifts for all occasions.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc987-07fe-73fd-9135-815119e46a4a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc987-07fe-73fd-9135-815119e46a4a",
        "storage_key": "property/6767906449167610/019fc987-07fe-73fd-9135-815119e46a4a.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://corporate.hallmark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1199437302719612463&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hallmark-corporate",
      "poi_latitude": "39.0811114",
      "poi_longitude": "-94.5800029",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 800-425-5627",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc987-16d5-776b-b512-3bbd66a5dede.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-16d5-776b-b512-3bbd66a5dede",
        "storage_key": "property/6767906449167610/019fc987-16d5-776b-b512-3bbd66a5dede.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjzp5phbwwIcRL4b0Nt9BpRA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_186992c0-ff39-466e-8b23-3cc25c728851",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "custom",
      "poi_name": "Children's Mercy Adele Hall Campus",
      "poi_type": "Health and Wellness",
      "poi_address": "2401 Gillham Rd, Kansas City, MO 64108, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc986-fd17-71f9-98a4-eee2c7cbad32.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc986-fd17-71f9-98a4-eee2c7cbad32",
        "storage_key": "property/6767906449167610/019fc986-fd17-71f9-98a4-eee2c7cbad32.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.childrensmercy.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=241680805565643787&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "childrens-mercy-adele-hall-campus",
      "poi_latitude": "39.08387889999999",
      "poi_longitude": "-94.5771759",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 816-234-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc987-16ec-7256-83e7-f34d3e4f9bd1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-16ec-7256-83e7-f34d3e4f9bd1",
        "storage_key": "property/6767906449167610/019fc987-16ec-7256-83e7-f34d3e4f9bd1.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9zZsZRPwwIcRCzzFhGmfWgM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_8117344a-1a46-46e8-847d-4a8148a571c1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "custom",
      "poi_name": "One Kansas City Place",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1200 Main St, Kansas City, MO 64105, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc987-0c67-72f0-b50f-8c5af2f48e65.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc987-0c67-72f0-b50f-8c5af2f48e65",
        "storage_key": "property/6767906449167610/019fc987-0c67-72f0-b50f-8c5af2f48e65.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=3149406623585977414&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "one-kansas-city-place",
      "poi_latitude": "39.0997374",
      "poi_longitude": "-94.5833889",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc987-16d5-776b-b512-3bbd66a5dede.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-16d5-776b-b512-3bbd66a5dede",
        "storage_key": "property/6767906449167610/019fc987-16d5-776b-b512-3bbd66a5dede.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXfG48l3wwIcRRsQaTKPwtCs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_cda6006c-d9e3-4dcd-9fed-227aa2db7524",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "custom",
      "poi_name": "Andrews McMeel Universal",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1130 Walnut St, Kansas City, MO 64106, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b665-32e9-70f8-a2c4-f9be39a403d6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b665-32e9-70f8-a2c4-f9be39a403d6",
        "storage_key": "property/6767906449167610/01a0b665-32e9-70f8-a2c4-f9be39a403d6.webp",
        "width": 939,
        "height": 1280
      },
      "poi_business_url": "http://www.amuniversal.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4686093680508147994&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "andrews-mcmeel-universal",
      "poi_latitude": "39.1000592",
      "poi_longitude": "-94.5822698",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 816-581-7500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc987-16d5-776b-b512-3bbd66a5dede.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-16d5-776b-b512-3bbd66a5dede",
        "storage_key": "property/6767906449167610/019fc987-16d5-776b-b512-3bbd66a5dede.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJVh4RGfwwIcRGhnk2l9ZCEE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f3eca367-745b-4534-82fc-dc739d9efef4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "custom",
      "poi_name": "Shook, Hardy & Bacon L.L.P.",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2555 Grand Blvd, Kansas City, MO 64108, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b665-35f0-72ef-baa0-12704a093bdc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b665-35f0-72ef-baa0-12704a093bdc",
        "storage_key": "property/6767906449167610/01a0b665-35f0-72ef-baa0-12704a093bdc.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.shb.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7919548204795275217&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shook-hardy--bacon-llp",
      "poi_latitude": "39.0798302",
      "poi_longitude": "-94.5827487",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 816-474-6550",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc987-16d5-776b-b512-3bbd66a5dede.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-16d5-776b-b512-3bbd66a5dede",
        "storage_key": "property/6767906449167610/019fc987-16d5-776b-b512-3bbd66a5dede.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJzZDs9T3wwIcR0adn-CHj520",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "consultant"
    },
    {
      "id": "custom_b257edf8-7491-4a27-86ad-2d6473b375ae",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "custom",
      "poi_name": "Kansas City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Kansas City City Hall, 414 E 12th St, Kansas City, MO 64106, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc987-07b0-7479-9e54-bf37b650bdd5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc987-07b0-7479-9e54-bf37b650bdd5",
        "storage_key": "property/6767906449167610/019fc987-07b0-7479-9e54-bf37b650bdd5.webp",
        "width": 781,
        "height": 1280
      },
      "poi_business_url": "http://www.kcmo.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16264843786418924934&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kansas-city-hall",
      "poi_latitude": "39.1008473",
      "poi_longitude": "-94.5780724",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 816-513-3600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc987-194e-73e1-bdf2-fd8dee85cc49.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-194e-73e1-bdf2-fd8dee85cc49",
        "storage_key": "property/6767906449167610/019fc987-194e-73e1-bdf2-fd8dee85cc49.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_e-zp2bwwIcRhi24uD9VuOE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_2604c8b8-beed-4dee-81f1-07922a847478",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "custom",
      "poi_name": "Jackson County Courthouse",
      "poi_type": "Major Employers & Offices",
      "poi_address": "415 E 12th St Unit 300, Kansas City, MO 64106, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019ff6ad-832f-7701-8dd5-85a3be6a2af4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6ad-832f-7701-8dd5-85a3be6a2af4",
        "storage_key": "property/6767906449167610/019ff6ad-832f-7701-8dd5-85a3be6a2af4.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.jacksongov.org/Directory.aspx?did=4",
      "poi_directions_map_url": "https://maps.google.com/?cid=1955781323409348683&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jackson-county-courthouse",
      "poi_latitude": "39.0992524",
      "poi_longitude": "-94.5781727",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 816-881-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/019fc987-194e-73e1-bdf2-fd8dee85cc49.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-194e-73e1-bdf2-fd8dee85cc49",
        "storage_key": "property/6767906449167610/019fc987-194e-73e1-bdf2-fd8dee85cc49.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHbRUnWbwwIcRS1goYMBUJBs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "courthouse"
    },
    {
      "id": "custom_08d857d4-d008-415d-90d3-60d051201aaa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "custom",
      "poi_name": "Banksia Bistro",
      "poi_type": "Restaurants",
      "poi_address": "1111 Main St, Kansas City, MO 64105, USA",
      "poi_short_description": "Australian-inspired bistro in the Town Pavilion serving breakfast, lunch, and dinner.",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "false",
      "poi_latitude": "39.100567",
      "poi_longitude": "-94.582838",
      "poi_miles_from_property": "0.1",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "ec_e5cd939134ffe62941211a55",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "day": "MON",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_997b8e1dd73161e7bcfd2637",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "day": "TUE",
      "open_time": "09:30",
      "close_time": "19:00"
    },
    {
      "id": "ec_d1f8af561983e48c5ed0969b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "day": "WED",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_065db833fd8c407dfb0ef319",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "day": "THU",
      "open_time": "09:30",
      "close_time": "19:00"
    },
    {
      "id": "ec_31820f9a694f6973535522e4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "day": "FRI",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_7e37cfcc1ab08fd3f070b734",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_bd6f18113e3a7550157cadd8",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "rating": "5",
      "name": "Cameron Craig",
      "text": "I have had a great experience living here. The building is well maintained and the amenities are great.\n\nThe leasing office deserves a special shoutout. Everyone is friendly, responsive, and always willing to help whenever questions or issues come up. It is clear that the management team genuinely cares about the residents and puts a lot of effort into building a sense of community. The monthly resident events are always well organized and are a great way to meet neighbors and make living here even more enjoyable.",
      "date": "2026-07-31",
      "title": "false"
    },
    {
      "id": "ec_12682f6e2a761ae121a3e2d2",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "rating": "5",
      "name": "Nic",
      "text": "I can’t say enough good things about Sky on Main. Ever since I applied, it has been a fantastic experience! The staff (Stacy, Tonia, and Rachel) have all been friendly (including Marlin and the other 24/7 security guards), the apartments are bright and spacious, maintenance is prompt and helpful, amenities are convenient and always improving, and the urban views are breathtaking!\n\nBut on top of all that, Sky on Main has a community to it. The staff goes out of their way to organize fun weekly drink + snack events (“Friday Night Flights”), there are monthly adult beverage + food events (with Stacy and Rachel serving incredible spreads), and there is a welcoming atmosphere that invites any residents who care to mingle to do so. It has put Sky on Main head and shoulders above any other urban living experience I’ve had.",
      "date": "2025-03-24",
      "title": "false"
    },
    {
      "id": "ec_25cdfcc0739dd0c327f7346f",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "rating": "5",
      "name": "Mike M",
      "text": "I enjoyed my stay at the Sky property! I rented a room through Airbnb. For a small fee I had access to their private garage, and the place was safe and secure. Only way in was with keycards. A lot of places to eat and explore are all within walking distance and the tram is right in front as well if you wanna ride that. On one of the days we were there we saw some guy peering through one of the doors trying to get in but couldn’t thanks to their security door systems. I ended up going through another entrance totally safe. Security was super kind and helpful in directing us and showing us how to get around in the building. The host was also very kind and helpful! The room was beautiful and THE VIEW was amazing! I definitely recommend staying here if you can! Thank you for the hospitality Francis!",
      "date": "2025-09-02",
      "title": "false"
    },
    {
      "id": "ec_4fc84897d40e29f9cc38a418",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "rating": "5",
      "name": "Alexandra Estes",
      "text": "I toured multiple apartment complexes before deciding to go with Sky on Main. After living here for a little over six months now, I'm SO happy with my decision and absolutely love living here! Here's why:\n\nI looked at multiple complexes downtown, in the crossroads, and in the plaza area. Everywhere I looked had nice units, ammenities, and advertised security. However, reading through reviews told a different story. It was hard to remain optimistic about my options, and I tried to remind myself that people typically only write reviews when they're upset.\n\nThings changed when I finally toured Sky on Main. The units and ammenities seemed great, but the security really sold me. There is someone working at the security desk 24/7, and there is no way to enter the building without a key. There are multiple key checkpoints too (one for the entrance, to call the elevator, to get to the residential floors, and then the code to your unit). The parking garage is also fully enclosed, requiring a key to use either the pedestrian or garage doors - knock on wood, but I haven't had any issues with my car or personal safety as a young woman so far.\n\nSince I've been living here, the staff has really stood out to me too. I needed to move here for work ASAP, and management was extremely patient with me and helped me get into a unit when I needed it. They also put on different events throughout the month, these can range anywhere from a pop-up market, happy hour, friendsgivng dinner, yoga class, etc. Attending these events doesn't cost any money, and I love the creativity and effort that they put into making these happen. I've really enjoyed going out of my comfort zone once in awhile and trying something I've never done before.\n\nAlong with the Sky on Main team and security, the units and location are great - but you probably knew that already ;). I plan on renewing my lease when the time comes!",
      "date": "2025-12-11",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_488106b7929822c710707721",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b662-7ea0-72aa-b294-5d0a4f34f939.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b662-7ea0-72aa-b294-5d0a4f34f939",
        "storage_key": "property/6767906449167610/01a0b662-7ea0-72aa-b294-5d0a4f34f939.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "B2",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=e5ENZ3iTBZp"
    },
    {
      "id": "ec_1d53a4e5c4244696028ac82c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b662-832b-72ff-a6a4-dad692f18521.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b662-832b-72ff-a6a4-dad692f18521",
        "storage_key": "property/6767906449167610/01a0b662-832b-72ff-a6a4-dad692f18521.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "B",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=eSngVdmxidt"
    },
    {
      "id": "ec_4426de661884397b43eb4c30",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "2-bedroom apartment at Sky on Main in Downtown Kansas City.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b662-7c0b-77fe-a473-4a085647ca7c.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b662-7c0b-77fe-a473-4a085647ca7c",
        "storage_key": "property/6767906449167610/01a0b662-7c0b-77fe-a473-4a085647ca7c.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "B4",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=Fomrm3ZtWwF"
    },
    {
      "id": "ec_82a42e92f241c87474dc3052",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b662-79cb-70b8-8907-6a826858017f.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b662-79cb-70b8-8907-6a826858017f",
        "storage_key": "property/6767906449167610/01a0b662-79cb-70b8-8907-6a826858017f.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "B5 - Den",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=M5LGgi7TmtZ"
    },
    {
      "id": "ec_177b0b0ab99e14ca7939f12d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b662-7f77-7424-aa5c-73d612f116df.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b662-7f77-7424-aa5c-73d612f116df",
        "storage_key": "property/6767906449167610/01a0b662-7f77-7424-aa5c-73d612f116df.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "A2",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=JShAto7VSC4"
    },
    {
      "id": "ec_e14fd9287adb2cfe37b7794e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "View Phase 1 and Phase 2 Difference.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b662-8c72-70fc-93d9-95ed2c071cde.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b662-8c72-70fc-93d9-95ed2c071cde",
        "storage_key": "property/6767906449167610/01a0b662-8c72-70fc-93d9-95ed2c071cde.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "A1",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=uUGTX5sGq2H"
    },
    {
      "id": "ec_38e4e8c81e6d1cb7c67f638d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b662-a737-7059-b95d-f67bd6768387.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b662-a737-7059-b95d-f67bd6768387",
        "storage_key": "property/6767906449167610/01a0b662-a737-7059-b95d-f67bd6768387.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "B3 - Den",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=W1HoskAbvkD"
    },
    {
      "id": "ec_578075a925c25e64f7edf790",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "1-bedroom apartment at Sky on Main in Downtown Kansas City.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b662-9408-75fa-826e-916b5c31944d.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b662-9408-75fa-826e-916b5c31944d",
        "storage_key": "property/6767906449167610/01a0b662-9408-75fa-826e-916b5c31944d.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "A207",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=8NVR99R4V2H"
    },
    {
      "id": "ec_1ff706ba5d9ec36fcb8d2fce",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "1-bedroom apartment at Sky on Main in Downtown Kansas City.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b662-8fb9-74c1-ab48-e556c9dfb5b8.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b662-8fb9-74c1-ab48-e556c9dfb5b8",
        "storage_key": "property/6767906449167610/01a0b662-8fb9-74c1-ab48-e556c9dfb5b8.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "A208",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=Zhc62QnRr7f"
    },
    {
      "id": "ec_608bfbeb58dcca8f434fc209",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "1-bedroom apartment at Sky on Main in Downtown Kansas City.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b662-b9dc-7313-b0c3-94cdd3323cdd.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b662-b9dc-7313-b0c3-94cdd3323cdd",
        "storage_key": "property/6767906449167610/01a0b662-b9dc-7313-b0c3-94cdd3323cdd.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "A211",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=tifRZK2nqr4"
    },
    {
      "id": "ec_ff21d8c789e77320f40e8114",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "1-bedroom apartment at Sky on Main in Downtown Kansas City.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b662-95e1-7549-b3ed-f0fc9d33de7c.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b662-95e1-7549-b3ed-f0fc9d33de7c",
        "storage_key": "property/6767906449167610/01a0b662-95e1-7549-b3ed-f0fc9d33de7c.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "A414",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=F25QYRa6PwN"
    }
  ],
  "faqs": [
    {
      "id": "custom_94e18837-7eda-4597-8c86-ec5a06f45db5",
      "question": "What utilities am I responsible to pay?",
      "answer": "Our residents are responsible to pay for water, trash, and electric.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_0411026e-7a31-4d5e-91b4-cd5b642ecc37",
      "question": "If something needs to be repaired in my apartment, how do I report it?",
      "answer": "You may call the office or submit work orders online by accessing your <a href=\"/resident-access\">resident account</a>. All emergency repairs should be reported by <a href=\"/contact-us\">contacting the office</a>. If the emergency is being reported after business hours, please follow the prompts to be connected to the answering service.",
      "category": "Maintenance",
      "source": "custom"
    },
    {
      "id": "custom_e6cdc736-089d-4b45-975f-3a49780d21c4",
      "question": "What is the application fee and is it refundable?",
      "answer": "Application fees are $50 per person 18 and older occupying the apartment. You may pay this fee online by credit card. All application fees are nonrefundable.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_8aaf9275-d882-4b8c-a117-92c63aaa3be2",
      "question": "What information do I need to apply for an apartment?",
      "answer": "Please review our <a href=\"https://www.pricebrotherskc.com/ResidentialRentalQualifications/\">Qualifications for Occupancy</a>.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_536b5a1b-da94-4506-8309-3b50032035e4",
      "question": "How do I apply?",
      "answer": "Click on the <a href=\"/apply-now\">Apply Now</a> button under the <a href=\"/floor-plans\">Floor Plans</a> tab of our community website.",
      "category": "General",
      "source": "custom"
    },
    {
      "id": "custom_5efdc31e-4cac-45a3-b869-a06301de79d5",
      "question": "What is a holding deposit or earnest money?",
      "answer": "A \"holding\" deposit or \"earnest money\" is another word for \"security\" deposit. Please <a href=\"/contact-us\">contact our leasing office</a> for more details.",
      "category": "General",
      "source": "custom"
    },
    {
      "id": "custom_88c3db02-5afc-46e8-b1fa-8a96cf95141d",
      "question": "Do you offer a lease term less than 12 months?",
      "answer": "We do offer shorter lease terms. Please <a href=\"/contact-us\">contact our office</a> for more information.",
      "category": "General",
      "source": "custom"
    },
    {
      "id": "custom_9eb3f2d3-33ca-44b8-a6d8-537a3bb800f9",
      "question": "Do I need an appointment to take a tour?",
      "answer": "No appointment is necessary to tour our community during business hours; however, it is always appreciated if you call ahead to make sure we are available to provide adequate time for you to tour and ask questions. It is recommended to arrive no later than one half hour prior to closing if you would like to tour the community. Everyone over 18 years of age must have a valid photo ID to tour. Valid forms of identification are decided by Price Brothers Management Company and may include items such as: US Driver’s License, US State Photo ID, US Military Photo ID, US Visa with Photo ID upon it, US Citizenship and Immigration Services Photo ID, Passport.",
      "category": "General",
      "source": "custom"
    },
    {
      "id": "custom_d45eced5-78f4-4048-af38-ddcbfffd8e58",
      "question": "Do you allow pets?",
      "answer": "Our community is happy to accept cats and dogs. Please refer to our <a href=\"/pet-policy\">Pet Policy</a> page.",
      "category": "General",
      "source": "custom"
    },
    {
      "id": "custom_e5639e70-bb96-490a-8fc9-0c20571d32bd",
      "question": "Do you offer covered parking?",
      "answer": "Yes, we offer a parking garage that includes 1 assigned space for 1 bedroom apartment homes and 2 assigned spaces for 2 bedroom apartment homes. Additional garage parking spaces may be available for rent. Please <a href=\"/contact-us\">contact the office</a> for our most current availability and pricing.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_90d3bb66-4829-46cb-a4be-9fb407be3661",
      "question": "Why does your pricing include ranges?",
      "answer": "The prices will range on each floor plan depending on finishes, views, and other features inside the apartment home.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_22fa219c-0503-4bf1-b177-7020be969864",
      "question": "Do you require renters insurance?",
      "answer": "Renters insurance is required. Our requirements are as follows: $100,000 in personal liability, $500 in medical and we encourage personal property coverage to protect you in the event of a disaster. You can easily sign up for a policy from our recommended insurance provider at <a href=\"https://www.residentshield.com/\">www.ResidentShield.com</a>.",
      "category": "General",
      "source": "custom"
    },
    {
      "id": "custom_6bb2de38-efa6-42e1-a03e-551408aa221b",
      "question": "Do you host events at your property?",
      "answer": "Yes, we host events throughout the year with various activities to encourage community camaraderie.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_e28bbf01-34dc-4c10-bacc-abd6e46cff9e",
      "question": "How can I refer a friend?",
      "answer": "If you love living here and want to refer a friend, please let our office know! We offer resident referral programs throughout the year and would love for your friends and family to join our community.",
      "category": "General",
      "source": "custom"
    },
    {
      "id": "custom_817d62f0-6b83-4151-8306-79acd624f8f4",
      "question": "How can I pay my rent?",
      "answer": "You can pay rent by accessing your <a href=\"/resident-access\">resident online account</a>. This allows you to use a bank account or credit card to make payments.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_036840ee-6c31-41c7-8add-d189ce4aa836",
      "question": "Do you accept packages on behalf of the residents?",
      "answer": "Yes, if you are not home to accept a package it can be left at the clubhouse for you to pick up. We please ask that you pick it up as soon as possible to prevent overcrowding.",
      "category": "Amenities",
      "source": "custom"
    }
  ],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "01a0c9ac-4591-7335-87a9-6897aec3c9ea",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Sky on Main Property Website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610"
    },
    {
      "lead_collector_id": "01a0c9ac-4627-759f-9dd0-10d5ba85465d",
      "lead_source": "LANDING_PAGE",
      "name": "Sky on Main Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "generator",
      "page_item_url": "in-unit-laundry-apartments-kansas-city-mo-sky-on-main",
      "search_query": "in-unit laundry apartments kansas city mo",
      "category": "Amenity",
      "h1_title": "In-Unit Laundry Apartments in Kansas City, MO",
      "h2_subtitle": "Discover in-unit laundry apartments in the heart of Kansas City, MO. Experience luxury living with modern amenities and breathtaking views.",
      "page_copy": "Experience the convenience and luxury of in-unit laundry apartments at Sky on Main, located in the vibrant Library District of Kansas City, MO. This reimagined historic high-rise offers spacious one- and two-bedroom apartments equipped with modern amenities, including floor-to-ceiling windows and quartz islands. Select homes provide stunning skyline, river, and Power & Light views, making urban living a truly elevated experience.\n\nBeyond in-home laundry, residents benefit from a community with planned social events, flat-rate utilities, and Wi-Fi access. Sky on Main also features prime retail and restaurant spaces, ensuring that dining and shopping experiences are just steps away. Join a thriving community in a city full of opportunity, where comfort and convenience meet elegance and style.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167610/019fc987-a24d-753a-8d4f-d27b460b24d5.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a downtown city street with tall buildings and a parking garage.",
        "public_id": "019fc987-a24d-753a-8d4f-d27b460b24d5",
        "storage_key": "property/6767906449167610/019fc987-a24d-753a-8d4f-d27b460b24d5.webp",
        "width": 3072,
        "height": 2304
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-Unit Laundry Apartments in Kansas City, MO",
      "seo_description": "Explore in-unit laundry apartments at Sky on Main in Kansas City, MO. Enjoy skyline views, modern amenities, and a prime location in the Library District.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "generator",
      "page_item_url": "air-conditioned-luxury-apartments-64105-sky-on-main",
      "search_query": "air conditioned luxury apartments 64105",
      "category": "Amenity",
      "h1_title": "Air Conditioned Luxury Apartments in 64105",
      "h2_subtitle": "Explore air conditioned luxury apartments located in the bustling 64105 area. Enjoy comfort and style at Sky on Main in downtown Kansas City.",
      "page_copy": "Sky on Main offers air conditioned luxury apartments in the heart of the 64105 area, elevating downtown living to new heights. Nestled within Kansas City's historic Library District, these one- and two-bedroom apartments combine modern elegance with timeless design. Floor-to-ceiling windows, quartz islands, and in-home laundry provide a lavish yet practical lifestyle.\n\nResidents can embrace a vibrant community atmosphere with planned social events and enjoy the convenience of flat-rate utilities and complimentary Wi-Fi. With retail and restaurant spaces onsite, your dining and shopping needs are mere steps away. Enjoy spectacular views of the skyline, river, and Power & Light while living in ultimate comfort and style at Sky on Main.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167610/019fc987-a24d-753a-8d4f-d27b460b24d5.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a downtown city street with tall buildings and a parking garage.",
        "public_id": "019fc987-a24d-753a-8d4f-d27b460b24d5",
        "storage_key": "property/6767906449167610/019fc987-a24d-753a-8d4f-d27b460b24d5.webp",
        "width": 3072,
        "height": 2304
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Luxury Apartments in 64105",
      "seo_description": "Discover air conditioned luxury apartments at Sky on Main in Kansas City's 64105 area. Enjoy comfort, style, and stunning views in the Library District.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "generator",
      "page_item_url": "downtown-kansas-city-apartments-quartz-countertops-sky-on-main",
      "search_query": "downtown kansas city apartments with quartz countertops",
      "category": "Amenity",
      "h1_title": "Downtown KC Apartments with Quartz Countertops",
      "h2_subtitle": "Find stunning downtown Kansas City apartments featuring quartz countertops at Sky on Main. Embrace luxury and modernity in a historic setting.",
      "page_copy": "Located in the heart of downtown Kansas City, Sky on Main boasts luxurious apartments equipped with elegant quartz countertops. Situated in the vibrant Library District, this historic high-rise offers reimagined spaces that blend modern comfort with historic charm. The one- and two-bedroom apartments feature floor-to-ceiling windows, offering breathtaking views of the skyline, river, and Power & Light district.\n\nResidents benefit from a host of community features, including planned social events, flat-rate utilities, and Wi-Fi access. With prime retail and restaurant spaces available onsite, everything you need is right at your fingertips. Experience the perfect mix of convenience, style, and comfort in these exquisite downtown Kansas City apartments at Sky on Main.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167610/019fc987-a24d-753a-8d4f-d27b460b24d5.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a downtown city street with tall buildings and a parking garage.",
        "public_id": "019fc987-a24d-753a-8d4f-d27b460b24d5",
        "storage_key": "property/6767906449167610/019fc987-a24d-753a-8d4f-d27b460b24d5.webp",
        "width": 3072,
        "height": 2304
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Downtown KC Apartments with Quartz Countertops",
      "seo_description": "Discover downtown Kansas City apartments at Sky on Main featuring quartz countertops. Luxury living in the historic Library District awaits you.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "generator",
      "page_item_url": "floor-to-ceiling-windows-apartments-library-district-sky-on-main",
      "search_query": "floor-to-ceiling windows apartments library district",
      "category": "Amenity",
      "h1_title": "Library District Apartments with Floor-to-Ceiling Windows",
      "h2_subtitle": "Explore Library District apartments featuring floor-to-ceiling windows. Sky on Main offers breathtaking views and modern living spaces.",
      "page_copy": "Nestled in Kansas City's vibrant Library District, Sky on Main features distinctive apartments that boast stunning floor-to-ceiling windows. These modern one- and two-bedroom homes offer expansive views of the city's iconic skyline, the river, and the Power & Light district, creating an open and airy atmosphere that truly enhances urban living. Experience the perfect blend of historical charm and contemporary elegance in this reimagined high-rise.\n\nSky on Main prides itself on offering residents a vibrant community life, complete with planned social events and onsite amenities such as Wi-Fi. Enjoy the convenience of flat-rate utilities and dive into the vibrant local scene with prime retail and restaurant spaces at your doorstep. Experience a lifestyle where spectacular views meet modern convenience in the heart of the Library District.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167610/019fc987-a24d-753a-8d4f-d27b460b24d5.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a downtown city street with tall buildings and a parking garage.",
        "public_id": "019fc987-a24d-753a-8d4f-d27b460b24d5",
        "storage_key": "property/6767906449167610/019fc987-a24d-753a-8d4f-d27b460b24d5.webp",
        "width": 3072,
        "height": 2304
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Library District Apartments with Floor-to-Ceiling Windows",
      "seo_description": "Discover Sky on Main's Library District apartments with floor-to-ceiling windows. Enjoy stunning views and modern designs in downtown Kansas City.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "generator",
      "page_item_url": "historic-building-modern-amenities-apartments-jackson-county-sky-on-main",
      "search_query": "historic building apartments with modern amenities jackson county",
      "category": "Amenity",
      "h1_title": "Historic Apartments with Modern Amenities in Jackson",
      "h2_subtitle": "Explore historic building apartments with modern amenities in Jackson County at Sky on Main. Enjoy a unique blend of charm and convenience.",
      "page_copy": "Sky on Main offers residents the perfect blend of historic charm and modern amenities in Jackson County. Set in a beautifully reimagined historic high-rise, these one- and two-bedroom apartments in Kansas City's Library District feature contemporary comforts such as floor-to-ceiling windows, quartz islands, and in-home laundry. The seamless integration of old-world elegance and new-world luxury defines the living experience here.\n\nIn addition to the stunning interiors, residents enjoy community features like planned social events and Wi-Fi. With flat-rate utilities simplifying your lifestyle and prime retail and restaurant spaces nearby, Sky on Main redefines convenience. Enjoy living in a part of history, beautifully updated with all the modern amenities needed for today's dynamic lifestyle in the heart of downtown Kansas City.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167610/019fc987-a24d-753a-8d4f-d27b460b24d5.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a downtown city street with tall buildings and a parking garage.",
        "public_id": "019fc987-a24d-753a-8d4f-d27b460b24d5",
        "storage_key": "property/6767906449167610/019fc987-a24d-753a-8d4f-d27b460b24d5.webp",
        "width": 3072,
        "height": 2304
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Historic Apartments, Modern Amenities in Jackson",
      "seo_description": "Discover historic building apartments with modern amenities in Jackson County at Sky on Main. Experience charm and convenience in Kansas City.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-kansas-city-mo-sky-on-main",
      "search_query": "one bedroom apartments kansas city mo",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Kansas City, MO",
      "h2_subtitle": "Discover elegant one bedroom apartments in Kansas City, MO. Sky on Main offers modern living spaces with stunning city views.",
      "page_copy": "Experience the ultimate in urban living at Sky on Main, where one bedroom apartments in Kansas City, MO offer a perfect mix of style and convenience. Located in the historic Library District, these exquisitely designed homes feature modern amenities such as floor-to-ceiling windows that flood the space with natural light, and stylish quartz countertops that enhance the contemporary kitchen decor.\n\nResidents of Sky on Main enjoy a vibrant and active community life with access to planned social events and convenient amenities like Wi-Fi. With flat-rate utilities, life here is stress-free and enjoyable. The surrounding neighborhood offers a dynamic local scene with prime retail and dining options right at your doorstep. Discover the best of Kansas City living in these beautifully appointed one bedroom apartments at Sky on Main.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167610/019fc987-a24d-753a-8d4f-d27b460b24d5.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a downtown city street with tall buildings and a parking garage.",
        "public_id": "019fc987-a24d-753a-8d4f-d27b460b24d5",
        "storage_key": "property/6767906449167610/019fc987-a24d-753a-8d4f-d27b460b24d5.webp",
        "width": 3072,
        "height": 2304
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Kansas City, MO",
      "seo_description": "Find one bedroom apartments in Kansas City, MO at Sky on Main. Enjoy modern amenities and stunning views in the historic Library District.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-library-district-sky-on-main",
      "search_query": "two bedroom apartments in the library district",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in the Library District",
      "h2_subtitle": "Discover spacious two bedroom apartments in the Library District. Sky on Main offers a blend of historic charm and modern living.",
      "page_copy": "At Sky on Main, two bedroom apartments in the Library District offer a distinctive living experience with a combination of history and modernity. These beautifully designed spaces feature expansive floor-to-ceiling windows that provide breathtaking views of Kansas City's unique skyline, bringing an abundance of natural light into each apartment. The interiors are complemented by modern touches like quartz islands in the kitchen and in-home laundry facilities, ensuring both comfort and style.\n\nResidents at Sky on Main are part of a vibrant community that enjoys planned social events and amenities such as Wi-Fi readily available. The convenience of flat-rate utilities adds ease to everyday living, while the prime retail and restaurant spaces in the neighborhood offer countless opportunities for entertainment and dining. Live in a two bedroom sanctuary that's both historic and comfortably modern in the heart of the Library District.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167610/019fc987-a24d-753a-8d4f-d27b460b24d5.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a downtown city street with tall buildings and a parking garage.",
        "public_id": "019fc987-a24d-753a-8d4f-d27b460b24d5",
        "storage_key": "property/6767906449167610/019fc987-a24d-753a-8d4f-d27b460b24d5.webp",
        "width": 3072,
        "height": 2304
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in the Library District",
      "seo_description": "Explore two bedroom apartments in the Library District at Sky on Main. Enjoy historic charm and modern amenities in Kansas City's vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "generator",
      "page_item_url": "apartments-near-crossroads-charter-schools-kansas-city-sky-on-main",
      "search_query": "apartments near crossroads charter schools kansas city",
      "category": "School",
      "h1_title": "Apartments Near Crossroads Charter Schools KC",
      "h2_subtitle": "Find exceptional apartments near Crossroads Charter Schools, Kansas City. Enjoy modern living in a historic setting at Sky on Main.",
      "page_copy": "Sky on Main offers beautiful apartments conveniently located near Crossroads Charter Schools in Kansas City, providing an ideal home for those seeking quality education nearby. These modern one- and two-bedroom apartments are situated in the historic Library District, offering both expansive city views and contemporary interiors, perfect for urban dwellers who appreciate a vibrant community.\n\nResidents enjoy the benefits of flat-rate utilities, planned social events, and seamless connectivity with available Wi-Fi. With retail and dining options just steps away, Sky on Main is more than an apartment—it's a lifestyle. Experience the best of city living combined with educational opportunities right at your doorstep when you choose Sky on Main near Crossroads Charter Schools.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167610/019fc987-a24d-753a-8d4f-d27b460b24d5.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a downtown city street with tall buildings and a parking garage.",
        "public_id": "019fc987-a24d-753a-8d4f-d27b460b24d5",
        "storage_key": "property/6767906449167610/019fc987-a24d-753a-8d4f-d27b460b24d5.webp",
        "width": 3072,
        "height": 2304
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Crossroads Charter Schools KC",
      "seo_description": "Discover apartments near Crossroads Charter Schools in Kansas City at Sky on Main. Enjoy modern conveniences in a historic high-rise.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "generator",
      "page_item_url": "apartments-close-to-crossroads-academy-quality-hill-kansas-city-sky-on-main",
      "search_query": "apartments close to crossroads academy quality hill kansas city",
      "category": "School",
      "h1_title": "Apartments Close to Crossroads Academy Quality Hill KC",
      "h2_subtitle": "Explore apartments close to Crossroads Academy in Quality Hill, Kansas City. Sky on Main combines historic elegance with modern features.",
      "page_copy": "Sky on Main offers stunning apartment options close to Crossroads Academy Quality Hill in Kansas City, perfect for those who value proximity to quality education and city amenities. Nestled in the historic Library District, these one- and two-bedroom residences feature open layouts with floor-to-ceiling windows, inviting plenty of natural light and offering splendid views of the Kansas City skyline.\n\nWith amenities such as planned social activities and convenient Wi-Fi, residents are part of an engaging community. Simplified living is ensured through flat-rate utilities, and the nearby retail and restaurants add a layer of convenience and entertainment. Experience a blend of historic charm and modern luxury when you choose Sky on Main, just a short distance from Crossroads Academy Quality Hill.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167610/019fc987-a24d-753a-8d4f-d27b460b24d5.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a downtown city street with tall buildings and a parking garage.",
        "public_id": "019fc987-a24d-753a-8d4f-d27b460b24d5",
        "storage_key": "property/6767906449167610/019fc987-a24d-753a-8d4f-d27b460b24d5.webp",
        "width": 3072,
        "height": 2304
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Crossroads Academy Quality Hill KC",
      "seo_description": "Find apartments near Crossroads Academy Quality Hill, Kansas City at Sky on Main. Enjoy stylish living in the historic Library District.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "generator",
      "page_item_url": "find-apartments-by-crossroads-preparatory-academy-jackson-county-sky-on-main",
      "search_query": "find apartments by crossroads preparatory academy jackson county",
      "category": "School",
      "h1_title": "Find Apartments by Crossroads Preparatory Academy",
      "h2_subtitle": "Discover ideal apartments near Crossroads Preparatory Academy in Jackson County. Sky on Main offers luxury with history in Kansas City.",
      "page_copy": "For those looking to find apartments by Crossroads Preparatory Academy in Jackson County, Sky on Main presents an unparalleled option. Situated in the historic Library District of Kansas City, this high-rise offers both one- and two-bedroom apartments featuring modern amenities like in-home laundry, quartz kitchen islands, and expansive floor-to-ceiling windows that frame scenic city and river views.\n\nAs a resident, you will appreciate the ease of flat-rate utilities and the vibrant community fostered by regular social events. With convenient access to retail and dining spaces, our location combines comfort with the excitement of urban living. Sky on Main is not only close to Crossroads Preparatory Academy but also centers you in a dynamic environment where history and modern convenience meet.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167610/019fc987-a24d-753a-8d4f-d27b460b24d5.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a downtown city street with tall buildings and a parking garage.",
        "public_id": "019fc987-a24d-753a-8d4f-d27b460b24d5",
        "storage_key": "property/6767906449167610/019fc987-a24d-753a-8d4f-d27b460b24d5.webp",
        "width": 3072,
        "height": 2304
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Find Apartments by Crossroads Preparatory Academy",
      "seo_description": "Explore apartments near Crossroads Preparatory Academy, Jackson County at Sky on Main. Enjoy historic charm with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "generator",
      "page_item_url": "apartments-near-primitivo-garcia-elementary-school-library-district-sky-on-main",
      "search_query": "apartments near primitivo garcia elementary school library district",
      "category": "School",
      "h1_title": "Apartments Near Primitivo Garcia Elementary School",
      "h2_subtitle": "Discover ideal living accommodations near Primitivo Garcia Elementary School in the Library District at Sky on Main.",
      "page_copy": "For families searching for apartments near Primitivo Garcia Elementary School, Sky on Main offers the perfect blend of convenience and comfort in the Library District of Kansas City. These elegant one- and two-bedroom homes feature modern amenities such as quartz kitchen islands and in-home laundry, all set within a reimagined historic high-rise.\n\nResidents enjoy access to flat-rate utilities, Wi-Fi, and a host of community events, fostering a vibrant neighborhood atmosphere. With prime retail and dining options just moments away, Sky on Main provides a lifestyle that caters to both families and professionals in a unique urban setting. Choose Sky on Main for its proximity to Primitivo Garcia Elementary School and experience elevated downtown living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167610/019fc987-a24d-753a-8d4f-d27b460b24d5.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a downtown city street with tall buildings and a parking garage.",
        "public_id": "019fc987-a24d-753a-8d4f-d27b460b24d5",
        "storage_key": "property/6767906449167610/019fc987-a24d-753a-8d4f-d27b460b24d5.webp",
        "width": 3072,
        "height": 2304
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Primitivo Garcia Elementary School",
      "seo_description": "Find apartments near Primitivo Garcia Elementary School in the Library District at Sky on Main. Enjoy downtown luxury in a historic setting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "generator",
      "page_item_url": "apartments-close-to-northeast-middle-school-64105-sky-on-main",
      "search_query": "apartments close to northeast middle school 64105",
      "category": "School",
      "h1_title": "Apartments Close to Northeast Middle School 64105",
      "h2_subtitle": "Find perfect apartments close to Northeast Middle School in the 64105 area. Discover luxury living at Sky on Main today.",
      "page_copy": "Looking for apartments close to Northeast Middle School in the vibrant 64105 area? Sky on Main in the bustling Library District offers an ideal solution. Our one- and two-bedroom apartments provide spacious layouts with floor-to-ceiling windows that capture stunning cityscapes, while including modern features like quartz kitchen islands and in-home laundry facilities.\n\nSky on Main residents benefit from amenities such as flat-rate utilities, reliable Wi-Fi, and dynamic social events that foster a strong community spirit. The building is also conveniently located near prime retail and diverse dining options, making it a perfect choice for those who want a blend of convenience and luxury. Experience vibrant city living at Sky on Main, mere moments from Northeast Middle School.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167610/019fc987-a24d-753a-8d4f-d27b460b24d5.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a downtown city street with tall buildings and a parking garage.",
        "public_id": "019fc987-a24d-753a-8d4f-d27b460b24d5",
        "storage_key": "property/6767906449167610/019fc987-a24d-753a-8d4f-d27b460b24d5.webp",
        "width": 3072,
        "height": 2304
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Northeast Middle School 64105",
      "seo_description": "Find luxury apartments near Northeast Middle School, 64105 at Sky on Main. Experience modern living with a historic touch.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "generator",
      "page_item_url": "apartments-near-northeast-high-school-kansas-city-mo-sky-on-main",
      "search_query": "apartments near northeast high school kansas city mo",
      "category": "School",
      "h1_title": "Apartments Near Northeast High School Kansas City",
      "h2_subtitle": "Discover convenient apartments near Northeast High School, Kansas City, MO. Live luxuriously at Sky on Main in the Library District.",
      "page_copy": "Located in the heart of Kansas City, MO, Sky on Main offers exceptional apartments near Northeast High School. Our historic high-rise in the Library District boasts beautifully remodeled one- and two-bedroom units featuring open layouts, modern amenities like quartz islands, and in-home laundry facilities, all with stunning views of the city skyline and river.\n\nResidents enjoy comfortable living with amenities such as flat-rate utilities, Wi-Fi, and an active social calendar that keeps our community vibrant. With access to prime retail and dining just steps away, Sky on Main serves as an ideal residence for those seeking luxury and convenience in their new home. Choose Sky on Main for easy commutes and a thriving downtown lifestyle near Northeast High School.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167610/019fc987-a24d-753a-8d4f-d27b460b24d5.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a downtown city street with tall buildings and a parking garage.",
        "public_id": "019fc987-a24d-753a-8d4f-d27b460b24d5",
        "storage_key": "property/6767906449167610/019fc987-a24d-753a-8d4f-d27b460b24d5.webp",
        "width": 3072,
        "height": 2304
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Northeast High School Kansas City",
      "seo_description": "Explore luxurious living near Northeast High School, Kansas City, MO at Sky on Main. Experience comfort in the vibrant Library District.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "generator",
      "page_item_url": "apartments-near-park-university-kansas-city-sky-on-main",
      "search_query": "apartments near park university kansas city",
      "category": "School",
      "h1_title": "Apartments Near Park University Kansas City",
      "h2_subtitle": "Experience upscale living near Park University, Kansas City. Sky on Main offers premium accommodations just a short commute away.",
      "page_copy": "Sky on Main presents a remarkable opportunity for students and professionals seeking apartments near Park University in Kansas City. Nestled in the lively Library District, this reimagined historic high-rise offers one- and two-bedroom apartments complete with modern comforts like quartz kitchen islands, floor-to-ceiling windows, and the convenience of in-home laundry.\n\nOur residents enjoy flat-rate utilities, dependable Wi-Fi, and engaging social events that create a vibrant community atmosphere. The prime retail and dining experiences right outside your door make Sky on Main a wonderful choice for those who want a seamless blend of luxury living and proximity to Park University. Enjoy the ease of downtown while staying close to academic pursuits.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167610/019fc987-a24d-753a-8d4f-d27b460b24d5.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a downtown city street with tall buildings and a parking garage.",
        "public_id": "019fc987-a24d-753a-8d4f-d27b460b24d5",
        "storage_key": "property/6767906449167610/019fc987-a24d-753a-8d4f-d27b460b24d5.webp",
        "width": 3072,
        "height": 2304
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Park University Kansas City",
      "seo_description": "Find luxury apartments near Park University in Kansas City at Sky on Main. Enjoy modern urban living in the historic Library District.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "generator",
      "page_item_url": "apartments-near-university-health-truman-medical-center-kansas-city-sky-on-main",
      "search_query": "apartments near university health truman medical center kansas city",
      "category": "Hospital",
      "h1_title": "Apartments Near University Health Truman Medical",
      "h2_subtitle": "Discover urban apartments near University Health Truman Medical Center in Kansas City. Enjoy Sky on Main's modern amenities and prime location.",
      "page_copy": "Sky on Main offers exceptional living options for those seeking apartments near University Health Truman Medical Center in Kansas City. Located in the vibrant Library District, this beautifully restored historic high-rise hosts spacious one- and two-bedroom apartments featuring expansive city views, quartz-topped kitchen islands, and in-home laundry.\n\nResidents at Sky on Main appreciate the convenience of flat-rate utilities and high-speed Wi-Fi, alongside scheduled social activities that create a lively community vibe. The property's prime location ensures easy access to local retail and dining, making it an ideal choice for healthcare professionals looking to live close to University Health Truman Medical Center while enjoying the benefits of an upscale downtown lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167610/019fc987-a24d-753a-8d4f-d27b460b24d5.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a downtown city street with tall buildings and a parking garage.",
        "public_id": "019fc987-a24d-753a-8d4f-d27b460b24d5",
        "storage_key": "property/6767906449167610/019fc987-a24d-753a-8d4f-d27b460b24d5.webp",
        "width": 3072,
        "height": 2304
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near University Health Truman Medical",
      "seo_description": "Find luxury apartments near University Health Truman Medical Center, Kansas City at Sky on Main. Enjoy modern comforts and prime downtown location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "generator",
      "page_item_url": "apartments-close-to-childrens-mercy-adele-hall-campus-64105-sky-on-main",
      "search_query": "apartments close to children's mercy adele hall campus 64105",
      "category": "Hospital",
      "h1_title": "Apartments Near Children's Mercy Adele Hall",
      "h2_subtitle": "Find stylish apartments close to Children's Mercy Adele Hall Campus in Kansas City’s 64105. Experience the elegance of Sky on Main.",
      "page_copy": "Situated in Kansas City's dynamic Library District, Sky on Main offers stunning apartments close to Children's Mercy Adele Hall Campus. This historic high-rise is perfect for professionals and families seeking spacious living, featuring one- and two-bedroom options with open layouts, modern quartz islands, and convenient in-home laundry.\n\nAt Sky on Main, residents benefit from flat-rate utilities, reliable Wi-Fi, and an engaging community through various social activities. The presence of prime retail and dining on site adds convenience for those with busy lifestyles. Enjoy easy commutes and the charm of downtown living while staying close to Children's Mercy Adele Hall Campus in the 64105 area.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167610/019fc987-a24d-753a-8d4f-d27b460b24d5.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a downtown city street with tall buildings and a parking garage.",
        "public_id": "019fc987-a24d-753a-8d4f-d27b460b24d5",
        "storage_key": "property/6767906449167610/019fc987-a24d-753a-8d4f-d27b460b24d5.webp",
        "width": 3072,
        "height": 2304
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Children's Mercy Adele Hall",
      "seo_description": "Explore luxury apartments close to Children's Mercy Adele Hall Campus, Kansas City, at Sky on Main. Enjoy modern living in the heart of 64105.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "generator",
      "page_item_url": "apartments-near-barney-allis-plaza-kansas-city-sky-on-main",
      "search_query": "apartments near Barney Allis Plaza Kansas City",
      "category": "Park",
      "h1_title": "Apartments Near Barney Allis Plaza KC",
      "h2_subtitle": "Explore elegant apartments near Barney Allis Plaza in Kansas City. Sky on Main offers urban living at its finest with modern amenities.",
      "page_copy": "Sky on Main is the ideal home for those seeking apartments near Barney Allis Plaza in Kansas City. Nestled in the vibrant Library District, this classic high-rise perfectly blends historic charm with contemporary conveniences. Our one- and two-bedroom apartments boast open layouts, sleek quartz islands, and provide breathtaking city views through expansive floor-to-ceiling windows.\n\nWith flat-rate utilities, seamless Wi-Fi connectivity, and a calendar full of social events, residents at Sky on Main experience a lively and connected community. The building's location offers accessible shopping and dining options, making it an excellent choice for those who desire luxury living close to Barney Allis Plaza's alluring energy.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167610/019fc987-a24d-753a-8d4f-d27b460b24d5.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a downtown city street with tall buildings and a parking garage.",
        "public_id": "019fc987-a24d-753a-8d4f-d27b460b24d5",
        "storage_key": "property/6767906449167610/019fc987-a24d-753a-8d4f-d27b460b24d5.webp",
        "width": 3072,
        "height": 2304
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Barney Allis Plaza KC",
      "seo_description": "Discover luxury apartments near Barney Allis Plaza, Kansas City. Sky on Main offers modern urban living in a vibrant downtown location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "generator",
      "page_item_url": "sky-on-main-by-berkley-riverfront-kansas-city",
      "search_query": "Sky on Main by Berkley Riverfront",
      "category": "Park",
      "h1_title": "Sky on Main Near Berkley Riverfront",
      "h2_subtitle": "Discover Sky on Main, minutes from Berkley Riverfront. Enjoy upscale Kansas City living in the Library District.",
      "page_copy": "Sky on Main offers a sophisticated urban lifestyle just a short distance from the picturesque Berkley Riverfront. Situated in Kansas City's Library District, this historic high-rise provides elevated one- and two-bedroom apartment options. Each unit overlooks the cityscape through expansive windows, allowing for natural light to complement modern features like quartz kitchen islands and in-home laundry facilities.\n\nResidents love the flat-rate utilities, high-speed Wi-Fi, and community-building social events. Sky on Main’s location is perfect for city dwellers who cherish easy access to outdoor spaces like Berkley Riverfront while enjoying downtown amenities. Indulge in the perfect blend of modern convenience and historic charm in this premier living destination.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167610/019fc987-a24d-753a-8d4f-d27b460b24d5.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a downtown city street with tall buildings and a parking garage.",
        "public_id": "019fc987-a24d-753a-8d4f-d27b460b24d5",
        "storage_key": "property/6767906449167610/019fc987-a24d-753a-8d4f-d27b460b24d5.webp",
        "width": 3072,
        "height": 2304
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Sky on Main Near Berkley Riverfront",
      "seo_description": "Live at Sky on Main, near Kansas City's Berkley Riverfront. Enjoy modern apartments with city views and downtown convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "generator",
      "page_item_url": "city-market-park-apartments-library-district",
      "search_query": "City Market Park apartments Library District",
      "category": "Park",
      "h1_title": "City Market Park Apartments in Library District",
      "h2_subtitle": "Discover apartments near City Market Park in the Library District. Enjoy upscale living at Sky on Main in Kansas City.",
      "page_copy": "Sky on Main offers luxurious living near City Market Park, located in the heart of Kansas City's Library District. Our historic high-rise elegantly combines classic architecture with modern amenities, providing spacious one- and two-bedroom apartments that feature open layouts, quartz countertops, and floor-to-ceiling windows with stunning city views.\n\nResidents enjoy a vibrant community experience thanks to planned social activities, convenient flat-rate utilities, and seamless Wi-Fi. Located near bustling City Market Park, Sky on Main is the perfect home base for enjoying Kansas City's cultural and culinary treasures. Come and explore this unique blend of urban charm and neighborhood convenience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167610/019fc987-a24d-753a-8d4f-d27b460b24d5.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a downtown city street with tall buildings and a parking garage.",
        "public_id": "019fc987-a24d-753a-8d4f-d27b460b24d5",
        "storage_key": "property/6767906449167610/019fc987-a24d-753a-8d4f-d27b460b24d5.webp",
        "width": 3072,
        "height": 2304
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "City Market Park Apartments Library District",
      "seo_description": "Explore Sky on Main, apartments near City Market Park in the Library District, Kansas City. Enjoy modern amenities and community living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "generator",
      "page_item_url": "nearby-mill-creek-park-apartments-jackson-county",
      "search_query": "nearby Mill Creek Park apartments Jackson County",
      "category": "Park",
      "h1_title": "Apartments Near Mill Creek Park, Jackson County",
      "h2_subtitle": "Sky on Main offers premium living near Mill Creek Park in Jackson County. Discover upscale urban apartments in Kansas City's Library District.",
      "page_copy": "For those seeking apartments near Mill Creek Park in Jackson County, Sky on Main presents an excellent option. Situated in the lively Library District, our historic high-rise distinguishes itself with its blend of classic elegance and modern living components. Choose from one- and two-bedroom configurations that offer attractive open floor plans, modern quartz finishes, and expansive windows with outstanding views.\n\nOur residents benefit from planned social events, straightforward flat-rate utility plans, and reliable Wi-Fi service. The property's prime location provides easy access to Mill Creek Park's natural beauty while enjoying the perks of urban convenience and lively cultural scenes in Kansas City. Experience the perfect balance of accessibility and style at Sky on Main.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167610/019fc987-a24d-753a-8d4f-d27b460b24d5.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a downtown city street with tall buildings and a parking garage.",
        "public_id": "019fc987-a24d-753a-8d4f-d27b460b24d5",
        "storage_key": "property/6767906449167610/019fc987-a24d-753a-8d4f-d27b460b24d5.webp",
        "width": 3072,
        "height": 2304
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Mill Creek Park, Jackson County",
      "seo_description": "Find upscale apartments near Mill Creek Park in Jackson County. Sky on Main offers modern living in Kansas City’s vibrant Library District.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167610",
      "source": "generator",
      "page_item_url": "apartments-near-kansas-city-airport-mo",
      "search_query": "apartments near kansas city international airport mo",
      "category": "Transit",
      "h1_title": "Apartments Near Kansas City International Airport",
      "h2_subtitle": "Discover convenient apartments near Kansas City International Airport, MO at Sky on Main, located in the vibrant Library District.",
      "page_copy": "Sky on Main is an ideal choice for those seeking apartments near Kansas City International Airport, MO. Located in the dynamic Library District of Kansas City, our historic high-rise offers a blend of modern luxury and historic charm. Choose from spacious one- and two-bedroom apartments, each featuring open layouts, quartz countertops, floor-to-ceiling windows, and in-home laundry.\n\nOur community fosters a vibrant lifestyle with planned social events, flat-rate utility options, and reliable Wi-Fi. With its strategic location, Sky on Main provides easy access to the airport while being surrounded by the cultural and culinary offerings of downtown Kansas City. Enjoy the perfect mix of convenience and city living at Sky on Main.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167610/019fc987-a24d-753a-8d4f-d27b460b24d5.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a downtown city street with tall buildings and a parking garage.",
        "public_id": "019fc987-a24d-753a-8d4f-d27b460b24d5",
        "storage_key": "property/6767906449167610/019fc987-a24d-753a-8d4f-d27b460b24d5.webp",
        "width": 3072,
        "height": 2304
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Kansas City International Airport",
      "seo_description": "Find modern apartments near Kansas City International Airport, MO. Sky on Main offers luxury living in KC's Library District.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "12701965026"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-TZL7R39R"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Batch 3"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Vantage"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/webchatjs/fb593cb1-c49d-41b4-982a-b12a365bc435/app.js?nocache=1&gaTracking=G-W5SYRVY79W&buttonbgcolor=4698cb&buttontextcolor=ffffff&chatheader=0&embed=false\"></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "39366991189"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/jlw07my4v2y"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "816-597-5430"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IjR1ZnQ4eWpFSWhBUVN3SWtnTFN3ZlE9PSIsInZhbHVlIjoiN3FteEFhT2VyQWZ2OXJmQmUweDNtZz09IiwibWFjIjoiYmU1ZjNkNWUzYWI1YzFiYWYxZTFmNDBhYTZjYjg4NjViZmZmODU1NzMwNDQxMGU4NjMwNGRiZWQ0MTg4OWVjMyJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_repli_id": "12701965026",
  "custom_google_gtm_id": "GTM-TZL7R39R",
  "custom_rollout_phase": "Batch 3",
  "custom_vibesites_theme": "Vantage",
  "custom_ads_subscription": "essential",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/webchatjs/fb593cb1-c49d-41b4-982a-b12a365bc435/app.js?nocache=1&gaTracking=G-W5SYRVY79W&buttonbgcolor=4698cb&buttontextcolor=ffffff&chatheader=0&embed=false\"></script>",
  "custom_seo_subscription": "essential",
  "custom_hubspot_company_id": "39366991189",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/jlw07my4v2y",
  "custom_website_subscription": "turnkey",
  "custom_ppc_tracking_phone_number": "816-597-5430",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IjR1ZnQ4eWpFSWhBUVN3SWtnTFN3ZlE9PSIsInZhbHVlIjoiN3FteEFhT2VyQWZ2OXJmQmUweDNtZz09IiwibWFjIjoiYmU1ZjNkNWUzYWI1YzFiYWYxZTFmNDBhYTZjYjg4NjViZmZmODU1NzMwNDQxMGU4NjMwNGRiZWQ0MTg4OWVjMyJ9",
  "custom_audioeye_site_id": "546c3d57-0a96-46fd-ae1e-1092b11076fa",
  "custom_audioeye_site_hash": "8814dc42c3c4057cd45a3a5dcd094262"
};

export const generatedAt = '2026-11-03T22:58:02.738Z';
